import { devicesTeIn } from '@mangovoice/devices-ui'
import { extensionsTeIn } from '@mangovoice/extensions-ui'
import { hotelsTeIn } from '@mangovoice/hotels-ui'
import { messagingTeIn } from '@mangovoice/messaging-ui'
import { musicOnHoldTeIn } from '@mangovoice/music-on-hold-ui'
import { pbxLocationsTeIn } from '@mangovoice/pbx-locations-ui'
import { pbxSettingsTeIn } from '@mangovoice/pbx-settings-ui'
import { phoneNumbersTeIn } from '@mangovoice/phone-numbers-ui'
import { soundClipsTeIn } from '@mangovoice/soundclips-ui'
import { systemSettingsTeIn } from '@mangovoice/system-settings-ui'
import { userGroupsTeIn } from '@mangovoice/user-groups-ui'
import { webhooksTeIn } from '@mangovoice/webhooks-ui'

import { en } from './en'
import { scheduleTeIn } from './schedule.te_in'

export const te_IN = {
  translation: {
    'Welcome to React': `రియాక్ట్ మరియు రియాక్ట్-ఐ18నెక్స్ట్ కు స్వాగతం`,
    yesterday: `నిన్న`,
    today: `ఈరోజు`,
    hour: `గంట`,
    day: `రోజు`,
    week: `వారం`,

    baseSettings: {
      profile: `ప్రొఫైల్`,
      snippets: `స్నిప్పెట్స్`,
      phone: `ఫోన్`,
      fax: `ఫ్యాక్స్`,
      notifications: `నోటిఫికేషన్లు`,
      audio: `ఆడియో`,
      updates: `అపడుతు`,
      blockedNumbers: `నిరోధించబడిన నంబర్లు`,
      integrations: `ఇంటిగ్రేషన్స్`,
      callCenter: `కాల్ సెంటర్`,
      experiments: `ప్రయోగాలు`,
      shortcutKeys: `షార్ట్‌కట్ కీలు`,
      collapse: `కుదించు`,
      expand: `విస్తరించు`,
      new: `కొత్త`,
      admin: `నిర్వహణ`,
      closeAdmin: `నిర్వహణను మూసివేయండి`,
      adminSections: `నిర్వహణ విభాగాలు`,
    },

    nav: {
      voicemail: `వాయిస్‌మెయిల్`,
      calls: `కాల్స్`,
      missedCalls: `తప్పిన కాల్స్`,
      text: `టెక్స్ట్`,
      messaging: `మెసేజింగ్`,
      fax: `ఫ్యాక్స్`,
      contacts: `కాంటాక్ట్స్`,
      settings: `సెట్టింగ్‌లు`,
      webPhone: `వెబ్ ఫోన్`,
      reporting: `రిపోర్టింగ్`,
      hotels: `హోటల్స్`,
      switchboard: `స్విచ్‌బోర్డ్`,
      devices: `పరికరాలు`,
      extensions: `పొడిగింపులు`,
      messagingGroups: `మెసేజింగ్ సమూహాలు`,
      soundClips: `సౌండ్ క్లిప్‌లు`,
      musicOnHold: `హోల్డ్ మ్యూజిక్`,
      phoneNumbers: `ఫోన్ నంబర్లు`,
      locations: `స్థానాలు`,
      pbxSettings: `PBX సెట్టింగ్‌లు`,
      schedules: `షెడ్యూల్‌లు`,
      integrations: `ఇంటిగ్రేషన్‌లు`,
      systemSettings: `సిస్టమ్ సెట్టింగ్‌లు`,
      users: `వినియోగదారులు`,
      userGroups: `వినియోగదారు సమూహాలు`,
      apiAccess: `API యాక్సెస్`,
      developers: `డెవలపర్లు`,
      mainNavigation: `ప్రధాన నావిగేషన్`,
      skipToMainContent: `ప్రధాన కంటెంట్‌కు వెళ్లండి`,
      callAnalytics: `కాల్ విశ్లేషణ`,
      status: `స్థితి`,
    },

    users: {
      detail: {
        close: `వినియోగదారు వివరాలను మూసివేయండి`,
        loadingUser: `వినియోగదారు లోడ్ అవుతోంది...`,
        pbxAssociations: {
          heading: `PBX అనుబంధాలు`,
          addToPbx: `PBX కి జోడించండి`,
          filterPlaceholder: `PBX అనుబంధాలను ఫిల్టర్ చేయండి...`,
          filterAriaLabel: `PBX అనుబంధాలను ఫిల్టర్ చేయండి`,
          empty: `ఈ వినియోగదారు ఏ PBXకి కేటాయించబడలేదు.`,
          noMatches: `మీ శోధనతో సరిపోలే PBX అనుబంధాలు లేవు.`,
        },
      },
      generalInfo: {
        heading: `వినియోగదారు సమాచారం`,
        copyCognitoKey: `"Cognito Key" కాపీ చేయండి`,
        resetPassword: `పాస్‌వర్డ్ రీసెట్ చేయండి`,
        resetPasswordAria: `పాస్‌వర్డ్ రీసెట్ చేయండి`,
        editUserInformation: `వినియోగదారు సమాచారాన్ని సవరించండి`,
        deactivateUser: `వినియోగదారును నిష్క్రియం చేయండి`,
        activateUser: `వినియోగదారును సక్రియం చేయండి`,
        username: `వినియోగదారు పేరు`,
        name: `పేరు`,
        role: `పాత్ర`,
        email: `ఇమెయిల్`,
        lastLoggedIn: `చివరి లాగిన్`,
        created: `సృష్టించబడింది`,
        updated: `నవీకరించబడింది`,
      },
      pbxAssociationCard: {
        editAria: `{{pbxName}} కోసం అనుబంధాన్ని సవరించండి`,
        removeAria: `{{pbxName}} నుండి {{userName}}ని తీసివేయండి`,
        assignedExtensions: `కేటాయించిన పొడిగింపులు`,
        faxEmail: `ఫ్యాక్స్ ఇమెయిల్`,
        faxNumber: `ఫ్యాక్స్ నంబర్`,
        pin: `PIN`,
        faxTitle: `ఫ్యాక్స్ శీర్షిక`,
      },
      phonePermissions: {
        heading: `ఫోన్ అనుమతులు`,
        loading: `ఫోన్ అనుమతులు లోడ్ అవుతోంది...`,
        empty: `ఈ వినియోగదారు ఏ ఫోన్ అనుమతి సమూహాలకు కేటాయించబడలేదు.`,
        editAria: `{{pbxName}} కోసం ఫోన్ అనుమతులను సవరించండి`,
        noGroupsAssigned: `సమూహాలు కేటాయించబడలేదు.`,
      },
      pbxUserForm: {
        titleAdd: `PBX కి జోడించండి`,
        titleEdit: `PBX అనుబంధాన్ని సవరించండి`,
        pbxLabel: `PBX`,
        pbxSearchPlaceholder: `పేరుతో PBXలను శోధించండి...`,
        pbxSearchAria: `పేరుతో PBX ఎంపికలను శోధించండి`,
        pbxSearching: `శోధిస్తోంది...`,
        pbxTypeToSearch: `PBXలను శోధించడానికి టైప్ చేయండి...`,
        pbxNoMatches: `ఆ శోధనతో సరిపోలే PBXలు లేవు.`,
        faxTitleLabel: `ఫ్యాక్స్ శీర్షిక`,
        faxTitlePlaceholder: `ఫ్యాక్స్ శీర్షిక`,
        sendingFaxEmailLabel: `పంపే ఫ్యాక్స్ ఇమెయిల్`,
        sendingFaxEmailPlaceholder: `ఫ్యాక్స్ ఇమెయిల్ చిరునామా`,
        invalidEmail: `దయచేసి చెల్లుబాటు అయ్యే ఇమెయిల్ చిరునామాను నమోదు చేయండి.`,
        sendingFaxNumberLabel: `పంపే ఫ్యాక్స్ నంబర్`,
        faxNumberSearchPlaceholder: `ఫ్యాక్స్ నంబర్లను శోధించండి...`,
        faxNumberSelectPbxFirst: `ముందుగా PBXని ఎంచుకోండి`,
        faxNumberSearchAria: `పంపే ఫ్యాక్స్ నంబర్ ఎంపికలను శోధించండి`,
        faxNumbersLoading: `ఫ్యాక్స్ నంబర్లు లోడ్ అవుతున్నాయి...`,
        faxNumbersEmpty: `ఈ PBX కోసం ఫ్యాక్స్ నంబర్లు కనుగొనబడలేదు.`,
        pinLabel: `PIN`,
        pinPlaceholder: `4-అంకెల PIN (1000-9999)`,
        userGroupsLabel: `వినియోగదారు సమూహాలు`,
        userGroupsSelected_one: `{{count}} ఎంచుకున్నారు`,
        userGroupsSelected_other: `{{count}} ఎంచుకున్నారు`,
        cancel: `రద్దు చేయండి`,
        submitAdd: `PBX కి జోడించండి`,
        submitEdit: `మార్పులను సేవ్ చేయండి`,
      },
      editPhonePermissions: {
        title: `ఫోన్ అనుమతులను సవరించండి: {{userName}}`,
        pbxLabel: `PBX: {{pbxName}}`,
        groups: `సమూహాలు`,
        noGroups: `ఈ PBX కోసం సమూహాలు అందుబాటులో లేవు.`,
        required: `(అవసరం)`,
        selectedCount: `{{total}}లో {{selected}} ఎంచుకున్నారు`,
        close: `మూసివేయండి`,
        submit: `ఫోన్ అనుమతులను నవీకరించండి`,
      },
      formatAssignedAssets: {
        extension_one: `{{count}} కేటాయించిన పొడిగింపు`,
        extension_other: `{{count}} కేటాయించిన పొడిగింపులు`,
        device_one: `{{count}} కేటాయించిన పరికరం`,
        device_other: `{{count}} కేటాయించిన పరికరాలు`,
        and: ` మరియు `,
      },
      toast: {
        userCreated: {
          title: `వినియోగదారు సృష్టించబడ్డారు`,
          description: `{{firstName}} {{lastName}} సృష్టించబడ్డారు.`,
        },
        userCreateError: {
          title: `వినియోగదారు సృష్టి లోపం`,
        },
        userUpdated: {
          title: `వినియోగదారు నవీకరించబడ్డారు`,
        },
        userUpdateError: {
          title: `వినియోగదారు నవీకరణ లోపం`,
        },
        pbxAdded: {
          title: `PBX కి వినియోగదారు జోడించబడ్డారు`,
        },
        pbxUpdated: {
          title: `PBX అనుబంధం నవీకరించబడింది`,
        },
        error: `లోపం`,
        associationRemoved: {
          title: `అనుబంధం తీసివేయబడింది`,
          description: `{{name}} ఈ PBX నుండి తీసివేయబడింది.`,
        },
        alreadyRemoved: {
          title: `ఇప్పటికే తీసివేయబడింది`,
          description: `PBXలో వినియోగదారు కనుగొనబడలేదు మరియు ఇప్పటికే తీసివేయబడి ఉండవచ్చు.`,
        },
        removeFailed: `PBX నుండి వినియోగదారును తీసివేయడంలో విఫలమైంది.`,
        noPhonePermissionChanges: {
          title: `ఫోన్ అనుమతి మార్పులు లేవు`,
        },
        phonePermissionsUpdated: {
          title: `ఫోన్ అనుమతులు నవీకరించబడ్డాయి`,
        },
        updateGroupFailed: `"{{name}}"ని నవీకరించడంలో విఫలమైంది.`,
        phonePermissionsUpdateError: {
          title: `ఫోన్ అనుమతులను నవీకరించడంలో విఫలమైంది`,
          fallback: `ఫోన్ అనుమతులను నవీకరించడం సాధ్యం కాలేదు.`,
        },
        defaultUserName: `వినియోగదారు`,
      },
      removeDialog: {
        cannotTitle: `PBX నుండి వినియోగదారును తీసివేయడం సాధ్యం కాదు`,
        thisUserCapitalized: `ఈ వినియోగదారు`,
        cannotBody: `<bold>{{userName}}</bold>కు ఈ PBXలో {{assets}} ఉన్నాయి. ఈ వినియోగదారును PBX నుండి తీసివేయడానికి ముందు ఈ ఆస్తులను తిరిగి కేటాయించండి లేదా తొలగించండి.`,
        ok: `సరే`,
        confirmTitle: `PBX నుండి వినియోగదారును తీసివేయాలా?`,
        thisUser: `ఈ వినియోగదారును`,
        confirmBody: `ఇది <bold>{{userName}}</bold>ని ఎంచుకున్న PBX నుండి తీసివేస్తుంది.`,
        cancel: `రద్దు చేయండి`,
        remove: `తీసివేయండి`,
      },
      list: {
        title: `యూజర్లు`,
        searchPlaceholder: `పేరు, యూజర్‌నేమ్ లేదా ఇమెయిల్ ద్వారా వెతకండి...`,
        searchAriaLabel: `యూజర్లను వెతకండి`,
        newUser: `కొత్త యూజర్`,
        newUserAriaLabel: `కొత్త యూజర్‌ను సృష్టించండి`,
        newUserDisabledAriaLabel: `కొత్త యూజర్‌ను సృష్టించండి (డిసేబుల్)`,
        newUserPermissionTooltip: `మీకు యూజర్లను సృష్టించే అనుమతి లేదు`,
        clickToCopy: `కాపీ చేయడానికి క్లిక్ చేయండి`,
        copied: `కాపీ చేయబడింది!`,
        loading: `వినియోగదారులను లోడ్ చేస్తోంది...`,
        error: `లోపం`,
        emptyNoResultsTitle: `ఫలితాలు కనుగొనబడలేదు`,
        emptyNoResultsDescription: `మీ శోధన పదాలను సర్దుబాటు చేయడానికి ప్రయత్నించండి`,
        emptyNoUsersTitle: `ఇంకా వినియోగదారులు లేరు`,
        emptyNoUsersDescription: `మీ మొదటి వినియోగదారుని సృష్టించడం ద్వారా ప్రారంభించండి`,
        removeFromPbxTitle: `PBX నుండి {{name}}ను తొలగించండి`,
        removeFromPbxDescription: `ఈ వినియోగదారుకు ఏవైనా కేటాయించబడిన పరికరాలు లేదా ఎక్స్‌టెన్షన్‌లు ఉంటే, అవి ఎంచుకున్న వినియోగదారికి తిరిగి కేటాయించబడతాయి.`,
        reassignAndRemove: `తిరిగి కేటాయించి, తొలగించండి`,
        cancel: `రద్దు చేయి`,
        reassignAssetsTo: `ఆస్తులను తిరిగి కేటాయించండి`,
        selectUserPlaceholder: `వినియోగదారుని ఎంచుకోండి...`,
        searchingUsers: `వెతుకుతోంది...`,
        noMatchingUsers: `సరిపోలే వినియోగదారులు లేరు`,
        searchUsersToReassign: `ఆస్తులను తిరిగి కేటాయించడానికి వినియోగదారులను వెతకండి`,
        candidateLoadFailed: `వినియోగదారులను లోడ్ చేయడం సాధ్యపడలేదు. మీ కనెక్షన్‌ను తనిఖీ చేసి మళ్లీ ప్రయత్నించండి.`,
        noOtherUsersOnPbx: `ఈ PBXలో ఇతర వినియోగదారులు లేరు. ఈ వినియోగదారుని తొలగించే ముందు మరొక వినియోగదారుని జోడించండి, తద్వారా వారి ఆస్తులను తిరిగి కేటాయించవచ్చు.`,
        defaultUserName: `వినియోగదారు`,
        column: {
          name: `పేరు`,
          usernameOrEmail: `యూజర్‌నేమ్ / ఇమెయిల్`,
          role: `పాత్ర`,
          faxEmail: `ఫ్యాక్స్ ఇమెయిల్`,
          lastLogin: `చివరి లాగిన్`,
          lastUpdated: `చివరి అప్‌డేట్`,
          action: `చర్య`,
        },
        pagination: {
          resultsPerPage: `పేజీకి ఫలితాలు:`,
          previousPage: `మునుపటి పేజీ`,
          nextPage: `తదుపరి పేజీ`,
          jumpToPage: `పేజీ {{page}} కు వెళ్ళండి`,
          all: `అన్నీ`,
          recordRange: `{{start}}—{{end}} / {{total}} మొత్తం`,
          recordRangeEmpty: `0 / 0`,
        },
      },
      resetPassword: {
        toast: {
          copiedTitle: `రీసెట్ లింక్ క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది`,
          copyFailedTitle: `రీసెట్ లింక్ సృష్టించబడింది, కానీ కాపీ చేయలేకపోయాం`,
          manualCopyDescription: `ఈ రీసెట్ URL ను మాన్యువల్‌గా కాపీ చేయండి: {{url}}`,
          missingUrlTitle: `రీసెట్ లింక్ సృష్టించడంలో విఫలమైంది`,
          missingUrlDescription: `రీసెట్ URL తిరిగి రాలేదు.`,
          requestFailedTitle: `పాస్‌వర్డ్ రీసెట్ చేయడంలో విఫలమైంది`,
          unexpectedErrorDescription: `ఊహించని లోపం సంభవించింది.`,
        },
      },
      create: {
        loadingForm: `యూజర్ ఫారమ్ లోడ్ అవుతోంది...`,
      },
      edit: {
        loadingDetails: `యూజర్ వివరాలు లోడ్ అవుతున్నాయి...`,
        retryLoadingRoles: `పాత్రలను మళ్లీ లోడ్ చేయండి`,
      },
      form: {
        heading: {
          newUser: `కొత్త యూజర్`,
          editUser: `యూజర్‌ను సవరించండి`,
        },
        section: {
          pbxAssignment: `PBX కేటాయింపు`,
        },
        field: {
          firstName: `మొదటి పేరు`,
          lastName: `చివరి పేరు`,
          username: `యూజర్‌నేమ్`,
          usernameHelper: `తప్పనిసరి. 4-150 అక్షరాలు. అక్షరాలు, సంఖ్యలు, బిందువులు లేదా డాష్‌లు మాత్రమే. గమనిక: సృష్టించిన తర్వాత యూజర్‌నేమ్‌ను మార్చలేరు.`,
          email: `ఈమెయిల్`,
          emailHelper: `ఐచ్ఛికం. ఒకసారి సెట్ చేసిన తర్వాత ఈమెయిల్‌ను మార్చలేరు.`,
          isStaff: `Mango సిబ్బందా?`,
          staffHelperIntro: `ఈ పదవి కొన్ని మినహాయింపులతో సిస్టమ్‌కు పూర్తి ప్రాప్యతను ఇస్తుంది:`,
          staffHelperBullet1: `యూజర్ ఇతర యూజర్‌లకు Mango సూపర్‌యూజర్ హోదాను కేటాయించలేరు.`,
          staffHelperBullet2: `యూజర్ Mango సూపర్‌యూజర్‌లను సవరించలేరు.`,
          staffHelperBullet3: `యూజర్ సర్వర్లు, ప్రొవైడర్లు లేదా పరికర తయారీదారులను సవరించలేరు.`,
          isSuperuser: `Mango సూపర్‌యూజర్`,
          role: `పాత్ర`,
          rolePlaceholder: `------`,
          roleUnavailable: `పాత్ర ఎంపికలు అందుబాటులో లేవు`,
          roleUnavailableHelper: `పాత్ర ఎంపికలు అందుబాటులో లేవు.`,
          roleWarning: `హెచ్చరిక: ఈ పాత్ర యూజర్ సంబంధిత అన్ని PBX లకు వర్తిస్తుంది. మార్పులు చేసే ముందు ప్రభావాలను జాగ్రత్తగా పరిశీలించండి.`,
          pbx: `PBX`,
          pbxSearchPlaceholder: `పేరుతో PBX వెతకండి...`,
          pbxSearchAriaLabel: `పేరుతో PBX ఎంపికలను వెతకండి`,
          pin: `PIN`,
          pinPlaceholder: `4-అంకెల PIN (1000-9999)`,
          faxTitle: `ఫ్యాక్స్ శీర్షిక`,
          faxTitlePlaceholder: `ఫ్యాక్స్ శీర్షిక`,
          sendingFaxEmail: `పంపే ఫ్యాక్స్ ఈమెయిల్`,
          sendingFaxEmailPlaceholder: `ఫ్యాక్స్ ఈమెయిల్ చిరునామా`,
          sendingFaxNumber: `పంపే ఫ్యాక్స్ నంబర్`,
          searchFaxNumbers: `ఫ్యాక్స్ నంబర్లను వెతకండి...`,
          selectPbxFirst: `ముందుగా ఒక PBX ఎంచుకోండి`,
          searchFaxNumbersAriaLabel: `పంపే ఫ్యాక్స్ నంబర్ ఎంపికలను వెతకండి`,
          userGroups: `యూజర్ గ్రూపులు`,
        },
        combobox: {
          searching: `వెతుకుతోంది...`,
          typeToSearchPbx: `PBX వెతకడానికి టైప్ చేయండి...`,
          noPbxMatches: `ఆ శోధనకు సరిపోలే PBX లేదు.`,
          loadingFaxNumbers: `ఫ్యాక్స్ నంబర్లను లోడ్ చేస్తోంది...`,
          noFaxNumbers: `ఈ PBX కోసం ఫ్యాక్స్ నంబర్లు కనుగొనబడలేదు.`,
        },
        userGroups: {
          placeholder: `యూజర్ గ్రూపులను ఎంచుకోండి...`,
          searchPlaceholder: `యూజర్ గ్రూపులను ఫిల్టర్ చేయండి...`,
          emptyLabel: `ఈ PBX కోసం యూజర్ గ్రూపులు అందుబాటులో లేవు.`,
          noResultsLabel: `మీ ఫిల్టర్‌కు సరిపోలే యూజర్ గ్రూపులు లేవు.`,
          summary_one: `{{count}} గ్రూప్ ఎంచుకోబడింది`,
          summary_other: `{{count}} గ్రూపులు ఎంచుకోబడ్డాయి`,
        },
        button: {
          cancel: `రద్దు చేయండి`,
          saveAndCreateAnother: `సేవ్ చేసి మరొకటి సృష్టించండి`,
          createUser: `యూజర్‌ను సృష్టించండి`,
          saveChanges: `మార్పులను సేవ్ చేయండి`,
        },
      },
    },

    switchboard: {
      list: {
        title: `స్విచ్‌బోర్డ్`,
        subtitle: `మీ వాయిస్ సిస్టమ్ కోసం కాల్ ఫ్లోలను సృష్టించండి మరియు నిర్వహించండి`,
        newSwitchboard: `కొత్త స్విచ్‌బోర్డ్`,
        search: { placeholder: `పేరుతో శోధించండి...` },
        pagination: {
          resultsPerPage: `పేజీకి ఫలితాలు:`,
          previousPage: `మునుపటి పేజీ`,
          nextPage: `తరువాతి పేజీ`,
          jumpToPage: `పేజీ {{page}}కి వెళ్లండి`,
          all: `అన్నీ`,
        },
        grid: {
          errorTitle: `లోపం`,
          errorLoading: `స్విచ్‌బోర్డ్‌లను లోడ్ చేయడంలో లోపం:`,
          checkConsole: `వివరాల కోసం కన్సోల్ చూడండి`,
          loading: `స్విచ్‌బోర్డ్‌లు లోడ్ అవుతున్నాయి...`,
        },
        empty: {
          noDataTitle: `ఇంకా స్విచ్‌బోర్డ్‌లు లేవు`,
          noDataDescription: `మీ మొదటి స్విచ్‌బోర్డ్ సృష్టించడం ద్వారా ప్రారంభించండి`,
          noResultsTitle: `ఈ పేజీలో స్విచ్‌బోర్డ్‌లు లేవు`,
          noResultsDescription: `పేజీ సైజ్ సర్దుబాటు చేయండి లేదా వేరే పేజీకి వెళ్లండి`,
          noSearchResultsTitle: `ఫలితాలు కనుగొనబడలేదు`,
          noSearchResultsDescription: `మీ శోధన పదాలను సర్దుబాటు చేయడానికి ప్రయత్నించండి`,
        },
        card: {
          editAria: `స్విచ్‌బోర్డ్ సవరించండి`,
          deleteAria: `తొలగించండి`,
          lastUpdated: `చివరి నవీకరణ`,
        },
        delete: {
          title: `స్విచ్‌బోర్డ్ తొలగించండి`,
          body: `"{{displayName}}"ని తొలగించాలని ఖచ్చితంగా ఉన్నారా? ఈ చర్యను రద్దు చేయలేము.`,
          cancel: `రద్దు చేయండి`,
          confirm: `తొలగించండి`,
        },
        deleteSuccessToast: `స్విచ్‌బోర్డ్ తొలగించబడింది`,
        deleteFailedToast: `స్విచ్‌బోర్డ్ తొలగించడం విఫలమైంది`,
        edit: {
          title: `స్విచ్‌బోర్డ్ సవరించండి`,
          nameLabel: `పేరు`,
          namePlaceholder: `ఉదా., స్విచ్‌బోర్డ్ - 7074`,
          numberLabel: `నంబర్`,
          numberPlaceholder: `ఉదా., 7074`,
          omitFromDirectoryLabel: `డైరెక్టరీ నుండి వదిలివేయండి`,
          omitNo: `కాదు`,
          omitYes: `అవును`,
          cancel: `రద్దు చేయండి`,
          submit: `స్విచ్‌బోర్డ్ నవీకరించండి`,
        },
      },
      edit: {
        loading: `స్విచ్‌బోర్డ్ లోడ్ అవుతోంది...`,
        notFound: {
          title: `స్విచ్‌బోర్డ్ కనుగొనబడలేదు`,
          errorLoading: `స్విచ్‌బోర్డ్ లోడ్ చేయడంలో లోపం: {{message}}`,
          description: `ఎక్స్‌టెన్షన్ {{extensionDialPlan}}తో స్విచ్‌బోర్డ్ APIలో లేదు.`,
          thisCouldMean: `దీని అర్థం:`,
          reasonDeleted: `స్విచ్‌బోర్డ్ తొలగించబడింది`,
          reasonNoData: `ఎక్స్‌టెన్షన్ ఉంది కానీ స్విచ్‌బోర్డ్ డేటా లేదు`,
          reasonCorrupted: `డేటా పునరుద్ధరించలేని స్థితిలో దెబ్బతిన్నది`,
          backToList: `← స్విచ్‌బోర్డ్ జాబితాకు తిరిగి వెళ్లండి`,
          unknownError: `తెలియని లోపం`,
        },
        save: {
          cannotSave: `స్విచ్‌బోర్డ్ సేవ్ చేయలేము`,
          success: `స్విచ్‌బోర్డ్ సేవ్ చేయబడింది`,
          failed: `స్విచ్‌బోర్డ్ సేవ్ చేయడం విఫలమైంది`,
          requiredFieldError: `{{node}}: {{message}}`,
          unexpectedError: `ఊహించని లోపం సంభవించింది.`,
          targetMismatch: `లోడ్ చేసిన స్విచ్‌బోర్డ్ ఈ పేజీతో సరిపోలడం లేదు. సేవ్ చేయడానికి ముందు రిఫ్రెష్ చేయండి.`,
        },
        header: {
          backToList: `స్విచ్‌బోర్డ్‌లకు తిరిగి వెళ్లండి`,
          defaultName: `స్విచ్‌బోర్డ్ {{extensionDialPlan}}`,
          deleteSwitchboard: `స్విచ్‌బోర్డ్‌ను తొలగించండి`,
          save: `సేవ్ చేయండి`,
          revertLocalChanges: `లోకల్ మార్పులను రద్దు చేయండి`,
          refreshSwitchboard: `స్విచ్‌బోర్డ్‌ను రిఫ్రెష్ చేయండి`,
        },
        oldFormat: {
          warning: `⚠️ హెచ్చరిక: స్విచ్‌బోర్డ్ డేటా పాత ఫార్మాట్‌లో ఉంది`,
          description: `ఈ స్విచ్‌బోర్డ్ పాత ఎడిటర్‌తో సృష్టించబడింది. కొత్త ఫార్మాట్‌కు మైగ్రేట్ చేయనంత వరకు విజువల్ ఫ్లో ప్రదర్శించబడదు.`,
        },
        routeConflict: {
          title: `రూటింగ్ వైరుధ్యం`,
          description: `{{node}} → {{route}}కు అనేక గమ్యస్థానాలు ఉన్నాయి. సేవ్ చేయడానికి ముందు ఒకదాన్ని తొలగించండి.`,
        },
        unconfiguredSchedule: {
          description: `ఈ కాల్ ఫ్లోలోని షెడ్యూల్ నోడ్‌కు ఏ షెడ్యూల్ ఎంపిక చేయబడలేదు. సేవ్ చేయడానికి ముందు షెడ్యూల్ ఎంచుకోండి, లేదా నోడ్‌ను డిస్‌కనెక్ట్ చేయండి.`,
          descriptionPlural: `ఈ కాల్ ఫ్లోలోని {{count}} షెడ్యూల్ నోడ్‌లకు ఏ షెడ్యూల్ ఎంపిక చేయబడలేదు. సేవ్ చేయడానికి ముందు ప్రతి ఒక్కదానికి షెడ్యూల్ ఎంచుకోండి, లేదా వాటిని డిస్‌కనెక్ట్ చేయండి.`,
        },
        canvas: {
          emptyTitle: `ఇంకా ఫ్లో కాన్ఫిగర్ చేయబడలేదు`,
          emptyDescription: `మీ కాల్ ఫ్లోను నిర్మించడం ప్రారంభించడానికి "Add Node"పై క్లిక్ చేయండి`,
          validationToastTitle: `హెచ్చరిక!`,
          invalidConnection: `చెల్లని కనెక్షన్`,
        },
        unsavedChanges: {
          title: `సేవ్ చేయని మార్పులు`,
          body: `మీకు సేవ్ చేయని మార్పులు ఉన్నాయి. వెళ్లాలని ఖచ్చితంగా ఉన్నారా?`,
          stay: `ఉండండి`,
          save: `సేవ్ చేయండి`,
          leave: `వెళ్లండి`,
        },
        revert: {
          title: `లోకల్ మార్పులను రద్దు చేయాలా?`,
          body: `ఇది ఈ బ్రౌజర్ సెషన్‌లో చేసిన మార్పులను తొలగించి, చివరిసారిగా సేవ్ చేసిన స్విచ్‌బోర్డ్‌ను మళ్లీ లోడ్ చేస్తుంది. ఇప్పటికే సేవ్ చేసినది తొలగించబడదు.`,
          cancel: `రద్దు చేయండి`,
          confirm: `మార్పులను రద్దు చేయండి`,
          success: `లోకల్ మార్పులు రద్దు చేయబడ్డాయి`,
          successDescription: `మీ చివరి సేవ్ చేసిన స్విచ్‌బోర్డ్ పునరుద్ధరించబడింది.`,
        },
        versionConflict: {
          title: `కొత్త అప్డేట్‌లు అందుబాటులో ఉన్నాయి`,
          body: `ఇంకెవరో ఈ స్విచ్‌బోర్డ్‌లో మార్పులు సేవ్ చేశారు. మీ ప్రస్తుత మార్పులను కొనసాగించండి లేదా తాజా సేవ్ చేసిన వెర్షన్‌ను లోడ్ చేయండి.`,
          keepWorking: `నా మార్పులను కొనసాగించండి`,
          loadLatest: `తాజా మార్పులను లోడ్ చేయండి`,
        },
        refresh: {
          newerVersionTitle: `స్విచ్‌బోర్డ్ రిఫ్రెష్ అయింది`,
          newerVersionDescription: `కొత్తగా సేవ్ చేసిన వెర్షన్ గుర్తించబడింది మరియు లోడ్ చేయబడింది.`,
        },
        configPanel: {
          title: `{{type}} కాన్ఫిగర్ చేయండి`,
          notImplemented: `ఈ నోడ్ టైప్ కోసం కాన్ఫిగరేషన్ UI ఇంకా ఇంప్లిమెంట్ చేయబడలేదు.`,
          cancel: `రద్దు చేయండి`,
          save: `సేవ్ చేయండి`,
        },
      },
      nodeLabels: {
        start: `ప్రారంభం`,
        transfer: `ట్రాన్స్ఫర్`,
        transfer_and_continue: `ట్రాన్స్ఫర్ మరియు కొనసాగించండి`,
        queue: `క్యూ`,
        auto_attendant: `ఆటో అటెండెంట్`,
        external_transfer: `బాహ్య ట్రాన్స్ఫర్`,
        leave_voicemail: `వాయిస్‌మెయిల్ వదిలివేయండి`,
        schedule: `షెడ్యూల్`,
        day_night: `పగలు/రాత్రి`,
        dial_by_name: `పేరుతో డయల్ చేయండి`,
        sound_clip: `సౌండ్ క్లిప్`,
        wait: `వేచి ఉండండి`,
        hang_up: `హ్యాంగ్ అప్`,
        jump_to_switchboard: `స్విచ్‌బోర్డ్‌కు వెళ్లండి`,
        conference_room: `కాన్ఫరెన్స్ రూమ్`,
        transfer_and_rollover: `ట్రాన్స్ఫర్ మరియు రోల్‌ఓవర్`,
        call_distribution: `కాల్ డిస్ట్రిబ్యూషన్`,
        change_caller_id: `కాలర్ ID మార్చండి`,
        webhook: `వెబ్‌హుక్`,
        interactive_webhook: `ఇంటరాక్టివ్ వెబ్‌హుక్`,
        fax_detect: `ఫ్యాక్స్ డిటెక్ట్`,
        sms_notification: `SMS నోటిఫికేషన్`,
        ai_agent_v1: `AI ఏజెంట్`,
      },
      dialogs: {
        deleteNode: {
          title: `నోడ్ తొలగించండి`,
          body: `ఈ నోడ్‌ను తొలగించాలని ఖచ్చితంగా ఉన్నారా?`,
          bodyWithLabel: `"{{label}}"ని తొలగించాలని ఖచ్చితంగా ఉన్నారా?`,
          warning: `ఈ చర్యను రద్దు చేయలేము. ఈ నోడ్‌కు అన్ని కనెక్షన్‌లు కూడా తొలగించబడతాయి.`,
          cancel: `రద్దు చేయండి`,
          confirm: `తొలగించండి`,
        },
        deleteEdge: {
          title: `కనెక్షన్ తొలగించండి`,
          body: `ఈ కనెక్షన్‌ను తొలగించాలని ఖచ్చితంగా ఉన్నారా?`,
          warning: `ఈ చర్యను రద్దు చేయలేము.`,
          cancel: `రద్దు చేయండి`,
          confirm: `తొలగించండి`,
        },
        deleteSwitchboard: {
          title: `స్విచ్‌బోర్డ్ తొలగించండి`,
          body: `ఈ స్విచ్‌బోర్డ్‌ను తొలగించాలని ఖచ్చితంగా ఉన్నారా?`,
          bodyWithName: `"{{name}}"ని తొలగించాలని ఖచ్చితంగా ఉన్నారా?`,
          bodyWithId: `స్విచ్‌బోర్డ్ {{id}}ని తొలగించాలని ఖచ్చితంగా ఉన్నారా?`,
          warning: `ఈ చర్యను రద్దు చేయలేము. అన్ని స్విచ్‌బోర్డ్ కాన్ఫిగరేషన్ మరియు డేటా శాశ్వతంగా తొలగించబడతాయి.`,
          cancel: `రద్దు చేయండి`,
          confirm: `తొలగించండి`,
        },
      },
      core: {
        selectExtension: `ఎక్స్‌టెన్షన్ ఎంచుకోండి...`,
        extensionLabel: `ఎక్స్‌టెన్షన్`,
        selectSchedule: `షెడ్యూల్ ఎంచుకోండి...`,
        scheduleLabel: `షెడ్యూల్`,
        selectSoundClip: `సౌండ్ క్లిప్ ఎంచుకోండి...`,
        soundClipLabel: `సౌండ్ క్లిప్`,
        selectSwitchboard: `స్విచ్‌బోర్డ్ ఎంచుకోండి...`,
        switchboardLabel: `స్విచ్‌బోర్డ్`,
        selectConferenceRoom: `కాన్ఫరెన్స్ రూమ్ ఎంచుకోండి...`,
        conferenceRoomLabel: `కాన్ఫరెన్స్ రూమ్`,
        selectQueue: `క్యూ ఎంచుకోండి...`,
        queueLabel: `క్యూ`,
        selectFax: `ఫ్యాక్స్ ఎక్స్‌టెన్షన్ ఎంచుకోండి...`,
        faxLabel: `ఫ్యాక్స్ ఎక్స్‌టెన్షన్`,
        timeoutPlaceholder: `టైమౌట్ (సెకన్లు)`,
        timeoutIncrease: `టైమౌట్ పెంచండి`,
        timeoutDecrease: `టైమౌట్ తగ్గించండి`,
        expand: `విస్తరించండి`,
        minimize: `కుదించండి`,
        deleteNodeAria: `నోడ్ తొలగించండి`,
        drop: `డ్రాప్`,
        drag: `డ్రాగ్`,
        unnamed: `పేరు లేదు`,
        voicemailOptions: {
          definedByExtension: `ఎక్స్‌టెన్షన్ ద్వారా నిర్వచించబడింది`,
          systemGenerated: `సిస్టమ్ జనరేట్ చేసిన గ్రీటింగ్`,
          noGreeting: `గ్రీటింగ్ లేదు`,
          busy1: `బిజీ-1`,
          unavailable2: `అందుబాటులో లేదు-2`,
          custom3: `కస్టమ్-3`,
          custom4: `కస్టమ్-4`,
          custom5: `కస్టమ్-5`,
          custom6: `కస్టమ్-6`,
          custom7: `కస్టమ్-7`,
          custom8: `కస్టమ్-8`,
          custom9: `కస్టమ్-9`,
        },
      },
      create: {
        nameRequired: `పేరు అవసరం`,
        nameRequiredDescription: `దయచేసి ఈ స్విచ్‌బోర్డ్‌కు పేరు నమోదు చేయండి.`,
        invalidNumber: `చెల్లని నంబర్`,
        invalidNumberDescription: `దయచేసి చెల్లుబాటు అయ్యే నంబర్ నమోదు చేయండి.`,
        invalidNumberRange: `నంబర్ 0 లేదా 100 మరియు 99999 మధ్య ఉండాలి.`,
        pbxIdRequired: `PBX ID అవసరం`,
        pbxIdRequiredDescription: `స్విచ్‌బోర్డ్ సృష్టించడానికి PBX ID అవసరం.`,
        createdSuccess: `స్విచ్‌బోర్డ్ సృష్టించబడింది`,
        createFailed: `స్విచ్‌బోర్డ్ సృష్టించడం విఫలమైంది`,
        genericError: `లోపం సంభవించింది`,
        cannotAddSwitchboard: `'{{name}}' స్విచ్‌బోర్డ్ జోడించలేము`,
        extensionAlreadyExists: `'{{number}}' నంబర్ తో ఎక్స్‌టెన్షన్ ఇప్పటికే ఉంది.`,
        dialogTitle: `కొత్త స్విచ్‌బోర్డ్`,
        close: `మూసివేయండి`,
        submitButton: `కొత్త స్విచ్‌బోర్డ్ సృష్టించండి`,
      },
      nodes: {
        clickToConfigure: `కాన్ఫిగర్ చేయడానికి క్లిక్ చేయండి`,
        defaultLabel: `నోడ్`,
        none: `ఏదీ లేదు`,
        transfer: {
          extension: `ఎక్స్‌టెన్షన్`,
          extensionHelp: `కాల్ ట్రాన్స్ఫర్ చేయడానికి ఎక్స్‌టెన్షన్`,
          timeout: `టైమౌట్ (సెకన్లు)`,
          timeoutHelp: `తదుపరి నోడ్‌కు వెళ్లే ముందు సెకన్లలో టైమౌట్`,
          onInvalid: `అచెల్లని`,
          onInvalidHelp: `ఎక్స్‌టెన్షన్ అచెల్లని అయితే వెళ్లే నోడ్`,
          onTimeout: `టైమౌట్`,
          onTimeoutHelp: `ట్రాన్స్ఫర్ టైమౌట్ అయితే వెళ్లే నోడ్`,
        },
        wait: {
          duration: `వ్యవధి (సెకన్లు)`,
          selectDuration: `వ్యవధి ఎంచుకోండి...`,
          ringDuringWait: `వేచి ఉన్నప్పుడు రింగ్ చేయండి`,
        },
        hangUp: {
          noConfig: `ఈ నోడ్ కాల్‌ను ముగిస్తుంది. కాన్ఫిగరేషన్ అవసరం లేదు.`,
          labelOptional: `లేబుల్`,
          labelPlaceholder: `డిస్ప్లేకు లేబుల్`,
        },
        smsNotification: {
          missedCall: `మిస్ చేసిన కాల్`,
          custom: `కస్టమ్`,
          messageType: `మెసేజ్ టైప్`,
          message: `మెసేజ్`,
          messagePlaceholder: `మిస్ చేసిన కాల్ {CALLER_ID}-{CALLER_NUMBER} నుండి`,
          tooltipNotesTitle: `నోట్స్`,
          tooltipNotesAria: `SMS మెసేజ్ సమాచారం`,
          tooltip: {
            intro: `మీ స్వంత సందేశాన్ని సృష్టించండి, మాంగో విలువలను ఎంబెడ్ చేయండి. ఉదాహరణ: జోన్ డో కాలర్ IDతో 888-555-1212 నుండి ఇన్‌కమింగ్ కాల్ ఇలా నమోదు చేయబడుతుంది`,
            exampleTemplate: `మిస్ చేసిన కాల్ {CALLER_ID}-{CALLER_NUMBER} నుండి`,
            exampleResultLeadIn: `ఇది SMS గ్రహీతకు ఈ రీతిగా కనిపించే SMS సందేశాన్ని పంపుతుంది`,
            exampleResult: `మిస్ చేసిన కాల్ జోన్ డో-8885551212 నుండి`,
            variablesHeading: `వేరియబుల్స్`,
          },
          smsRecipient: `SMS గ్రహీత`,
          smsRecipientInfo: `SMS గ్రహీత సమాచారం`,
          separateNumbersHint: `అనేక గ్రహీతలకు పంపడానికి కామాతో నంబర్లను వేరు చేయండి`,
          or: `లేదా`,
          autoReplyToCaller: `కాలర్‌కు ఆటో రిప్లై`,
          sendFrom: `నుండి పంపండి`,
          selectSendFrom: `నంబర్ ఎంచుకోండి...`,
          selectMessagingGroup: `మెసేజింగ్ గ్రూప్ ఎంచుకోండి...`,
          smsGroupLabel: `SMS గ్రూప్:`,
          currentUnavailableNumber: `ప్రస్తుత విలువ (అందుబాటులో లేదు): {{value}}`,
          incomingCall: `ఇన్‌కమింగ్ కాల్`,
          voicemail: `వాయిస్ మెయిల్`,
        },
        queue: {
          onEscape: `ఎస్కేప్ చేసినప్పుడు`,
          maxWait: `గరిష్ట వేచి:`,
        },
        transferAndRollover: {
          noAnswer: `జవాబు లేదు`,
          busy: `బిజీ`,
        },
        common: {
          remove: `తొలగించండి`,
          addOption: `+ ఐచ్ఛికం జోడించండి`,
          removeOption: `ఐచ్ఛికం తొలగించండి`,
          tooltip: {
            variablesHeading: `వేరియబుల్స్`,
            callerIdDesc: `కాల్ చేసే వ్యక్తి యొక్క కాలర్ ID పేరు`,
            callerNumberDesc: `కాల్ చేసే వ్యక్తి యొక్క నంబర్`,
            numberDialedDesc: `డయల్ చేయబడిన నంబర్`,
            callUidDesc: `తరువాత కాల్ రెకార్డ్ చూడటానికి ఉపయోగించగల కాల్ యొక్క ప్రత్యేక ID.`,
            dialedNumberNameDesc: `మాంగోలో డయల్ చేయబడిన నంబర్ పేరు`,
            timeUtcDesc: `UTC టైమ్ జోన్‌లో కాల్ సమయం`,
          },
        },
        schedule: {
          open: `ఓపెన్`,
          closed: `క్లోజ్డ్`,
          holiday: `హాలిడే`,
        },
        aiAgent: {
          agentId: `ఏజెంట్ ID`,
          agentIdPlaceholder: `UUID నమోదు చేయండి (36 అక్షరాలు)`,
          onError: `లోపం`,
          selectAgent: `ఏజెంట్ ఎంచుకోండి...`,
          noAgents: `ఏజెంట్లు కాన్ఫిగర్ చేయబడలేదు`,
        },
        externalTransfer: {
          transferCompany: `బదిలీ కంపెనీ`,
          noCompany: `--`,
          searchTransferCompany: `బదిలీ కంపెనీలను వెతకండి...`,
          searchTransferCompanyAriaLabel: `బదిలీ కంపెనీలను వెతకండి`,
          noTransferCompanyMatches: `మీ శోధనకు సరిపోలే బదిలీ కంపెనీలు లేవు.`,
          number: `నంబర్`,
          enterPhoneNumber: `ఫోన్ నంబర్ నమోదు చేయండి`,
          phoneNumberExactDigitError: `ఫోన్ నంబర్ ఖచ్చితంగా {{count}} అంకెలు ఉండాలి`,
          phoneNumberDigitRangeError: `ఫోన్ నంబర్ {{min}} నుండి {{max}} అంకెలు ఉండాలి`,
          sipServer: `SIP సర్వర్`,
          enterSipServer: `SIP సర్వర్ నమోదు చేయండి`,
          passThroughCallerId: `కాలర్ ID పాస్ థ్రూ చేయండి`,
          orUseThisCallerId: `లేదా ఈ కాలర్ ID ఉపయోగించండి`,
          selectCallerId: `కాలర్ ID ఎంచుకోండి...`,
          noPhoneNumbersAvailable: `ఫోన్ నంబర్లు అందుబాటులో లేవు`,
          requireOneToConnect: `కనెక్ట్ చేయడానికి 1 అవసరం`,
        },
        callDistribution: {
          weight: `వెయిట్`,
          weightWarning: `హెచ్చరిక! మొత్తం వెయిట్ శాతం 100 ఉండాలి. ఇప్పుడు {{total}}`,
        },
        changeCallerId: {
          callerId: `కాలర్ ID`,
          enterCallerId: `కాలర్ ID నమోదు చేయండి`,
          addUpTo20Chars: `ముందు 20 అక్షరాల వరకు జోడించండి`,
          replaceCallerId: `కాలర్ ID రీప్లేస్ చేయండి`,
        },
        dialByName: {
          invalid: `అచెల్లని`,
          lookupBy: `దీని ద్వారా శోధించండి`,
          extensionName: `ఎక్స్‌టెన్షన్ పేరు`,
          userName: `యూజర్ పేరు`,
          sortOrder: `ఆర్డర్`,
          firstName: `ఫస్ట్ నేమ్`,
          lastName: `లాస్ట్ నేమ్`,
          firstLastName: `ఫస్ట్/లాస్ట్ నేమ్`,
        },
        leaveVoicemail: {
          message: `మెసేజ్`,
        },
        autoAttendant: {
          repeatTimes: `పునరావృత సార్లు`,
          allowExtensionDialing: `ఎక్స్‌టెన్షన్ డయలింగ్ అనుమతించండి`,
          press: `ప్రెస్ చేయండి`,
        },
        dayNight: {
          whenOpen: `ఓపెన్ ఉన్నప్పుడు`,
          whenClosed: `క్లోజ్డ్ ఉన్నప్పుడు`,
          open: `ఓపెన్`,
          closed: `క్లోజ్డ్`,
          pressToToggle: `(టోగుల్ చేయడానికి {{code}} ప్రెస్ చేయండి)`,
          basic: `బేసిక్`,
          advanced: `అడ్వాన్స్డ్`,
          toggleCode: `టోగుల్ కోడ్`,
          toastSuccess: `PBX డే/నైట్ స్టేటస్ విజయవంతంగా అప్‌డేట్ చేయబడింది`,
          toastFailed: `PBX డే/నైట్ స్టేటస్ అప్‌డేట్ చేయడం విఫలమైంది`,
        },
        webhook: {
          tooltipTitle: `ఏమి చేయాలి?`,
          tooltipAria: `వెబ్‌హుక్ సమాచారం`,
          notifyUrl: `నోటిఫై URL`,
          notifyUrlPlaceholder: `http://www.example.com/mango_notification.php`,
          tooltip: {
            intro: `బాహ్య వెబ్‌సైట్ లేదా సర్వర్‌కు నోటిఫికేషన్‌లను పంపడానికి ఈ ఫీచర్‌ను ఉపయోగించండి`,
            exampleUsesHeading: `ఉపయోగ ఉదాహరణలు:`,
            exampleUse1: `స్క్రీన్ పాప్ నోటిఫికేషన్`,
            exampleUse2: `కాల్‌లను లాగ్ చేయండి`,
            exampleUse3: `మరొక సైట్‌లో చర్యను ప్రేరేపించండి`,
            exampleUse4: `లీడ్‌లను సృష్టించండి`,
            exampleUrlHeading: `ఉదాహరణ URL`,
            curlyBracketsNote: `కర్లీ బ్రాకెట్‌లు మాంగోవాయిస్ ద్వారా వాస్తవ డేటాతో భర్తి చేయబడతాయి.`,
          },
        },
        interactiveWebhook: {
          tooltipAria: `ఇంటరాక్టివ్ వెబ్‌హుక్ సమాచారం`,
          url: `URL`,
          urlPlaceholder: `http://www.example.com/webhook`,
          allowExtensionAsOption: `ఐచ్ఛికంగా ఎక్స్‌టెన్షన్ అనుమతించండి`,
          option: `ఐచ్ఛికం`,
          optionPlaceholder: `ఐచ్ఛికం`,
          tooltip: {
            intro: `ఇంటరాక్టివ్ వెబ్‌హుక్‌లు మాంగో మరియు మీ సాఫ్ట్‌వేర్ మధ్య రియల్-టైమ్ రూటింగ్‌ను అనుమతిస్తాయి.`,
            howItWorksHeading: `ఎలా పనిచేస్తుంది:`,
            howItWorksBody: `మాంగో నిర్వచించిన urlకు GET అభ్యర్థన చేస్తుంది. మేము అన్ని {} వేరియబుల్‌లను వాస్తవ డేటాతో భర్తి చేస్తాము. కాలర్‌ను ఎలా రూట్ చేయాలో నిర్ణయించడానికి మీరు అభ్యర్థనలో పారామీటర్‌లను ఉపయోగించవచ్చు. మాంగో కాల్‌ను రూట్ చేయాలనుకునే ఐచ్ఛికంతో ప్రతిస్పందనను తిరిగి పంపడం ద్వారా ఇది జరుగుతుంది. ఇది కాలర్‌ల రియల్-టైమ్ రూటింగ్‌ను అనుమతిస్తుంది.`,
            exampleCasesHeading: `ఉదాహరణ కేసులు:`,
            exampleCase1: `స్కిల్స్ ఆధారిత రూటింగ్`,
            exampleCase2: `ప్రారంభ కాల్ నిర్వహించిన ఏజెంట్‌కు గ్రాహకులను తిరిగి రూట్ చేయండి`,
            exampleCase3: `తిరిగి వచ్చే కాలర్‌ల కోసం కాల్ రూట్‌ను అనుకూలీకరించండి.`,
            exampleRequestHeading: `ఉదాహరణ అభ్యర్థన`,
            responseNote: `ప్రతిస్పందనలోని ఐచ్ఛిక విలువ ఈ ఆబ్జెక్ట్‌లో సెట్ చేయబడిన ఐచ్ఛికాలతో సంబంధం ఉండాలి, మీరు ఎక్స్‌టెన్షన్ నంబర్‌ను కూడా తిరిగి ఇవ్వవచ్చు.`,
            exampleResponseHeading: `ఉదాహరణ ప్రతిస్పందన`,
            exampleResponseBody: `{"status": "success", "option": "1"}`,
          },
        },
      },
    },

    schedule: scheduleTeIn,

    global: {
      close: `మూసివేయి`,
      clearSearch: `శోధనను క్లియర్ చేయి`,
      tooltip: {
        copyLink: `క్లిప్‌బోర్డ్‌కు లింక్‌ను కాపీ చేయండి`,
        copyLinkAt: `{{timeStamp}} వద్ద లింక్‌ను కాపీ చేయండి`,
        copyLinkText: `లింక్‌ను కాపీ చేయండి`,
      },
      toast: {
        moveSuccess: `వాయిస్‌మెయిల్ విజయవంతంగా తరలించబడింది.`,
        moveError: `వాయిస్‌మెయిల్ తరలించడంలో విఫలమైంది.`,
        deleteSuccess: `వాయిస్‌మెయిల్ విజయవంతంగా తొలగించబడింది.`,
        deleteError: `వాయిస్‌మెయిల్ తొలగించడంలో విఫలమైంది.`,
        markUnreadSuccess: `వాయిస్‌మెయిల్ చదవనిదిగా విజయవంతంగా గుర్తించబడింది.`,
        markUnreadError: `వాయిస్‌మెయిల్ చదవనిదిగా గుర్తించడంలో విఫలమైంది.`,
        copyLinkSuccess: `క్లిప్‌బోర్డ్‌కు లింక్ కాపీ చేయబడింది`,
        copySuccess: `క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది`,
        copyError: `క్లిప్‌బోర్డ్‌కు కాపీ చేయడం సాధ్యపడలేదు`,
        extensionSwitched: `ఎక్స్‌టెన్షన్ దీనికి మార్చబడింది:`,
        pbxChanged: `PBX దీనికి మార్చబడింది:`,
        globalPhoneHotKeySuccess: `గ్లోబల్ ఫోన్ హాట్‌కీ విజయవంతంగా సేవ్ చేయబడింది.`,
        globalPhoneHotKeyError: `గ్లోబల్ ఫోన్ హాట్‌కీని సేవ్ చేయడంలో విఫలమైంది.`,
        globalPhoneHotKeyDisabled: `హాట్కీ నిలిపివేయబడింది.`,
        globalPhoneHotKeyEnabled: `హాట్కీ ప్రారంభించబడింది.`,
      },
      input: {
        defaultPlaceholder: `ఇక్కడ టైప్ చేయండి`,
      },
      timeAgo: {
        justNow: `ఇప్పుడే`,
        minutesAgo_one: `{{count}} నిమిషం క్రితం`,
        minutesAgo_other: `{{count}} నిమిషాల క్రితం`,
        hoursAgo_one: `{{count}} గంట క్రితం`,
        hoursAgo_other: `{{count}} గంటల క్రితం`,
        daysAgo_one: `{{count}} రోజు క్రితం`,
        daysAgo_other: `{{count}} రోజుల క్రితం`,
      },
      currency: {
        default: `{{value, currency}}`,
        withCode: `{{value, currency, currencyCode}}`,
      },
    },

    contactSearchInput: {
      placeholder: `పేరు లేదా నంబర్‌ను టైప్ చేయండి`,
      invalidPhoneNumber: `తప్పిన ఫోన్ నంబర్`,
      noNumber: `నంబర్ లేదు`,
    },

    newCallModal: {
      header: `కొత్త కాల్`,
      sendToWebPhone: `వెబ్ ఫోన్‌కు పంపండి`,
      sendToDeskPhone: `డెస్క్ ఫోన్‌కు పంపండి (యీలింక్)`,
      from: `నుండి`,
      to: `కు`,
      answerHandsetWhenItRings: `మీ హ్యాండ్‌సెట్ రింగ్ అయినప్పుడు సమాధానం ఇవ్వండి.`,
      attemptingToEstablishCallTo: `{{phoneNumber}}కు కాల్ చేయడానికి ప్రయత్నిస్తోంది...`,
      checkInternetConnection: `దయచేసి మీ ఇంటర్నెట్ కనెక్షన్‌ని తనిఖీ చేసి మళ్లీ ప్రయత్నించండి.`,
      tryAgain: `మళ్లీ ప్రయత్నించండి`,
      establishingCallTo: `{{phoneNumber}}కు కాల్ చేస్తోంది...`,
      failedToEstablishCallTo: `{{phoneNumber}}కు కాల్ చేయడంలో సమస్య ఉంది.`,
    },

    confirmBlockNumberModal: {
      title: `{{formattedPhoneNumber}}ని నిరోధించాలా`,
      message: `మీ PBX ఇకపై ఈ నంబర్ నుండి కాల్స్, టెక్స్ట్‌లు లేదా ఫ్యాక్స్‌లను స్వీకరించదు.`,
      confirmText: `నంబర్‌ను నిరోధించండి`,
      cancelText: `రద్దు చేయండి`,
      toastBlockError: `{{formattedPhoneNumber}}ని నిరోధించడంలో సమస్య ఉంది, దయచేసి మళ్లీ ప్రయత్నించండి.`,
      toastUnblockError: `{{formattedPhoneNumber}}ని అన్‌బ్లాక్ చేయడంలో సమస్య ఉంది, దయచేసి మళ్లీ ప్రయత్నించండి.`,
    },

    blockedNumbers: {
      addNumber: `నంబర్‌ను జోడించండి`,
      headerSubtext: `క్రింద జాబితా చేయబడిన నంబర్‌ల నుండి అన్ని కాల్స్, టెక్స్ట్‌లు మరియు ఫ్యాక్స్‌లు నిరోధించబడతాయి.`,
      header: `నిరోధించబడిన నంబర్లు`,
      clearButton: `క్లియర్ చేయండి`,
      blockButton: `నంబర్‌ను నిరోధించండి`,
      modalSubtext: `క్రింద జాబితా చేయబడిన నంబర్‌ల నుండి అన్ని కాల్స్, టెక్స్ట్‌లు మరియు ఫ్యాక్స్‌లు నిరోధించబడతాయి.`,
      noBlockedNumbers: `నిరోధించబడిన నంబర్లు ఏవీ కనుగొనబడలేదు.`,
      unblockTooltip: `అన్‌బ్లాక్ చేయి`,
      unblockNumberLabel: `{{formattedPhoneNumber}}ను అన్‌బ్లాక్ చేయి`,
      numberUnblocked: `{{formattedPhoneNumber}} అన్‌బ్లాక్ చేయబడింది`,
      confirmUnblock: {
        title: `{{formattedPhoneNumber}}ను అన్‌బ్లాక్ చేయాలా?`,
        message: `మీ PBX ఈ నంబర్ నుండి కాల్స్, టెక్స్ట్‌లు మరియు ఫ్యాక్స్‌లను మళ్లీ స్వీకరిస్తుంది.`,
        confirmText: `నంబర్‌ను అన్‌బ్లాక్ చేయి`,
        cancelText: `రద్దు చేయండి`,
      },
    },
    a11y: {
      messages: {
        senderContact: `కాంటాక్ట్`,
        senderYou: `మీరు`,
        senderTeam: `మీ బృందం`,
        messageMeta: `{{sender}}, {{time}}:`,
        newMessage: `{{sender}} నుండి కొత్త సందేశం: {{body}}`,
        newMessages: `{{sender}} నుండి {{count}} కొత్త సందేశాలు`,
        attachment: `జోడింపు`,
        messageSent: `సందేశం పంపబడింది`,
        messageFailed: `సందేశం పంపడం విఫలమైంది. మళ్లీ ప్రయత్నించవచ్చు.`,
        openImage: `చిత్రాన్ని తెరవండి {{name}}`,
        imageFrom: `{{sender}} నుండి చిత్రం`,
        downloadFile: `{{name}} డౌన్‌లోడ్ చేయండి`,
      },
      composer: {
        label: `సందేశం`,
        labelWithName: `{{name}}కు సందేశం`,
      },
      toast: {
        close: `మూసివేయండి`,
      },
      nav: {
        notificationCount: `{{count}} కొత్తవి`,
      },
      filterGroup: {
        text: `టెక్స్ట్ ఫిల్టర్`,
        voicemail: `వాయిస్‌మెయిల్ ఫిల్టర్`,
        fax: `ఫ్యాక్స్ ఫిల్టర్`,
        snippets: `స్నిప్పెట్ ఫిల్టర్`,
      },
      recipient: {
        label: `గ్రహీత పేరు లేదా నంబర్`,
        listLabel: `సూచించిన కాంటాక్ట్‌లు`,
        results: `కనుగొన్న కాంటాక్ట్‌లు: {{count}}`,
      },
    },

    messageInput: {
      statusMessage: {
        uploading: `అప్‌లోడ్ చేస్తోంది...`,
        failedToUpload: `అప్‌లోడ్ చేయడంలో విఫలమైంది`,
      },
      attachMedia: `మీడియాను జోడించండి`,
      addSnippet: `స్నిప్పెట్‌ను జోడించండి`,
      emojis: `ఎమోజీలు 😃`,
      sendText: `టెక్స్ట్ పంపండి`,
      inputPlaceholder: `ఇక్కడ సందేశం పంపండి`,
      retry: `మళ్ళీ ప్రయత్నించండి`,
    },

    messagingPage: {
      emptyDetailViewMessage: `ఏ థ్రెడ్ ఎంచుకోబడలేదు`,
      errorToastMessage: `తప్పిన ఫోన్ నంబర్`,
      textPlaceholder: {
        receivedFile: `ఫైల్ స్వీకరించబడింది`,
        fileSent: `ఫైల్ పంపబడింది`,
      },
      subheadingText: `{{phoneNumber, phone}} నుండి`,
    },

    newFaxModal: {
      header: `కొత్త ఫ్యాక్స్`,
      footer: {
        sendButtonText: `పంపండి`,
      },
      loadingView: {
        sendingFax: `ఫ్యాక్స్ పంపుతోంది...`,
      },
    },

    newFaxForm: {
      dropdownPlaceholder: `నుండి...`,
      textAreaPlaceholder: `కవర్ పేజీ గమనికను నమోదు చేయండి`,
      switchText: {
        includeCoverPage: `కవర్ పేజీని చేర్చండి`,
        sendEmailConfirmation: `ఇమెయిల్ నిర్ధారణ పంపండి`,
      },
      dropzonePlaceholder: `మీరు 25mb వరకు ఫ్యాక్స్‌లను పంపవచ్చు`,
      tagInputPlaceholder: `ఇమెయిల్ చిరునామాను నమోదు చేసి "Enter" నొక్కండి`,
      tagInputGuideText: `మీరు {{maxEmailConfirmations}} వరకు ఇమెయిల్ చిరునామాలను సమర్పించవచ్చు`,
      coverPageNoteLabel: `కవర్ పేజీ గమనిక`,
      emailConfirmationsLabel: `నిర్ధారణ ఇమెయిల్‌లు`,
      emailValueType: `ఇమెయిల్`,
    },

    sizeGauge: {
      totalSize: `మొత్తం పరిమాణం: {{totalSize}} / {{sizeLimit}}`,
      exceededSize: `{{exceededSize}} ద్వారా మించిపోయింది`,
    },

    contentDefault: {
      placeholder: `ఫైల్‌ను ఇక్కడ లాగి వదలండి, లేదా బ్రౌజ్ చేయడానికి క్లిక్ చేయండి`,
    },

    contentAcceptedMulti: {
      previewFile: `{{fileName}}ని ప్రివ్యూ చేయండి`,
      removeFile: `{{fileName}}ని తీసివేయండి`,
      fileRemoved: `{{fileName}} తీసివేయబడింది`,
      moveUp: `{{fileName}}ని పైకి తరలించండి`,
      moveDown: `{{fileName}}ని కిందికి తరలించండి`,
      fileMoved: `{{fileName}} {{total}}లో {{position}}వ స్థానానికి తరలించబడింది`,
      possibleDuplicate: `సంభావ్య నకిలీ`,
      tooLarge: `చాలా పెద్దది`,
      possibleDuplicateAndTooLarge: `సంభావ్య నకిలీ మరియు చాలా పెద్దది`,
      fileWithStatus: `{{file}} – {{status}}`,
    },

    newThreadModal: {
      header: {
        newThread: `కొత్త థ్రెడ్`,
        noGroupFound: `ఏ సమూహం కనుగొనబడలేదు`,
      },
      sendButtonText: `పంపండి`,
      contactText1: `ఈ ఎక్స్‌టెన్షన్ మెసేజింగ్ సమూహంలో భాగం కాదు.`,
      contactText2: `{{adminUrl}}కు వెళ్లి మీ మెసేజింగ్ సమూహాన్ని సెటప్ చేయండి, లేదా మీ మ్యాంగో అడ్మినిస్ట్రేటర్‌ను సంప్రదించండి`,
      contactLinkText: `మెసేజింగ్ సమూహం అంటే ఏమిటి?`,
      placeholder: `మీ సందేశం`,
    },

    deleteConfirmModal: {
      title: `వాయిస్‌మెయిల్‌ను తొలగించాలా?`,
      message: `ఇది శాశ్వతమైనది మరియు రద్దు చేయబడదు.`,
      deleteButton: `తొలగించు`,
      cancelButton: `రద్దు చేయండి`,
    },

    confirmModal: {
      defaultTitle: `మీరు ఖచ్చితంగా ఉన్నారా?`,
      confirmDeleteVoicemail: `ఈ వాయిస్‌మెయిల్‌ను తొలగించడం శాశ్వతమైనది మరియు రద్దు చేయబడదు.`,
      dontAskAgain: `మళ్లీ అడగవద్దు`,
    },

    emptySearch: {
      shoot: `అయ్యో.`,
      nothingIsMatching: `ఏదీ సరిపోలడం లేదు`,
      didYouSpellItRight: `మీరు సరిగ్గా స్పెల్లింగ్ చేశారా?`,
    },

    listItem: {
      unreadStatus: `చదవనిది`,
      markedAsUnread: `చదవనిదిగా గుర్తించబడింది`,
      markedAsRead: `చదివినదిగా గుర్తించబడింది`,
    },

    messageThreadHeader: {
      rename: `పేరు మార్చండి`,
      cancel: `రద్దు చేయండి`,
      threadNameLabel: `థ్రెడ్ పేరు`,
    },

    dropZoneMappings: {
      fileToLarge: {
        title: `ఫైల్ చాలా పెద్దది`,
        description: `మీరు అప్‌లోడ్ చేయడానికి ప్రయత్నిస్తున్న ఫైల్ చాలా పెద్దదిగా ఉంది. గరిష్ట ఫైల్ పరిమాణం {{maxFileSize}}MB`,
      },
      fileInvalidType: {
        link: `మరింత తెలుసుకోండి`,
        title: `మద్దతు లేని ఫైల్ రకం`,
        faxDescription: `ఆ ఫైల్ మద్దతు లేని ఫైల్ రకంలా ఉంది. మద్దతు ఉన్న ఫైల్ రకాల గురించి {{link}}`,
        description: `ఆ ఫైల్ మద్దతు లేని ఫైల్ రకంలా ఉంది. {{urlLink}} వద్ద మద్దతు ఉన్న ఫైల్ రకాల గురించి మరింత తెలుసుకోండి`,
      },
      fileUploadFailed: {
        title: `అప్‌లోడ్ విఫలమైంది`,
        description: `మీరు అప్‌లోడ్ చేయడానికి ప్రయత్నిస్తున్న ఫైల్ అప్‌లోడ్ చేయడంలో విఫలమైనట్లు కనిపిస్తోంది. దయచేసి మళ్లీ ప్రయత్నించండి.`,
      },
      general: {
        title: `ఊహించని లోపం సంభవించింది`,
        description: `ఊహించని లోపం సంభవించింది, దయచేసి మళ్లీ ప్రయత్నించండి.`,
      },
    },

    messageThreads: {
      emptyState: {
        title: `టెక్స్ట్‌లు లేవు`,
        subtitle1: `మీరు ఇంకా ఏ టెక్స్ట్‌లను పంపలేదు లేదా స్వీకరించలేదు`,
        subtitle2: `ప్రారంభించడానికి ఒక టెక్స్ట్ పంపండి`,
      },
      searchPlaceholder: `పేరు లేదా నంబర్‌ను శోధించండి`,
      searchLabel: `సందేశాలను వెతకండి`,
      allGroups: `అన్ని సమూహాలు`,
      new: `{{count}} కొత్తవి - అన్నీ చూడండి`,
      markAllRead: `అన్నీ చదివినట్లు గుర్తించండి`,
      buttonText: `కొత్త టెక్స్ట్`,
    },

    phoneOptions: {
      recent: `ఇటీవలి`,
      missed: `తప్పినవి`,
    },

    chatOptions: {
      recent: `ఇటీవలి`,
      unread: `చదవనివి`,
    },

    snippetOptions: {
      pbx: `PBX`,
      personal: `వ్యక్తిగత`,
    },

    chatMenu: {
      label: `స్నిప్పెట్స్`,
      settings: `స్నిప్పెట్ సెట్టింగ్‌లు`,
    },

    phoneMenu: {
      label: `ఆటో ఆన్సర్`,
    },

    generalMenu: {
      label: `అభిప్రాయాన్ని పంపండి`,
    },

    experimentsMenu: {
      label: `వెబ్ ఫోన్`,
    },

    developMenu: {
      notifications: `నోటిఫికేషన్లు`,
      contacts: `కాంటాక్ట్స్`,
    },

    callState: {
      inboundAnswered: `ఇన్‌బౌండ్ సమాధానమిచ్చారు`,
      outboundAnswered: `అవుట్‌బౌండ్ సమాధానమిచ్చారు`,
      inboundMissedOrDeclined: `ఇన్‌బౌండ్ తప్పినవి లేదా తిరస్కరించినవి`,
      outboundMissedOrDeclined: `అవుట్‌బౌండ్ తప్పినవి లేదా తిరస్కరించినవి`,
    },

    voicemailState: {
      received: `ఒక వాయిస్‌మెయిల్ స్వీకరించబడింది`,
      sent: `మీరు ఒక వాయిస్‌మెయిల్ పంపారు`,
    },

    voicemailOptions: {
      recent: `ఇటీవలి`,
      unread: `చదవనివి`,
    },

    mangoPhoneTypes: {
      mobile: `మొబైల్`,
      work: `పని`,
      home: `ఇల్లు`,
    },

    mangoContactTypes: {
      mango: `మ్యాంగో వాయిస్`,
    },

    markReadModal: {
      header: `జాగ్రత్త - అన్నీ చదివినట్లు గుర్తించండి`,
      message: `అన్ని థ్రెడ్‌లను చదివినట్లు గుర్తించడం రద్దు చేయబడదు`,
      confirmText: `మీరు ఖచ్చితంగా ఉన్నారా?`,
      confirmButton: `ధృవీకరించు`,
    },

    faxViewList: {
      titleNoFaxes: `ఫ్యాక్స్‌లు లేవు`,
      titleNoMatchingFaxes: `సరిపోలే ఫ్యాక్స్‌లు లేవు`,
      subtitleTryRemovingFilters: `కొన్ని ఫిల్టర్‌లను తీసివేయడానికి ప్రయత్నించండి`,
      subtitleNoFaxes: `మీ వద్ద ఏ ఫ్యాక్స్‌లు లేనట్లు కనిపిస్తోంది.`,
      buttonTextStartFax: `ఒక ఫ్యాక్స్ ప్రారంభించండి`,
      buttonTextStartFirstFax: `మీ మొదటి ఫ్యాక్స్ ప్రారంభించండి`,
      searchPlaceholder: `పేరు లేదా నంబర్‌ను శోధించండి`,
      searchLabel: `ఫ్యాక్స్‌లను వెతకండి`,
      status: {
        failed: `విఫలమైంది`,
        pending: `ప్రాసెస్ అవుతోంది`,
        sent: `పంపబడింది`,
        received: `స్వీకరించబడింది`,
        unknown: `తెలియదు`,
      },
    },

    pdfToolbar: {
      print: `ముద్రించు`,
      download: `డౌన్‌లోడ్ చేయండి`,
      openInNewTab: `కొత్త ట్యాబ్‌లో తెరవండి`,
      firstPage: `మొదటి పేజీ`,
      previousPage: `మునుపటి పేజీ`,
      nextPage: `తదుపరి పేజీ`,
      lastPage: `చివరి పేజీ`,
      rotate: `తిప్పండి`,
      pageStatus: `{{pages}}లో పేజీ {{pageNumber}}`,
    },

    toolbar: {
      clearAll: `అన్నీ క్లియర్ చేయండి`,
      potentialDuplicates: `సంభావ్య నకిలీలు`,
    },

    call: {
      toast: {
        callDeclined: `{{context}} నుండి కాల్ తిరస్కరించబడింది`,
        callEnded: `{{context}}తో కాల్ ముగిసింది`,
        callHeld: `{{context}}తో కాల్ హోల్డ్‌లో ఉంచబడింది`,
        callParked: `{{callName}} {{parkingLotName}}కు బదిలీ చేయబడింది`,
        callParkFailed: `{{callName}}ని {{parkingLotName}}లో పార్క్ చేయడం విఫలమైంది`,
        callTargetUndialable: `{{target}}కి కాల్ చేయలేరు - నంబర్‌ను తనిఖీ చేసి మళ్లీ ప్రయత్నించండి`,
        callTransferred: `{{callName}} {{transferToName}}కు బదిలీ చేయబడింది`,
        callTransferFailed: `{{callName}}ని {{transferToName}}కి బదిలీ చేయడం విఫలమైంది`,
        callUnavailable: `ఫోన్ డిస్‌కనెక్ట్ అయింది - కాల్ చేయడం సాధ్యం కాలేదు`,
      },
    },

    incomingCallModal: {
      newCallFrom: `నుండి కొత్త కాల్`,
      rejectCall: `కాల్ తిరస్కరించండి`,
      acceptCall: `కాల్ అంగీకరించండి`,
      endAndAccept: `ముగించి అంగీకరించండి`,
      holdAndAccept: `హోల్డ్ చేసి అంగీకరించండి`,
      parkAndAccept: `పార్క్ చేసి అంగీకరించండి`,
    },

    popupCallButtons: {
      accept: `అంగీకరించు`,
      reject: `తిరస్కరించు`,
      endAndAccept: `ముగించి అంగీకరించు`,
      holdAndAccept: `హోల్డ్ చేసి అంగీకరించు`,
      parkAndAccept: `పార్క్ చేసి అంగీకరించు`,
      switch: `మార్చు`,
      resume: `కొనసాగించు`,
      end: `ముగించు`,
      tooltip: {
        accept: `వచ్చే కాల్‌ను అంగీకరించు`,
        reject: `వచ్చే కాల్‌ను తిరస్కరించు`,
        endAndAccept: `ప్రస్తుత కాల్‌ను ముగించి వచ్చే కాల్‌ను అంగీకరించు`,
        holdAndAccept: `ప్రస్తుత కాల్‌ను హోల్డ్‌లో ఉంచి వచ్చే కాల్‌ను అంగీకరించు`,
        parkAndAccept: `ప్రస్తుత కాల్‌ను పార్క్ చేసి వచ్చే కాల్‌ను అంగీకరించు`,
        switch: `ఈ కాల్‌కు మార్చు`,
        resume: `ఈ కాల్‌ను కొనసాగించు`,
        end: `ఈ కాల్‌ను ముగించు`,
      },
    },

    callStatus: {
      deskPhone: `డెస్క్ ఫోన్`,
      onHold: `హోల్డ్‌లో`,
      ringing: `రింగింగ్`,
      connected: `కనెక్ట్ అయింది`,
      connecting: `కనెక్ట్ అవుతోంది`,
      ready: `సిద్ధంగా ఉంది`,
      dialing: `డయల్ చేస్తోంది...`,
      reconnecting: `మళ్లీ కనెక్ట్ అవుతోంది...`,
      onDeskPhone: `డెస్క్ ఫోన్‌లో`,
      connectedWithDuration: `కనెక్ట్ అయింది {{duration}}`,
      shortDial: `డయల్`,
      shortRing: `రింగ్`,
      shortHold: `హోల్డ్`,
      shortConn: `కనెక్ట్`,
      shortDesk: `డెస్క్`,
    },

    callAnnouncements: {
      incomingCall: `{{name}}, {{number}} నుండి ఇన్‌కమింగ్ కాల్`,
      incomingCallNameOnly: `{{name}} నుండి ఇన్‌కమింగ్ కాల్`,
      connected: `కనెక్ట్ అయింది`,
      onHold: `హోల్డ్‌లో ఉంది`,
      resumed: `కాల్ కొనసాగింది`,
      muted: `మ్యూట్ చేయబడింది`,
      unmuted: `అన్‌మ్యూట్ చేయబడింది`,
      callEnded: `కాల్ ముగిసింది`,
      answerFailed: `కాల్‌కు సమాధానం ఇవ్వలేకపోయాం`,
      holdFailed: `కాల్‌ను హోల్డ్‌లో ఉంచలేకపోయాం`,
      resumeFailed: `కాల్‌ను కొనసాగించలేకపోయాం`,
    },

    callSoundIndicator: {
      onHold: `హోల్డ్‌లో`,
      muted: `మ్యూట్`,
      reconnecting: `మళ్లీ కనెక్ట్ అవుతోంది`,
    },

    popup: {
      tabs: {
        inboundCalls: `ఇన్‌బౌండ్ కాల్స్`,
        messages: `సందేశాలు`,
      },
      emptyStates: {
        noCalls: {
          title: `కాల్స్ కనుగొనబడలేదు`,
          description: `ప్రస్తుతం ఇన్‌బౌండ్ కాల్స్ అందుబాటులో లేవు`,
        },
        noActiveCalls: `యాక్టివ్ కాల్స్ లేవు`,
        noMessages: {
          title: `సందేశాలు కనుగొనబడలేదు`,
          description: `ప్రస్తుతం సందేశాలు అందుబాటులో లేవు`,
        },
      },
      footer: {
        poweredByMango: `Mango Voice ద్వారా అందించబడింది`,
      },
      callButtons: {
        deskPhoneActive: `డెస్క్ ఫోన్‌లో కాల్ యాక్టివ్‌గా ఉంది`,
        dismiss: `తీసివేయండి`,
      },
      callItem: {
        unknownCaller: `తెలియని కాలర్`,
        unknownNumber: `తెలియని నంబర్`,
        onHold: `హోల్డ్‌లో`,
        pageIntercom: `పేజ్/ఇంటర్కామ్`,
        callDetails: `కాల్ వివరాలు`,
      },
      messageButtons: {
        dismiss: `తీసివేయండి`,
        openMessage: `సందేశాన్ని తెరవండి`,
      },
      personCard: {
        patientFile: `పేషెంట్ ఫైల్`,
        fullName: `పూర్తి పేరు`,
        dateOfBirth: `పుట్టిన తేదీ`,
        patientNumber: `పేషెంట్ నంబర్`,
        inboundNumber: `ఇన్‌బౌండ్ నంబర్`,
        extension: `పొడిగింపు`,
        defaultLocation: `డిఫాల్ట్ లొకేషన్`,
        nextAppointment: `తదుపరి అపాయింట్‌మెంట్`,
        previousAppointment: `మునుపటి అపాయింట్‌మెంట్`,
        insurance: `బీమా`,
        balance: `బ్యాలెన్స్`,
      },
      header: {
        expand: `విస్తరించండి`,
        minimize: `కుదించండి`,
        dismiss: `తీసివేయండి`,
        logoAlt: `లోగో`,
      },
    },

    faxPage: {
      toast: {
        copyLinkSuccess: `క్లిప్‌బోర్డ్‌కు లింక్ కాపీ చేయబడింది`,
        copyLinkError: `క్లిప్‌బోర్డ్‌కు లింక్ కాపీ చేయడంలో విఫలమైంది.`,
        sendSuccess: `మీ ఫ్యాక్స్ క్యూకు జోడించబడింది మరియు త్వరలో పంపబడుతుంది`,
        sendError: `మీ ఫ్యాక్స్ పంపడంలో సమస్య ఉంది. దయచేసి మళ్లీ ప్రయత్నించండి`,
        deleteSuccess: `ఫ్యాక్స్ విజయవంతంగా తొలగించబడింది`,
        deleteError: `ఈ ఫ్యాక్స్ తొలగించడంలో సమస్య ఉంది. దయచేసి మళ్లీ ప్రయత్నించండి`,
        unexpectedError: `ఊహించని లోపం సంభవించింది`,
      },
      confirmDelete: {
        title: `ఫ్యాక్స్‌ను తొలగించు`,
        message: `మీరు ఖచ్చితంగా ఈ ఫ్యాక్స్‌ను తొలగించాలనుకుంటున్నారా?`,
        button: `తొలగించు`,
        cancel: `రద్దు చేయండి`,
      },
      confirmResend: {
        title: `ఫ్యాక్స్‌ను మళ్లీ పంపు`,
        message: `మీరు ఖచ్చితంగా ఈ ఫ్యాక్స్‌ను మళ్లీ పంపాలనుకుంటున్నారా?`,
        button: `మళ్లీ పంపు`,
        cancel: `రద్దు చేయండి`,
      },
      emptyStateMessage: `ఏ ఫ్యాక్స్ ఎంచుకోబడలేదు`,
      status: {
        queued: `క్యూలో ఉంది`,
        received: `స్వీకరించబడింది`,
        sent: `పంపబడింది`,
      },
      direction: {
        to: `కు`,
        from: `నుండి`,
      },
      detailsHeader: {
        status: `{{statusDate}} నాడు {{statusTime}}కు {{directionText}} {{statusPrefix}}`,
      },
    },

    secureFaxPage: {
      logoAlt: `Mango Voice logo`,
      loading: {
        title: `సెక్యూర్ ఫ్యాక్స్ లింక్‌ను తనిఖీ చేస్తోంది`,
        description: `మేము ఈ సెక్యూర్ ఫ్యాక్స్ లింక్‌ను ధృవీకరించే వరకు దయచేసి వేచి ఉండండి.`,
      },
      password: {
        title: `సెక్యూర్ ఫ్యాక్స్ యాక్సెస్`,
        description: `ఈ సెక్యూర్ ఫ్యాక్స్‌ను యాక్సెస్ చేయడానికి సెక్యూర్ ఫ్యాక్స్ పాస్‌వర్డ్‌ను నమోదు చేయండి.`,
        label: `సెక్యూర్ ఫ్యాక్స్ పాస్‌వర్డ్`,
        placeholder: `పాస్‌వర్డ్ నమోదు చేయండి`,
        submitButton: `సెక్యూర్ ఫ్యాక్స్‌ను చూడండి`,
        submittingButton: `పాస్‌వర్డ్ ధృవీకరిస్తోంది...`,
      },
      errors: {
        password_required: `పాస్‌వర్డ్ అవసరం.`,
        invalid_password: `మీరు నమోదు చేసిన పాస్‌వర్డ్ తప్పు.`,
        s3_error: `సెక్యూర్ ఫ్యాక్స్ ప్రివ్యూను సిద్ధం చేయడం సాధ్యపడలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.`,
        throttled: `చాలా ఎక్కువ అభ్యర్థనలు. దయచేసి కాసేపు వేచి ఉండి మళ్లీ ప్రయత్నించండి.`,
        unknown: `ఏదో తప్పు జరిగింది. దయచేసి మళ్లీ ప్రయత్నించండి.`,
        attemptsRemaining: `మిగిలిన ప్రయత్నాలు: {{count}}`,
      },
      status: {
        expired: {
          title: `లింక్ గడువు ముగిసింది`,
          description: `ఈ సెక్యూర్ ఫ్యాక్స్ లింక్ గడువు ముగిసింది. దయచేసి కొత్త సెక్యూర్ ఫ్యాక్స్ లింక్‌ను అభ్యర్థించండి.`,
        },
        disabled: {
          title: `లింక్ నిలిపివేయబడింది`,
          description: `ఈ సెక్యూర్ ఫ్యాక్స్ లింక్ నిలిపివేయబడింది.`,
        },
        not_found: {
          title: `లింక్ కనుగొనబడలేదు`,
          description: `మేము ఈ సెక్యూర్ ఫ్యాక్స్ లింక్‌ను కనుగొనలేకపోయాము.`,
        },
        max_downloads_reached: {
          title: `డౌన్‌లోడ్ పరిమితి చేరుకుంది`,
          description: `ఈ సెక్యూర్ ఫ్యాక్స్ లింక్ గరిష్ట డౌన్‌లోడ్‌ల సంఖ్యను చేరుకుంది.`,
        },
        too_many_attempts: {
          title: `చాలా ఎక్కువ ప్రయత్నాలు`,
          description: `చాలా ఎక్కువ పాస్‌వర్డ్ ప్రయత్నాల తర్వాత ఈ సెక్యూర్ ఫ్యాక్స్ లింక్ లాక్ చేయబడింది.`,
        },
        throttled: {
          title: `చాలా ఎక్కువ అభ్యర్థనలు`,
          description: `ఈ లింక్ కోసం చాలా ఎక్కువ అభ్యర్థనలు చేయబడ్డాయి. దయచేసి కాసేపటి తర్వాత మళ్లీ ప్రయత్నించండి.`,
        },
        unknown: {
          title: `సెక్యూర్ ఫ్యాక్స్‌ను లోడ్ చేయడం సాధ్యపడలేదు`,
          description: `మేము ఈ సెక్యూర్ ఫ్యాక్స్ లింక్‌ను ధృవీకరించలేకపోయాము.`,
        },
        actions: {
          checkAgain: `మళ్లీ తనిఖీ చేయండి`,
        },
      },
      download: {
        title: `సెక్యూర్ ఫ్యాక్స్ సిద్ధంగా ఉంది`,
        description: `మీ సెక్యూర్ ఫ్యాక్స్ సిద్ధంగా ఉంది. ఈ డౌన్‌లోడ్ లింక్ గడువు త్వరలో ముగుస్తుంది, కాబట్టి ఇప్పుడే డౌన్‌లోడ్ చేయండి.`,
        detailsTitle: `ఫ్యాక్స్ వివరాలు`,
        fromLabel: `నుండి`,
        toLabel: `కు`,
        receivedLabel: `స్వీకరించబడింది`,
        downloadsRemainingLabel: `మిగిలిన డౌన్‌లోడ్‌లు`,
        actions: {
          download: `ఫ్యాక్స్ డౌన్‌లోడ్ చేయండి`,
          openInNewTab: `కొత్త ట్యాబ్‌లో తెరవండి`,
          tryAnotherPassword: `మరో పాస్‌వర్డ్ ప్రయత్నించండి`,
        },
        fetchError: {
          title: `ప్రివ్యూను లోడ్ చేయలేకపోయాము`,
          description: `డౌన్‌లోడ్ లింక్ నుండి సెక్యూర్ ఫ్యాక్స్ ప్రివ్యూను లోడ్ చేయలేకపోయాము.`,
          retryPreview: `ప్రివ్యూను మళ్లీ ప్రయత్నించండి`,
          generic: `సెక్యూర్ ఫ్యాక్స్ ప్రివ్యూను లోడ్ చేయడంలో విఫలమైంది.`,
        },
      },
    },

    voicemail: {
      emptyState: {
        title: `వాయిస్‌మెయిల్స్ లేవు`,
        subtitle1: `మీరు మీ అన్ని కాల్స్‌కు సమాధానమిస్తున్నట్లు కనిపిస్తోంది. మంచి పనిని కొనసాగించండి!`,
        subtitle2: `మీరు వాయిస్‌మెయిల్స్ మిస్ అవుతున్నారని భావిస్తే, దయచేసి మా మద్దతు బృందాన్ని సంప్రదించండి.`,
        buttonText: `మద్దతును సంప్రదించండి`,
      },
      searchPlaceholder: `కాలర్ పేరు లేదా నంబర్ కోసం శోధించండి`,
      searchLabel: `వాయిస్‌మెయిల్‌ను వెతకండి`,
      emptyDetailViewMessage: `ఏ వాయిస్‌మెయిల్ ఎంచుకోబడలేదు`,

      mangoModal: {
        title: `తరలించు`,
        headerText: `వాయిస్‌మెయిల్‌ను తరలించు`,
        cancelButtonText: `రద్దు చేయండి`,
        moveButtonText: `వాయిస్‌మెయిల్‌ను తరలించు`,
        selectVoicemailBoxText: `వాయిస్‌మెయిల్ బాక్స్‌ను ఎంచుకోండి...`,
        markAsUnreadText: `ఎంచుకున్న బాక్స్‌లో చదవనిదిగా గుర్తించండి`,
        destinationBoxText: `గమ్యస్థాన వాయిస్‌మెయిల్ బాక్స్`,
        destinationBoxWarning: `గమ్యస్థాన వాయిస్‌మెయిల్ బాక్స్‌కు మీకు యాక్సెస్ లేకపోతే ఈ వాయిస్‌మెయిల్ అందుబాటులో ఉండదు.`,
      },

      detailView: {
        headerSubheadingText: `నుండి`,
        headerSubheadingToText: `కు`,
        audioPlayerTitle: `వాయిస్‌మెయిల్ ఆడియో`,
        transcriptionText: `ట్రాన్స్క్రిప్షన్`,
      },

      loadingText: `వాయిస్‌మెయిల్`,
      transcriptionTitleText: `ట్రాన్స్క్రిప్షన్`,

      move: {
        error: `వాయిస్‌మెయిల్‌ను తరలించేటప్పుడు లోపం సంభవించింది.`,
        success: `వాయిస్‌మెయిల్ విజయవంతంగా తరలించబడింది`,
        successMarkAsUnread: `వాయిస్‌మెయిల్ విజయవంతంగా తరలించబడింది మరియు చదవనిదిగా గుర్తించబడింది`,
        successMarkAsRead: `వాయిస్‌మెయిల్ విజయవంతంగా తరలించబడింది`,
      },

      filter: {
        all: `అన్నీ`,
        unread: `చదవనివి`,
        allInboxes: `అన్ని ఇన్‌బాక్స్‌లు`,
      },

      tooltip: {
        move: `తరలించు`,
        delete: `తొలగించు`,
        markAsUnread: `చదవనిదిగా గుర్తించు`,
        markAsRead: `చదివినట్లుగా గుర్తించు`,
        blockNumber: `నంబర్‌ను నిరోధించు`,
        unblockNumber: `నంబర్‌ను అన్‌బ్లాక్ చేయి`,
        copyLink: `క్లిప్‌బోర్డ్‌కు లింక్‌ను కాపీ చేయండి`,
        editContact: `కాంటాక్ట్‌ను సవరించు`,
        newCall: `కొత్త కాల్`,
        newText: `కొత్త టెక్స్ట్`,
        resendFax: `ఫ్యాక్స్‌ను మళ్లీ పంపు`,
        moveFax: `ఫ్యాక్స్‌ను తరలించు`,
        newFax: `కొత్త ఫ్యాక్స్`,
        close: `మూసివేయండి`,
      },

      copyLinkError: `క్లిప్‌బోర్డ్‌కు లింక్ కాపీ చేయడంలో విఫలమైంది.`,
    },

    audioPlayer: {
      rewind10s: `10సె వెనుకకు తిప్పండి`,
      play: `ప్లే చేయండి`,
      pause: `పాజ్ చేయండి`,
      mute: `మ్యూట్ చేయండి`,
      unmute: `అన్‌మ్యూట్ చేయండి`,
      fastForward10s: `10సె ముందుకు తిప్పండి`,
      jumpToAnswer: `సమాధానానికి వెళ్లండి`,
      changePlaybackSpeed: `ప్లేబ్యాక్ వేగాన్ని మార్చండి`,
      downloadAudio: `ఆడియోను డౌన్‌లోడ్ చేయండి`,
      seeKeyboardShortcuts: `కీబోర్డ్ షార్ట్‌కట్‌లను చూడండి`,
      mediaError: `ఈ ఆడియో ఫైల్‌ను లోడ్ చేయడంలో సమస్య ఉంది.`,
      noAudio: `రికార్డింగ్ అందుబాటులో లేదు`,
      playbackPosition: `ప్లేబ్యాక్ స్థానం`,
      playbackPositionValue: `{{duration}}లో {{position}}`,
    },

    fax: {
      filter: {
        all: `అన్నీ`,
        unread: `చదవనివి`,
        allInboxes: `అన్ని ఇన్‌బాక్స్‌లు`,
        sent: `పంపబడినవి`,
        received: `స్వీకరించబడినవి`,
      },
      tooltip: {
        pending: `ఈ ఫ్యాక్స్ ప్రాసెస్ అవుతోంది మరియు త్వరలో పంపబడుతుంది`,
      },
    },

    pbxPrompt: {
      loggingIn: `లాగిన్ అవుతోంది...`,
      loadingPbxs: `PBXలు లోడ్ అవుతున్నాయి...`,
      selectPbx: `మీ PBXని ఎంచుకోండి`,
      noPbxMessage: `మీరు ప్రస్తుతం ఏ ఫోన్ సిస్టమ్ (PBX)లో సభ్యులు కాదు. ఈ యాప్‌ను ఉపయోగించడానికి, దయచేసి మీ కార్యాలయంలో ఫోన్ సిస్టమ్‌ను నిర్వహించే వ్యక్తిని సంప్రదించండి మరియు మిమ్మల్ని జోడించమని అడగండి.`,
      noPbxErrorMessage: `ఇది పొరపాటు అని మీరు విశ్వసిస్తే, మరింత సహాయం కోసం Mango సపోర్ట్‌ని సంప్రదించండి.`,
      callSupport: `సపోర్ట్‌కి కాల్ చేయండి`,
      emailSupport: `సపోర్ట్‌కి ఇమెయిల్ పంపండి`,
      back: `వెనుకకు`,
      errorTitle: `అయ్యో! ఏదో తప్పు జరిగింది.`,
      errorMessage: `దయచేసి మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌ని సంప్రదించండి.`,
    },

    pbxPicker: {
      searchPlaceholder: `PBXలు శోధించండి...`,
      current: `ప్రస్తుత`,
      recent: `ఇటీవలి`,
      allPbxs: `అన్ని PBXలు`,
      searchResults: `శోధన ఫలితాలు`,
      noResults: `PBXలు కనుగొనబడలేదు`,
      searchPrompt: `పేరు ద్వారా PBX కోసం శోధించండి`,
      switchPbx: `PBX మార్చండి`,
      count: `{{count}} PBXలు`,
      countFiltered: `{{count}} PBXలు కనుగొనబడ్డాయి`,
    },

    pbxHeaderSwitcher: {
      selectPbx: `PBX ఎంచుకోండి`,
      ariaLabel: `PBX మార్చండి`,
    },

    loginPrompt: {
      loginFailedError: `లాగిన్ విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.`,
      invalidEmail: `చెల్లని ఇమెయిల్ చిరునామా!`,
      enterUsername: `దయచేసి యూజర్‌నేమ్ నమోదు చేయండి`,
      enterPassword: `దయచేసి పాస్‌వర్డ్ నమోదు చేయండి`,
      invalidCredentials: `చెల్లని యూజర్‌నేమ్ లేదా పాస్‌వర్డ్, దయచేసి మీ ఆధారాలను తనిఖీ చేసి మళ్లీ ప్రయత్నించండి.`,
      usernamePlaceholder: `ఇమెయిల్ / యూజర్‌నేమ్`,
      passwordPlaceholder: `పాస్‌వర్డ్`,
      logIn: `లాగిన్`,
      forgotPassword: `మీ పాస్‌వర్డ్ మర్చిపోయారా?`,
      openSupportForm: `సహాయ ఫారమ్ తెరవండి`,
      backToLogin: `లాగిన్‌కు తిరిగి వెళ్ళండి`,
      showPassword: `పాస్‌వర్డ్ చూపించు`,
    },

    desktopAppBanner: {
      tryDesktopApp: `ఉత్తమ అనుభవం కోసం {{appName}} డెస్క్‌టాప్ యాప్‌ను ప్రయత్నించండి`,
      desktopAppName: `{{appName}} డెస్క్‌టాప్`,
      launchAppTooltip: `ఇన్‌స్టాల్ చేయబడితే డెస్క్‌టాప్ యాప్‌ను ప్రారంభించండి`,
      downloadAppTooltip: `డెస్క్‌టాప్ యాప్‌ను డౌన్‌లోడ్ చేయండి`,
      launchApp: `యాప్‌ను ప్రారంభించండి`,
      download: `డౌన్‌లోడ్`,
      settings: `సెట్టింగ్‌లు`,
      dontAskAgain: `మళ్ళీ అడగకండి`,
      remindMeLater: `తర్వాత గుర్తు చేయండి`,
      alwaysOpenHint: `లింక్‌లను ఎల్లప్పుడూ డెస్క్‌టాప్ యాప్‌లో తెరవడానికి, సెట్టింగ్‌లలో దీన్ని మార్చండి.`,
      launchConfirmTitle: `డెస్క్‌టాప్ యాప్‌లో తెరవండి`,
    },
    openApp: {
      title: `మీ డెస్క్‌టాప్ యాప్‌ను తెరుస్తోంది…`,
      subtitle: `మేము ఇప్పుడు యాప్‌ను ప్రారంభిస్తున్నాము. అది స్వయంచాలకంగా తెరవకపోతే, దిగువ బటన్‌ను ఉపయోగించండి.`,
      closeHint: `యాప్ తెరుచుకున్న తర్వాత మీరు ఈ ట్యాబ్‌ను మూసివేయవచ్చు.`,
      openButton: `డెస్క్‌టాప్ యాప్‌ను తెరవండి`,
      fallbackPrompt: `డెస్క్‌టాప్ యాప్ ఇన్‌స్టాల్ చేయలేదా?`,
      downloadButton: `డెస్క్‌టాప్ యాప్‌ను డౌన్‌లోడ్ చేయండి`,
    },

    openedInDesktop: {
      title: `మేము ఈ పేజీని డెస్క్‌టాప్ యాప్‌లో తెరవడానికి ప్రయత్నించాము`,
      subtitle: `{{appName}} డెస్క్‌టాప్ యాప్ తెరుచుకుంటే, మీరు ఈ ట్యాబ్‌ను మూసివేయవచ్చు.`,
      continueInBrowser: `బ్రౌజర్‌లో కొనసాగించండి`,
      tryAgain: `మళ్లీ ప్రయత్నించండి`,
      stopOpeningInDesktop: `డెస్క్‌టాప్ యాప్‌లో లింక్‌లను తెరవడం ఆపివేయండి`,
      settingsHint: `లింక్‌లను ఈ బ్రౌజర్‌లోనే ఉంచడానికి, <settingsLink>సెట్టింగ్‌లలో డెస్క్‌టాప్ యాప్‌ను</settingsLink> మార్చండి.`,
    },

    profileSettings: {
      myProfile: `నా ప్రొఫైల్`,
      editProfile: `ప్రొఫైల్‌ను సవరించండి`,
      name: `పేరు`,
      username: `యూజర్‌నేమ్`,
      email: `ఈమెయిల్`,
      openDesktopApp: `డెస్క్‌టాప్ యాప్‌ను తెరవండి`,
      launchDesktopApp: `డెస్క్‌టాప్ యాప్‌ను ప్రారంభించండి`,
      callSupport: `మద్దతుకు కాల్ చేయండి`,
      emailSupport: `మద్దతుకు ఇమెయిల్ చేయండి`,
      sendFeedback: `అభిప్రాయాన్ని పంపండి`,
      whatsNew: `కొత్తది ఏమిటి`,
      downloadApp: `యాప్‌ను డౌన్‌లోడ్ చేయండి`,
      logOut: `లాగ్ అవుట్ చేయండి`,
      needHelp: `సహాయం కావాలా?`,
      switchPbx: `PBX మార్చండి`,
      pbxName: `PBX పేరు`,
      darkMode: `డార్క్ మోడ్`,
      darkModeOptions: {
        light: `లైట్`,
        dark: `డార్క్`,
        system: `సిస్టమ్ సెట్టింగ్‌లను ఉపయోగించండి`,
      },
      language: `భాష`,
      desktopApp: {
        label: `డెస్క్‌టాప్ యాప్`,
        beta: `బీటా`,
        modeLabel: `నేను ఈ బ్రౌజర్‌లో {{appName}} లింక్‌ను తెరిచినప్పుడు`,
        modeHint: `ఈ సెట్టింగ్ ఈ బ్రౌజర్‌కు మాత్రమే వర్తిస్తుంది.`,
        modes: {
          ask: `నన్ను అడగండి (బ్యానర్ చూపించండి)`,
          always: `ఎల్లప్పుడూ డెస్క్‌టాప్ యాప్‌లో తెరవండి`,
          never: `అడగవద్దు`,
        },
        testLaunch: {
          title: `లింక్‌లను డెస్క్‌టాప్ యాప్‌లో తెరవండి`,
          question: `మేము {{appName}} డెస్క్‌టాప్ యాప్‌ను తెరవడానికి ప్రయత్నించాము. అది తెరుచుకుందా?`,
          yes: `అవును, తెరుచుకుంది`,
          no: `లేదు, తెరుచుకోలేదు`,
          notOpened: `లింక్‌లు ఈ బ్రౌజర్‌లోనే తెరుచుకుంటాయి. {{appName}} డెస్క్‌టాప్ యాప్‌ను ఇన్‌స్టాల్ చేసి, మళ్లీ ప్రయత్నించండి.`,
          tryAgain: `మళ్లీ ప్రయత్నించండి`,
          close: `మూసివేయండి`,
        },
      },
      switchPbxConfirmation: {
        title: `మీ ప్రస్తుత PBXని మార్చండి`,
        message: `మీరు తిరిగి మారే వరకు {{pbxName}} నుండి కాల్స్, టెక్స్ట్‌లు, ఫ్యాక్స్‌లు మరియు వాయిస్‌మెయిల్‌లు ఈ అప్లికేషన్‌లో అందుబాటులో ఉండవు.`,
        confirmText: `సరే`,
        cancelText: `రద్దు చేయండి`,
      },
      editMyProfile: {
        title: `నా ప్రొఫైల్‌ని సవరించండి`,
        update: `ప్రొఫైల్‌ను నవీకరించండి`,
        close: `మూసివేయండి`,
        firstName: `మొదటి పేరు`,
        lastName: `చివరి పేరు`,
        username: `వినియోగదారు పేరు`,
        email: `ఇమెయిల్`,
        errRequiredFirstName: `దయచేసి మొదటి పేరును నమోదు చేయండి.`,
        errRequiredLastName: `దయచేసి చివరి పేరును నమోదు చేయండి.`,
        successProfile: `ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది.`,
      },
    },

    pbxQuerySwitch: {
      confirm: {
        title: `ఈ PBXను సెట్ చేయాలా?`,
        message: `మీ PBXను {{pbxName}} గా సెట్ చేయాలనుకుంటున్నారా?`,
        confirmText: `PBX సెట్ చేయండి`,
        cancelText: `రద్దు చేయండి`,
      },
      warning: {
        invalid: {
          title: `చెల్లని PBX లింక్`,
          description: `PBX లింక్ చెల్లదు. దయచేసి Admin నుండి మళ్లీ ప్రయత్నించండి.`,
        },
        inaccessible: {
          title: `PBX మార్చలేము`,
          description: `ఆ PBXకు మీకు ప్రాప్యత లేదు.`,
        },
      },
    },

    languageSelector: {
      title: `భాష ప్రాధాన్యతలు`,
      selectLanguage: `భాషను ఎంచుకోండి`,
      autoDetect: `ఆటో-డిటెక్ట్ (సిస్టమ్ భాష)`,
      languages: {
        en: `ఆంగ్లం`,
        'en-US': `ఆంగ్లం (యునైటెడ్ స్టేట్స్)`,
        'en-GB': `ఆంగ్లం (యునైటెడ్ కింగ్‌డమ్)`,
        'en-CA': `ఆంగ్లం (కెనడా)`,
        es: `స్పానిష్`,
        'es-MX': `స్పానిష్ (మెక్సికో)`,
        'es-US': `స్పానిష్ (యునైటెడ్ స్టేట్స్)`,
        'fr-CA': `ఫ్రెంచ్ (కెనడా)`,
        ko: `కొరియన్`,
        ne: `నేపాలీ`,
        te: `తెలుగు`,
      },
    },

    snippetsSettings: {
      confirmationModal: {
        title: `మీరు ఖచ్చితంగా ఉన్నారా?`,
        message: `ఈ స్నిప్పెట్‌ను తొలగించడం శాశ్వతమైనది మరియు రద్దు చేయబడదు`,
        confirmText: `తొలగించు`,
        cancelText: `రద్దు చేయండి`,
      },
      errorWithTimeout: `ఏదో తప్పు జరిగింది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.`,
      headerText: `స్నిప్పెట్స్`,
      newButtonText: `కొత్త`,
      tooltipDelete: `తొలగించు`,
      editSnippetLabel: `స్నిప్పెట్ {{name}}ను సవరించు`,
      deleteSnippetLabel: `స్నిప్పెట్ {{name}}ను తొలగించు`,
      cancelEditing: `సవరణను రద్దు చేయండి`,
      dismissError: `లోపాన్ని తీసివేయండి`,
      editSnippet: `స్నిప్పెట్‌ను సవరించు`,
      newSnippet: `కొత్త స్నిప్పెట్`,
      shortcut: `షార్ట్‌కట్`,
      inputPlaceholder: `శుభోదయం`,
      shortcutGuideText: `ఒక పదం, ఖాళీలు లేవు. ఉదా: #good-morning లేదా #TestResults`,
      visibility: `దృశ్యమానత`,
      visibilityGuideText: `వ్యక్తిగత = మీరు మాత్రమే యాక్సెస్ చేయగలరు, కంపెనీ = ప్రతిఒక్కరూ యాక్సెస్ చేయగలరు`,
      editBodyInputPlaceholder: `ఇక్కడ ఒక ముందుగా తయారుచేసిన సందేశాన్ని వ్రాయండి. మీరు ఇమెయిల్‌లు, వెబ్ లింక్‌లు, ఫోన్ నంబర్‌లను జోడించవచ్చు...`,
      mangoButtonCancel: `రద్దు చేయండి`,
      mangoButtonSave: `సేవ్ చేయండి`,
      loadingSnippets: `స్నిప్పెట్స్‌ను లోడ్ చేస్తోంది...`,
      noSnippetsFound: `స్నిప్పెట్స్ ఏవీ కనుగొనబడలేదు`,
      body: `బాడీ`,
      personal: `వ్యక్తిగత`,
      filter: {
        all: `అన్నీ`,
        unread: `చదవనివి`,
        allInboxes: `అన్ని ఇన్‌బాక్స్‌లు`,
      },
    },

    phoneSettings: {
      incomingCalls: `ఇన్‌కమింగ్ కాల్స్`,
      showInboundC2CCalls: `ఇన్‌బౌండ్ C2C కాల్స్‌ను చూపించు`,
      playRingtone: `రింగ్‌టోన్ ప్లే చేయండి`,
      ringtone: `రింగ్‌టోన్`,
      respondWithBusyToSecondCall: `రెండవ కాల్‌కు బిజీతో ప్రతిస్పందించండి`,
      disabledInAgentMode: `ఏజెంట్ మోడ్ ప్రారంభించబడినప్పుడు అక్రియం చేయబడింది`,
      outgoingCalls: `అవుట్‌గోయింగ్ కాల్స్`,
      defaultOutboundPhone: `అవుట్‌బౌండ్ కాల్స్ కోసం డిఫాల్ట్ ఫోన్‌ను ఎంచుకోండి`,
      autoAnswer: `ఆటో ఆన్సర్`,
      enableCallerIdSelection: `కాలర్ ID ఎంపికను ప్రారంభించండి`,
      enableCallerIdSelectionDescription: `కాల్స్ చేసేటప్పుడు అవుట్‌గోయింగ్ ఫోన్ నంబర్‌ను ఎంచుకోవడానికి మిమ్మల్ని అనుమతిస్తుంది.`,
      callerId: `కాలర్ ID`,
      presence: `ఉనికి`,
      presenceDescription: `కింది విభాగాలు మీ వెబ్ ఫోన్‌లో ప్రదర్శించబడతాయి, ఇది మీకు ఎక్కువగా డయల్ చేసిన ఎక్స్‌టెన్షన్‌లు మరియు నంబర్‌లకు శీఘ్ర ప్రాప్యతను ఇస్తుంది.`,
      parkingSpotsDisplayed: `ప్రదర్శించబడిన పార్కింగ్ స్థలాలు (పరిమితి 5)`,
      removeParkingSpot: `పార్కింగ్ స్థలాన్ని తీసివేయండి`,
      addParkingSpot: `పార్కింగ్ స్థలాన్ని జోడించండి`,
      lineExtensionsDisplayed: `ప్రదర్శించబడిన లైన్ ఎక్స్‌టెన్షన్‌లు (పరిమితి 10)`,
      removeExtension: `ఎక్స్‌టెన్షన్‌ను తీసివేయండి`,
      addExtension: `ఎక్స్‌టెన్షన్‌ను జోడించండి`,
      speedDial: `స్పీడ్ డయల్ (పరిమితి {{maxSpeedDials}})`,
      editSpeedDial: `స్పీడ్ డయల్‌ను సవరించు`,
      removeSpeedDial: `స్పీడ్ డయల్‌ను తీసివేయండి`,
      addSpeedDial: `స్పీడ్ డయల్‌ను జోడించండి`,
      clickToCall: `కాల్ చేయడానికి క్లిక్ చేయండి`,
      sendToDeskPhone: `డెస్క్ ఫోన్‌కు పంపండి (యీలింక్)`,
      useWebPhone: `వెబ్ ఫోన్‌ను ఉపయోగించండి`,
    },

    phoneSettingItems: {
      selectExtension: `ఎక్స్‌టెన్షన్‌ను ఎంచుకోండి`,
      yourExtension: `మీ ఎక్స్‌టెన్షన్`,
      activateWebPhone: `వెబ్ ఫోన్‌ను యాక్టివేట్ చేయండి`,
      confirmationModal: {
        title: `లైన్ ఎక్స్‌టెన్షన్‌లు అందుబాటులో లేవు`,
        message1: `ఈ ఫోన్ సిస్టమ్‌లో ({{pbxName}}) మీకు ఏ లైన్ ఎక్స్‌టెన్షన్‌లు కేటాయించబడలేదు.`,
        message2: `ఫోన్ ఫీచర్‌ను ఉపయోగించడానికి, దయచేసి లైన్ ఎక్స్‌టెన్షన్‌ను కేటాయించడానికి మీ సిస్టమ్ అడ్మినిస్ట్రేటర్‌ను సంప్రదించండి.`,
        confirmText: `కొట్టివేయండి`,
        cancelText: `రద్దు చేయండి`,
      },
    },

    extensionSelector: {
      selectExtension: `కొత్త ఎక్స్‌టెన్షన్‌ను ఎంచుకోండి`,
      deactivateWebPhone: `వెబ్ ఫోన్‌ను డియాక్టివేట్ చేయండి`,
      none: `ఏదీకాదు`,
      confirmationModal: {
        title: `పరికరాన్ని అన్‌లింక్ చేయండి`,
        message: `ఈ పరికరం ఇకపై {{extensionName}} నుండి కాల్స్‌ను పంపదు లేదా స్వీకరించదు.`,
        confirmText: `సరే`,
        cancelText: `రద్దు చేయండి`,
      },
    },

    webPhone: {
      unknownCaller: `తెలియని కాలర్`,
      selectParkingSpot: `పార్కింగ్ స్పాట్‌ను ఎంచుకోండి`,
      receivingCalls: `కాల్‌లను స్వీకరిస్తున్నారు`,
      doNotDisturb: {
        title: `భంగం చేయవద్దు`,
        until: `{{time}} వరకు`,
        indefinite: `భంగం చేయవద్దు`,
        for30Minutes: `30 నిమిషాల పాటు భంగం చేయవద్దు`,
        for1Hour: `1 గంట పాటు భంగం చేయవద్దు`,
        for2Hours: `2 గంటల పాటు భంగం చేయవద్దు`,
        untilTomorrow: `రేపు వరకు భంగం చేయవద్దు`,
        turnOff: `భంగం చేయవద్దు ఆఫ్ చేయి`,
      },
      tooltip: {
        copied: `కాపీ చేయబడింది!`,
        copyCallerId: `కాలర్ IDని కాపీ చేయండి`,
        copyPhoneNumber: `ఫోన్ నంబర్‌ను కాపీ చేయండి`,
        endCall: `కాల్ ముగించండి`,
        muteCall: `కాల్ మ్యూట్ చేయండి`,
        answerCall: `కాల్‌కు సమాధానం ఇవ్వండి`,
        switchToCall: `కాల్‌కు మారండి`,
        warmTransfer: `వెచ్చని బదిలీ`,
        holdCall: `కాల్‌ను హోల్డ్ చేయండి`,
        resumeCall: `కాల్‌ను పునఃప్రారంభించండి`,
        newCall: `కొత్త కాల్`,
        mergeCalls: `కాల్‌లను విలీనం చేయండి`,
        endConference: `కాన్ఫరెన్స్ ముగించండి`,
      },
      callError: {
        youAreDisconnected: `మీరు డిస్‌కనెక్ట్ అయ్యారు`,
        connectionInterrupted: `మీ కనెక్షన్ అంతరాయమైంది. కనెక్షన్‌ని మళ్ళీ ప్రయత్నించడానికి ఇక్కడ క్లిక్ చేయండి.`,
        reconnect: `రీకనెక్ట్`,
        connecting: `కనెక్ట్ అవుతోంది…`,
        connectionFailed: `ఫోన్ కనెక్షన్ విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.`,
        retry: `మళ్లీ ప్రయత్నించు`,
        microphoneDisabled: `మైక్రోఫోన్ అనుమతులు డిసేబుల్ చేయబడ్డాయి!`,
        microphoneEnableText: `మీ మైక్రోఫోన్ అనుమతిని ఎనేబుల్ చేయడం వల్ల వెబ్‌ఫోన్‌ను ఉపయోగించడానికి అనుమతిస్తుంది.`,
        microphoneInUse: `మైక్రోఫోన్ వాడుకలో ఉంది`,
        microphoneInUseText: `మరో అప్లికేషన్ మీ మైక్రోఫోన్‌ను ఉపయోగిస్తోంది. దాన్ని (ఉదా. Zoom, Teams లేదా మరో ట్యాబ్) మూసివేసి మళ్లీ ప్రయత్నించండి.`,
        seeHereForHelp: `సహాయం కోసం ఇక్కడ చూడండి.`,
      },
      feedback: {
        reason: {
          soundDelayed: `Sound was delayed`,
          couldntHearOthers: `I couldn't hear others`,
          echo: `There was echo`,
          audioBreakingUp: `Audio was breaking up`,
          othersCouldntHearMe: `Others couldn't hear me`,
          otherAudioIssue: `Other audio issue`,
        },
        modal: {
          header: `What went wrong?`,
          dismiss: `Dismiss`,
          submit: `Submit Feedback`,
        },
        toast: {
          header: `Rate your call audio`,
          thanks: `Thanks!`,
          goodQuality: `మంచి కాల్ నాణ్యత`,
          poorQuality: `పేలవమైన కాల్ నాణ్యత`,
          dismiss: `తీసివేయి`,
        },
      },
    },

    faxSettings: {
      enableFaxCoverPage: `ఫ్యాక్స్ కవర్ పేజీని ప్రారంభించండి`,
    },

    notificationSettings: {
      alertMessage: `మీరు నోటిఫికేషన్లను నిరోధించారు. దీన్ని తిరిగి ఆన్ చేయడానికి మీరు మీ బ్రౌజర్ సెట్టింగ్‌లలోకి వెళ్లాలి.`,
      browserNotifications: `బ్రౌజర్ నోటిఫికేషన్లు`,
      playSoundForNewTexts: `కొత్త టెక్స్ట్‌ల కోసం సౌండ్ ప్లే చేయండి`,
      testNotification: `పరీక్ష నోటిఫికేషన్`,
      volumeControl: `నోటిఫికేషన్ వాల్యూమ్ మీ కంప్యూటర్ ద్వారా నియంత్రించబడుతుంది`,
      help: `సహాయం`,
      helpLinkText: `నేను నోటిఫికేషన్లను ఎలా ఆన్/ఆఫ్ చేయాలి`,
      onGoogleChrome: `Google Chromeలో?`,
      callPop: {
        title: `కాల్ మరియు టెక్స్ట్ నోటిఫికేషన్ విండో`,
        description: `మా కొత్త నోటిఫికేషన్ విండో ఫీచర్‌ను ప్రయత్నించండి. ఈ ఫీచర్ మీరు కాల్ లేదా టెక్స్ట్ సందేశం అందుకున్నప్పుడు ఒక చిన్న, ప్రత్యేక విండోను చూపుతుంది. ఇది మీ పనికి అంతరాయం కలిగించకుండా కాల్ మరియు టెక్స్ట్ సమాచారాన్ని చూడటానికి మిమ్మల్ని అనుమతిస్తుంది!`,
        answerOnPatientInfoButtonClick: `రోగి సమాచారం తెరిచేటప్పుడు కాల్‌కు సమాధానం ఇవ్వండి`,
        showExampleButton: `ఉదాహరణ చూపించు`,
        enableExampleHint: `ఉదాహరణ బటన్‌ను ప్రారంభించడానికి పై స్విచ్‌ను టోగుల్ చేయండి`,
      },
      popupPosition: {
        title: `పాప్అప్ విండో స్థానం`,
        topLeft: `ఎడమ పైభాగం`,
        topRight: `కుడి పైభాగం`,
        bottomLeft: `ఎడమ దిగువ`,
        bottomRight: `కుడి దిగువ`,
      },
    },

    callInProgressModal: {
      title: `కాల్ జరుగుతోంది`,
      message: `దయచేసి ఎక్స్‌టెన్షన్‌లను మార్చడానికి ముందు మీ ప్రస్తుత కాల్‌ను ముగించండి`,
      dismiss: `తొలగించు`,
    },

    sessionExpiredModal: {
      title: `మీ సెషన్ గడువు ముగిసింది`,
      message: `మీ భద్రత కోసం, మిమ్మల్ని సైన్ అవుట్ చేశాము. టెక్స్ట్ సందేశ డ్రాఫ్ట్‌లు ఈ పరికరంలో భద్రపరచబడ్డాయి. కొనసాగించడానికి మళ్లీ సైన్ ఇన్ చేయండి.`,
      signInAgain: `మళ్లీ సైన్ ఇన్ చేయండి`,
    },

    audioSettings: {
      selectSoundOutputSource: `సౌండ్ అవుట్‌పుట్ సోర్స్‌ను ఎంచుకోండి - స్పీకర్లు`,
      selectInputSource: `ఇన్‌పుట్ సోర్స్‌ను ఎంచుకోండి - మైక్రోఫోన్`,
      toSelectAudioDevices: `ఆడియో పరికరాలను ఎంచుకోవడానికి, దయచేసి మైక్రోఫోన్ అనుమతులను మంజూరు చేయండి`,
    },

    integrationsSettings: {
      title: `ఇంటిగ్రేషన్లు`,
      description: `ఈ పేజీ మీ డేటా సోర్స్ ఇంటిగ్రేషన్లలో కొన్నింటిని చూపిస్తుంది — Mango మరియు మీ ప్రాక్టీస్ మేనేజ్‌మెంట్ సాఫ్ట్‌వేర్ మధ్య డేటాను సమకాలీకరించే కనెక్షన్లు. మీకు ఇంకా ఇక్కడ కనిపించని ఇతర యాక్టివ్ ఇంటిగ్రేషన్లు ఉండవచ్చు. మేము అన్నింటినీ కలిపే ఏకీకృత ఇంటిగ్రేషన్ అనుభవంపై పని చేస్తున్నాము.`,
      configuration: `కాన్ఫిగరేషన్`,
      auth: `అధికారీకరణ`,
      authDescription: `ఈ ఇంటిగ్రేషన్ మీ డేటాను యాక్సెస్ చేయడానికి అధికారీకరణ అవసరం.`,
      authButton: `అధికారీకరించు`,
      authRegionNotSupported: `మీ గుర్తించిన ప్రాంతంలో అధికారీకరణ అందుబాటులో లేదు. ఇది తప్పు అని మీరు భావిస్తే (ఉదాహరణకు, మీరు VPN ఉపయోగిస్తున్నట్లయితే), మద్దతును సంప్రదించండి.`,
      agentId: `ID: {{id}}`,
      copiedConfirmation: `కాపీ చేయబడింది!`,
      copyIdFailedTitle: `ID కాపీ చేయలేకపోయాము`,
      unknownDate: `(తెలియదు)`,
      statusActive: `యాక్టివ్`,
      statusPaused: `పాజ్ చేయబడింది`,
      createdLabel: `సృష్టించబడింది`,
      updatedLabel: `నవీకరించబడింది`,
      notSet: `(సెట్ చేయబడలేదు)`,
      enabled: `ప్రారంభించబడింది`,
      disabled: `నిలిపివేయబడింది`,
      accessRestricted: `మీకు ఇంటిగ్రేషన్లను యాక్సెస్ చేయడానికి అనుమతి లేదు. యాక్సెస్ కోసం మీ నిర్వాహకుడిని సంప్రదించండి.`,
      emptyState: {
        primary: `ఇంకా ఇక్కడ ఎటువంటి డేటా సోర్స్ ఇంటిగ్రేషన్లు నిర్వహించబడటం లేదు.`,
        secondary: `మీకు యాక్టివ్ ఇంటిగ్రేషన్లు ఉంటే, అవి ఇంకా ఈ జాబితాలో కనిపించకపోవచ్చు.`,
      },
      error: {
        title: `ఇంటిగ్రేషన్లు లోడ్ చేయడంలో విఫలమైంది`,
        message: `మీ ఇంటిగ్రేషన్లను లోడ్ చేస్తున్నప్పుడు లోపం సంభవించింది. దయచేసి తర్వాత మళ్ళీ ప్రయత్నించండి.`,
      },
    },

    updateSettings: {
      noExperimentsAvailable: `ఈ సమయంలో ఎలాంటి ప్రయోగాలు నడుస్తున్నవి లేవు.`,
      channelSwitcher: {
        title: `రిలీజ్ చానల్ స్విచింగ్`,
        description: `ఏ వెర్షన్ అప్డేట్లను స్వీకరించాలో ఎంచుకోండి. ప్రొడక్షన్లో అత్యంత స్థిరమైన ఫీచర్లు ఉన్నాయి, అయితే ఇతర ఛానెల్లు కొత్త ఫీచర్ల ప్రివ్యూను అందించవచ్చు. ఛానెల్లను మార్చడానికి అప్లికేషన్ రీస్టార్ట్ అవసరం.`,
        devModeNote: `డెవలప్మెంట్ మోడ్: చానల్ మార్చడం అనుకరణ చేయబడుతుంది మరియు యాప్ను పునఃప్రారంభించడానికి బదులుగా పేజీని రీలోడ్ చేస్తుంది.`,
        releaseChannel: `రిలీజ్ చానల్`,
        selectChannel: `చానల్ను ఎంచుకోండి...`,
        switchChannel: `చానల్ మార్చండి`,
        rollback: `{{channelName}}కి తిరిగి వెళ్ళండి`,
        current: `ప్రస్తుత: {{channelName}}`,
        switchTo: `మారండి:`,
        error: `చానల్ అందుబాటులో లేదు`,
        validationError: `{{channelName}} కు మారడం సాధ్యపడలేదు. ఛానల్ ఇంకా అందుబాటులో లేకపోవచ్చు లేదా నెట్‌వర్క్ సమస్య ఉండవచ్చు. దయచేసి కొద్దిసేపటి తర్వాత మళ్లీ ప్రయత్నించండి.`,
        switchFailed: `ఛానల్ మార్చడం విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.`,
        restartModal: {
          title: `రీస్టార్ట్ అవసరం`,
          successMessage: `విజయవంతంగా <strong>{{channelName}}</strong> చానల్కు మార్చబడింది.`,
          warningMessage: `ఛానెల్ మార్పును పూర్తి చేయడానికి అప్లికేషన్ నవీకరించి, ఆపై పునఃప్రారంభించాలి. సేవ్ చేయని ఏదైనా పని పోతుంది.`,
          cancel: `రద్దు చేయండి`,
          restartNow: `మార్పు ప్రారంభించండి`,
          switchingChannel: `{{channelName}}కి మారుతోంది...`,
          checkingUpdates: `నవీకరణల కోసం తనిఖీ చేస్తోంది...`,
          downloadingUpdate: `నవీకరణను డౌన్‌లోడ్ చేస్తోంది... {{progress}}%`,
          activatingChannel: `ఛానెల్‌ను సక్రియం చేస్తోంది...`,
          switching: `మారుతోంది...`,
        },
        highRiskWarning: {
          title: `అస్థిర ఛానల్`,
          description: `ఈ ఛానెల్‌లో ప్రయోగాత్మక ఫీచర్లు, బగ్‌లు లేదా అసంపూర్ణ కార్యాచరణ ఉండవచ్చు. మీ స్వంత రిస్క్‌తో ఉపయోగించండి.`,
        },
        mediumRiskWarning: {
          title: `ప్రీ-రిలీజ్ ఛానల్`,
          description: `ఈ ఛానెల్‌లో బగ్‌లు లేదా అసంపూర్ణ ఫీచర్లు ఉండవచ్చిన ప్రీ-రిలీజ్ సాఫ్ట్‌వేర్ ఉంది.`,
        },
      },
      releaseNotifications: {
        title: `రిలీజ్ నోటిఫికేషన్లు`,
        description: `యాప్ యొక్క కొత్త వెర్షన్ విడుదలైనప్పుడు ఇమెయిల్ పొందండి.`,
        descriptionWithChannel: `{{channel}} చానల్‌లో యాప్ యొక్క కొత్త వెర్షన్ విడుదలైనప్పుడు ఇమెయిల్ పొందండి.`,
        toggleLabel: `కొత్త రిలీజ్‌ల గురించి నాకు ఇమెయిల్ పంపండి`,
        recipient: `నోటిఫికేషన్‌లు మీ ఖాతాతో అనుబంధించబడిన ఇమెయిల్ చిరునామాకు పంపబడతాయి.`,
        recipientWithEmail: `నోటిఫికేషన్‌లు {{email}}కు పంపబడతాయి.`,
        resubscribeNote: `మీరు గతంలో సభ్యత్వాన్ని రద్దు చేసుకున్నారు. దీన్ని ఆన్ చేస్తే మీ ఇమెయిల్ రిలీజ్ అప్‌డేట్ ఇమెయిల్‌లకు మళ్లీ సభ్యత్వం పొందుతుంది.`,
        error: `మీ నోటిఫికేషన్ సెట్టింగ్‌ను అప్‌డేట్ చేయడం సాధ్యపడలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.`,
        loadError: `మీ నోటిఫికేషన్ సెట్టింగ్‌ను లోడ్ చేయడం సాధ్యపడలేదు.`,
        retry: `మళ్లీ ప్రయత్నించండి`,
        previewButton: `ఇమెయిల్ ప్రివ్యూ`,
        previewModalTitle: `రిలీజ్ ఇమెయిల్ ఉదాహరణ`,
        previewModalNote: `మీరు అందుకునే ఇమెయిల్ నమూనా. అసలు కంటెంట్ రిలీజ్‌ను బట్టి మారుతుంది. ఇమెయిల్‌లు ఆంగ్లంలో పంపబడతాయి.`,
        previewFrom: `నుండి:`,
        previewSubject: `విషయం:`,
        previewClose: `మూసివేయి`,
        previewTipsTitle: `ఈ ఇమెయిల్‌లు మీకు అందేలా చూసుకోండి`,
        previewSenderTip: `ఇమెయిల్ పంపే చిరునామా:`,
        previewTipContacts: `ఆ చిరునామాను మీ కాంటాక్ట్‌లు లేదా అడ్రస్ బుక్‌కు జోడించండి.`,
        previewTipJunk: `రిలీజ్ తర్వాత ఇమెయిల్ కనిపించకపోతే, మీ స్పామ్ లేదా జంక్ ఫోల్డర్‌ను తనిఖీ చేసి దాన్ని "స్పామ్ కాదు"గా గుర్తు పెట్టండి.`,
        previewTipSafelist: `ఆఫీసు ఖాతాలో, mangovoice.com డొమైన్‌ను సేఫ్‌లిస్ట్ చేయమని మీ IT అడ్మిన్‌ను అడగండి.`,
      },
    },

    blockedNumberModal: {
      header: `నంబర్‌ను నిరోధించు`,
      description: `ఈ నంబర్ నుండి అన్ని కాల్స్, టెక్స్ట్‌లు మరియు ఫ్యాక్స్‌లు నిరోధించబడతాయి.`,
      clearButton: `క్లియర్ చేయండి`,
      blockButton: `నంబర్‌ను నిరోధించు`,
      inputPlaceholder: `ఫోన్ నంబర్‌ను నమోదు చేయండి`,
      inputLabel: `నిరోధించాల్సిన ఫోన్ నంబర్`,
    },

    callCenterSettings: {
      enableAgentMode: `ఏజెంట్ మోడ్‌ను ప్రారంభించండి`,
      customStatuses: `కస్టమ్ ఏజెంట్ స్థితిలు`,
      customStatusesDescription: `లంచ్‌లు, విరామాలు, సమావేశాలు వంటి కాల్ క్యూ వెలుపల కార్యకలాపాలను ట్రాక్ చేయడానికి కస్టమ్ స్థితిలను సెటప్ చేయండి. మీ బృందం కార్యకలాపాలను వ్యవస్థీకృతంగా మరియు కనిపించేలా ఉంచండి.`,
      editStatus: `స్థితిని సవరించు`,
      deleteStatus: `స్థితిని తొలగించు`,
      confirmationModal: {
        title: `కస్టమ్ స్థితిని తొలగించు`,
        text1: `మీ కస్టమ్ స్థితి, `,
        text2: `, శాశ్వతంగా తొలగించబడుతుంది. మీరు ఖచ్చితంగా ఉన్నారా?`,
        confirmText: `స్థితిని తొలగించు`,
        cancelText: `రద్దు చేయండి`,
      },
      newStatus: `కొత్త స్థితి`,
      toast: {
        deleteStatusSuccess: `స్థితి విజయవంతంగా తొలగించబడింది`,
      },
    },

    customStatusModal: {
      NameAddrHeader: `కస్టమ్ స్థితిని జోడించు`,
      editHeader: `కస్టమ్ స్థితిని సవరించు`,
      inputLabel: `స్థితి పేరు`,
      inputPlaceholder: `పేరు`,
      type: `రకం`,
      typePlaceholder: `రకాన్ని ఎంచుకోండి`,
      away: `దూరంగా`,
      online: `ఆన్‌లైన్`,
      description: `వివరణ`,
      descriptionPlaceholder: `ఈ స్థితి దేనికి ఉపయోగించబడుతుంది?`,
      toast: {
        createSuccess: `స్థితి విజయవంతంగా సృష్టించబడింది`,
        editSuccess: `స్థితి విజయవంతంగా నవీకరించబడింది`,
      },
      cancelButton: `రద్దు చేయండి`,
      saveButton: `సేవ్ చేయండి`,
    },

    experimentsState: {
      queueDashboardEnabled: `క్యూ డాష్‌బోర్డ్`,
      queueDashboardDescription: `క్యూ డాష్‌బోర్డ్ ఫీచర్‌ను ప్రారంభించండి.`,
      missedCallsEnabled: `తప్పిన కాల్స్`,
      missedCallsDescription: `తప్పిన కాల్స్ ట్రాకింగ్ ఫీచర్‌ను ప్రారంభించండి.`,
      badge: {
        beta: `బీటా`,
      },
      globalPhoneCapture: {
        title: `గ్లోబల్ ఫోన్ నంబర్ క్యాప్చర్`,
        description: {
          intro: `మీ కంప్యూటర్‌లోని ఏదైనా అప్లికేషన్ నుండి ఫోన్ నంబర్‌ను కాపీ చేయడానికి మరియు ఆ నంబర్‌ను Mango Voice డయల్ ప్యాడ్‌లో నింపడానికి ఒక హాట్‌కీని నొక్కడానికి మిమ్మల్ని అనుమతిస్తుంది.`,
          howToUse: `ఈ ఫీచర్‌ను ఎలా ఉపయోగించాలి: మొదట మీరు ఉపయోగించాలనుకుంటున్న క్రింది హాట్‌కీ కలయికను ఎంచుకోండి, ఆపై "హాట్‌కీని సెట్ చేయి" బటన్‌ను నొక్కండి.`,
          afterSet: `మీ హాట్‌కీ సెట్ అయిన తర్వాత, మీరు సాధారణంగా ఏదైనా ఇతర అప్లికేషన్‌లో చేసే విధంగా ఫోన్ నంబర్‌ను కాపీ చేయండి (Cmd/Ctrl+C లేదా సందర్భ మెను ఉపయోగించి), ఆపై ఆ నంబర్‌ను Mango Voice లోకి లోడ్ చేయడానికి మీరు ఎంచుకున్న హాట్‌కీని నొక్కండి.`,
          note: `గమనిక: కొన్ని హాట్‌కీలు ఇతర అప్లికేషన్‌ల ద్వారా ఉపయోగంలో ఉండవచ్చు--Mango ఏదైనా వైరుధ్యాన్ని గుర్తించడానికి ప్రయత్నించి మీకు తెలియజేస్తుంది.`,
        },
        activeSettingTitle: `హాట్‌కీ స్థితి:`,
        activeAndSet: `ప్రస్తుత హాట్‌కీ`,
        unsavedChanges: `ప్రతిపాదిత హాట్‌కీ:`,
        configureTitle: `హాట్‌కీని కాన్ఫిగర్ చేయండి:`,
        keyLabel: `కీ:`,
        status: {
          enabled: `ప్రారంభించబడింది`,
          disabled: `నిలిపివేయబడింది`,
        },
        button: {
          setHotkey: `హాట్‌కీని సెట్ చేయండి`,
          disableFeature: `హాట్‌కీని నిలిపివేయండి`,
          enableFeature: `హాట్‌కీని ప్రారంభించండి`,
          clearHotkey: `హాట్కీని క్లియర్ చేయండి`,
        },
        notSet: `సెట్ చేయబడలేదు`,
        toast: {
          hotkeyCleared: `హాట్కీ క్లియర్ చేయబడింది`,
        },
      },
    },

    shortcutKeysHelp: {
      title: `ఆడియో ప్లేయర్ కీబోర్డ్ షార్ట్‌కట్‌లు`,
      keyboardKeys: {
        spaceBar: `స్పేస్ బార్`,
        m: `M`,
        leftArrow: `←`,
        rightArrow: `→`,
        slash: `/`,
        shift: `Shift`,
      },
      playPause: `ప్లే / పాజ్`,
      muteUnmute: `మ్యూట్ / అన్‌మ్యూట్`,
      rewind10s: `10సె వెనుకకు తిప్పండి`,
      advance10s: `10సె ముందుకు తిప్పండి`,
      rewind3s: `3సె వెనుకకు తిప్పండి`,
      advance3s: `3సె ముందుకు తిప్పండి`,
      scopeNote: `కీబోర్డ్ ఫోకస్ ఆడియో ప్లేయర్‌లో ఉన్నప్పుడు మ్యూట్ మరియు స్కిప్ షార్ట్‌కట్‌లు పనిచేస్తాయి.`,
    },

    newParkingLotModal: {
      header: `పార్కింగ్ స్థలాన్ని జోడించు`,
      parkingSpot: `పార్కింగ్ స్థలం`,
      label: `లేబుల్`,
      cancelButton: `రద్దు చేయండి`,
      saveButton: `సేవ్ చేయండి`,
      parking1Label: `పార్కింగ్ 1`,
      parking2Label: `పార్కింగ్ 2`,
      parking3Label: `పార్కింగ్ 3`,
      parking4Label: `పార్కింగ్ 4`,
      parking5Label: `పార్కింగ్ 5`,
      parking6Label: `పార్కింగ్ 6`,
      parking7Label: `పార్కింగ్ 7`,
      parking8Label: `పార్కింగ్ 8`,
      parking9Label: `పార్కింగ్ 9`,
      parking10Label: `పార్కింగ్ 10`,
    },

    newExtensionSubscriptionModal: {
      header: `ఎక్స్‌టెన్షన్ ఉనికిని జోడించు`,
      extension: `ఎక్స్‌టెన్షన్`,
      cancelButton: `రద్దు చేయండి`,
      saveButton: `సేవ్ చేయండి`,
    },

    dropdownSelect: {
      placeholder: `ఎంచుకోండి...`,
      noResultsFound: `ఫలితాలు కనుగొనబడలేదు`,
      assignUserFirst: `ముందు వినియోగదారుని కేటాయించండి`,
    },

    tooltips: {
      filter: `ఫిల్టర్`,
      dismiss: `తీసివేయి`,
      chartInformation: `చార్ట్ సమాచారం`,
    },

    form: {
      placeholder: {
        searchNameOrNumber: `పేరు లేదా నంబర్ శోధించండి`,
        selectStatus: `స్థితి ఎంచుకోండి`,
        selectUser: `వినియోగదారుని ఎంచుకోండి`,
        selectVirtualFax: `వర్చువల్ ఫ్యాక్స్ ఎంచుకోండి...`,
        searchNumbers: `నంబర్లు శోధించండి`,
        dateMonth: `MM`,
        dateDay: `DD`,
        dateYear: `YYYY`,
        timeHours: `HH`,
        timeMinutes: `MM`,
        timeMeridiem: `AM`,
      },
    },

    newSpeedDialModal: {
      addSpeedDial: `స్పీడ్ డయల్‌ను జోడించు`,
      editSpeedDial: `స్పీడ్ డయల్‌ను సవరించు`,
      contactName: `కాంటాక్ట్ పేరు`,
      number: `నంబర్`,
      cancelButton: `రద్దు చేయండి`,
      saveButton: `సేవ్ చేయండి`,
    },

    actionsButton: {
      tooltipNewAction: `కొత్త చర్య`,
      newThread: `కొత్త థ్రెడ్`,
      newCall: `కొత్త కాల్`,
      newFax: `కొత్త ఫ్యాక్స్`,
    },

    accountButton: {
      settings: `సెట్టింగ్‌లు`,
      connectionStatus: `యాప్ స్థితి`,
      switchPbx: `PBX మార్చండి`,
      openApp: `యాప్‌ను తెరవండి`,
      downloadApp: `యాప్‌ను డౌన్‌లోడ్ చేయండి`,
      whatsNew: `కొత్తది ఏమిటి`,
      giveFeedback: `అభిప్రాయాన్ని ఇవ్వండి`,
      helpCenter: `సహాయ కేంద్రం`,
      logOut: `లాగ్ అవుట్ చేయండి`,
      apiDocs: `API డాక్స్`,
    },

    statusPanel: {
      title: `యాప్ స్థితి`,
      tabBasic: `ప్రాథమికం`,
      tabAdvanced: `అధునాతనం`,
      tabListLabel: `యాప్ స్థితి వీక్షణలు`,
      refresh: `రిఫ్రెష్ చేయండి`,
      refreshing: `రిఫ్రెష్ అవుతోంది…`,
      refreshed: `నవీకరించబడింది`,
      close: `మూసివేయండి`,
      copyDiagnostics: `డయాగ్నొస్టిక్స్ కాపీ చేయండి`,
      copied: `కాపీ చేయబడింది`,
      overallHealthy: `ఆరోగ్యకరం`,
      overallDegraded: `క్షీణించింది`,
      overallDown: `డౌన్`,
      overallIdle: `నిష్క్రియం`,
      overallUnknown: `తెలియదు`,
      summaryGood: `అంతా బాగానే ఉంది.`,
      summaryProblem: `సమస్య కనుగొనబడింది.`,
      fixNetworkOffline: `మీ Wi-Fi లేదా నెట్‌వర్క్ కేబుల్‌ను తనిఖీ చేసి, మళ్లీ ప్రయత్నించండి.`,
      fixPhoneError: `ఫోన్‌ను మళ్లీ కనెక్ట్ చేయడానికి పేజీని రీలోడ్ చేయండి. అది విఫలమవుతూ ఉంటే, సపోర్ట్‌ను సంప్రదించండి.`,
      fixRealtimeReconnecting: `స్వయంచాలకంగా మళ్లీ కనెక్ట్ అవుతోంది. ఇది కొనసాగితే, పేజీని రీలోడ్ చేయండి.`,
      fixRealtimeSuspended: `యాప్ నిలిపివేయబడింది. ఇది త్వరలో పునఃప్రారంభం కావాలి — కాకపోతే రీలోడ్ చేయండి.`,
      fixRealtimeDisconnected: `మెసేజింగ్ మరియు కాల్ అప్‌డేట్‌లను పునరుద్ధరించడానికి పేజీని రీలోడ్ చేయండి.`,
      rowInternet: `ఇంటర్నెట్`,
      rowPhoneService: `ఫోన్ సేవ`,
      rowMessaging: `మెసేజింగ్`,
      rowAppUpdates: `యాప్ అప్‌డేట్‌లు`,
      stateUpdateReady: `అప్‌డేట్ సిద్ధంగా ఉంది`,
      stateCantInstallUpdates: `అప్‌డేట్‌లను ఇన్‌స్టాల్ చేయలేకపోతోంది`,
      stateUpdateBlocked: `అప్‌డేట్ బ్లాక్ చేయబడింది`,
      stateUpdateReadyVersion: `అప్‌డేట్ సిద్ధంగా ఉంది ({{version}})`,
      stateUpdateDownloading: `అప్‌డేట్ డౌన్‌లోడ్ అవుతోంది…`,
      stateUpdateDownloadingVersion: `అప్‌డేట్ డౌన్‌లోడ్ అవుతోంది ({{version}})…`,
      stateUpdateCheckFailed: `అప్‌డేట్‌ల కోసం తనిఖీ చేయలేకపోయింది`,
      stateCheckingForUpdates: `అప్‌డేట్‌ల కోసం తనిఖీ చేస్తోంది…`,
      stateNotCheckedYet: `ఇంకా తనిఖీ చేయలేదు`,
      checkAgain: `మళ్లీ తనిఖీ చేయండి`,
      online: `ఆన్‌లైన్`,
      offline: `ఆఫ్‌లైన్`,
      on: `ఆన్`,
      off: `ఆఫ్`,
      stateOnline: `ఆన్‌లైన్`,
      stateOffline: `ఆఫ్‌లైన్`,
      stateConnected: `కనెక్ట్ అయింది`,
      stateDisconnected: `డిస్‌కనెక్ట్ అయింది`,
      stateRegisteredReady: `నమోదు చేయబడింది & సిద్ధం`,
      stateConnecting: `కనెక్ట్ అవుతోంది…`,
      stateReconnecting: `మళ్లీ కనెక్ట్ అవుతోంది`,
      stateSuspended: `నిలిపివేయబడింది`,
      stateRegistrationError: `నమోదు లోపం`,
      regNotStarted: `ప్రారంభం కాలేదు`,
      regRegistered: `నమోదు చేయబడింది`,
      regUnregistered: `నమోదు రద్దు చేయబడింది`,
      regTerminated: `ముగించబడింది`,
      transportNotStarted: `ప్రారంభం కాలేదు`,
      transportConnected: `కనెక్ట్ అయింది`,
      transportDisconnected: `డిస్‌కనెక్ట్ అయింది`,
      sectionSip: `SIP`,
      sectionMessaging: `మెసేజింగ్ / రియల్-టైమ్`,
      sectionNetwork: `నెట్‌వర్క్`,
      sectionTelephony: `టెలిఫోనీ`,
      sectionEnvironment: `ఎన్విరాన్‌మెంట్`,
      labelRegistration: `నమోదు`,
      labelTransport: `ట్రాన్స్‌పోర్ట్`,
      labelLastError: `చివరి లోపం`,
      labelWebSocket: `WebSocket`,
      labelLastHeartbeat: `చివరి హార్ట్‌బీట్`,
      heartbeatAgo: `{{seconds}} సెకన్ల క్రితం`,
      heartbeatStale: `{{seconds}} సెకన్ల క్రితం (పాతది)`,
      heartbeatNone: `ఇంకా లేదు`,
      labelReconnectAttempts: `మళ్లీ కనెక్ట్ ప్రయత్నాలు`,
      labelBrowser: `బ్రౌజర్`,
      sectionAudio: `ఆడియో`,
      labelMicPermission: `మైక్రోఫోన్ అనుమతి`,
      labelMicInput: `మైక్రోఫోన్ (ఇన్‌పుట్)`,
      labelSpeaker: `స్పీకర్ (అవుట్‌పుట్)`,
      deviceCount: `{{count}} కనుగొనబడ్డాయి`,
      deviceDefault: `సిస్టమ్ డిఫాల్ట్`,
      deviceNone: `ఏదీ గుర్తించబడలేదు`,
      sectionCall: `క్రియాశీల కాల్`,
      callNone: `క్రియాశీల కాల్ లేదు`,
      labelCallStatus: `స్థితి`,
      labelCallDirection: `దిశ`,
      labelCallSource: `మూలం`,
      labelCallHold: `హోల్డ్‌లో`,
      labelCallMuted: `మ్యూట్ చేయబడింది`,
      labelCallDuration: `వ్యవధి`,
      labelLatestVersion: `తాజా వెర్షన్`,
      labelUpToDate: `తాజాగా ఉంది`,
      labelOutOfDate: `అప్‌డేట్ అందుబాటులో ఉంది`,
      labelChannel: `ఛానెల్`,
      labelPlatform: `ప్లాట్‌ఫారమ్`,
      sectionSession: `సెషన్`,
      labelSignedIn: `సైన్ ఇన్ అయ్యారు`,
      labelTokenExpiry: `సెషన్ గడువు ముగుస్తుంది`,
      tokenExpired: `గడువు ముగిసింది`,
      tokenValid: `చెల్లుబాటు`,
      tokenNone: `క్రియాశీల సెషన్ లేదు`,
      labelNotifications: `నోటిఫికేషన్‌లు`,
      labelLocalStorage: `లోకల్ స్టోరేజ్`,
      storageWritable: `రాయదగినది`,
      storageBlocked: `నిరోధించబడింది`,
      navChipDegraded: `యాప్ స్థితి: శ్రద్ధ అవసరం`,
      navChipDown: `యాప్ స్థితి: సమస్య కనుగొనబడింది`,
      navChipAria: `సమస్య గుర్తించబడింది. యాప్ స్థితిని తెరవండి.`,
      sectionEvents: `ఇటీవలి కనెక్షన్ ఈవెంట్‌లు`,
      noEvents: `ఈ సెషన్‌లో కనెక్షన్ మార్పులు లేవు — కనెక్షన్ స్థిరంగా ఉంది.`,
      eventOnline: `నెట్‌వర్క్ ఆన్‌లైన్`,
      eventOffline: `నెట్‌వర్క్ ఆఫ్‌లైన్`,
      eventWsConnected: `రియల్-టైమ్ కనెక్ట్ అయింది`,
      eventWsReconnecting: `రియల్-టైమ్ మళ్లీ కనెక్ట్ అవుతోంది`,
      eventWsSuspended: `రియల్-టైమ్ నిలిపివేయబడింది`,
      eventWsDisconnected: `రియల్-టైమ్ డిస్‌కనెక్ట్ అయింది`,
      labelPbx: `PBX`,
      labelPbxId: `PBX ID`,
      labelPbxUuid: `PBX UUID`,
      labelDoNotDisturb: `డిస్టర్బ్ చేయవద్దు`,
      labelRespondBusy: `2వ కాల్‌కు బిజీగా స్పందించండి`,
      labelAppVersion: `యాప్ వెర్షన్`,
      labelBuild: `బిల్డ్`,
      labelCaptured: `క్యాప్చర్ చేయబడింది`,
      labelUserAgent: `యూజర్ ఏజెంట్`,
      extensions: `ఎక్స్‌టెన్షన్లు`,
      noExtensions: `ఎటువంటి ఎక్స్‌టెన్షన్లు కేటాయించబడలేదు.`,
      thisSession: `ఈ సెషన్`,
    },

    contactsPage: {
      emptyDetailMessage: `ఏ కాంటాక్ట్ ఎంచుకోబడలేదు`,
      toast: {
        copyNumberSuccess: `ఫోన్ నంబర్ క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది`,
        copyNumberError: `ఫోన్ నంబర్‌ను కాపీ చేయడం సాధ్యపడలేదు`,
      },
    },

    contactsListView: {
      searchPlaceholder: `పేరు లేదా నంబర్‌ను శోధించండి`,
      searchLabel: `కాంటాక్ట్‌లను శోధించండి`,
      contactSourceContent: `అన్ని కాంటాక్ట్‌లు`,
      emptyNotice: {
        noContactsYet: `ఇంకా ఇక్కడ కాంటాక్ట్‌లు లేవు`,
        contactSupport: `మీ పేషెంట్ కాంటాక్ట్‌లను కనెక్ట్ చేయడానికి మా సపోర్ట్ టీమ్‌ను సంప్రదించండి. అంతర్గత ఎక్స్‌టెన్షన్‌లు వాటిని సెటప్ చేసిన తర్వాత ఇక్కడ కూడా కనిపిస్తాయి`,
        noContactsFound: `కాంటాక్ట్‌లు కనుగొనబడలేదు`,
        noMatchingContacts: `సరిపోలే కాంటాక్ట్‌లు మాకు కనుగొనబడలేదు`,
      },
    },

    contactItems: {
      primary: `ప్రాథమిక`,
      actionButton: {
        copyNumber: `నంబర్‌ను కాపీ చేయండి`,
        callNumber: `నంబర్‌కు కాల్ చేయండి`,
        messageNumber: `నంబర్‌కు సందేశం పంపండి`,
        sendFax: `ఫ్యాక్స్ పంపండి`,
        callNumberLabel: `{{number}}కు కాల్ చేయండి`,
        messageNumberLabel: `{{number}}కు సందేశం పంపండి`,
        sendFaxLabel: `{{number}}కు ఫ్యాక్స్ పంపండి`,
        copyNumberLabel: `{{number}}ను కాపీ చేయండి`,
        unblockNumberLabel: `{{number}}ను అన్‌బ్లాక్ చేయి`,
      },
      emptyContactItem: `ఈ కాంటాక్ట్ కోసం ఇంకా ఏ ఫోన్ నంబర్‌లు సేవ్ చేయబడలేదు`,
      contactInformation: `కాంటాక్ట్ సమాచారం`,
      contactSource: `కాంటాక్ట్ మూలం:`,
      fromPms: `{{pmsName}} నుండి`,
    },

    contactEventHistory: {
      recentActivity: `ఇటీవలి కార్యకలాపం`,
      timespanText: `గత 14 రోజులు`,
      historyLabel: {
        messaging: `సందేశ థ్రెడ్`,
        inboundCall: `ఇన్‌బౌండ్ కాల్`,
        outboundCall: `అవుట్‌బౌండ్ కాల్`,
        inboundFax: `ఫ్యాక్స్ స్వీకరించబడింది`,
        outboundFax: `ఫ్యాక్స్ పంపబడింది`,
        voicemail: `వాయిస్‌మెయిల్`,
      },
    },

    quickDialView: {
      tab: {
        favorites: `ఇష్టమైనవి`,
        recentlyDialed: `ఇటీవల డయల్ చేసినవి`,
      },
      groupName: {
        parkingSpots: `పార్కింగ్ స్థలాలు`,
        lineExtensions: `లైన్ ఎక్స్‌టెన్షన్‌లు`,
        speedDial: `స్పీడ్ డయల్`,
      },
      phoneSettings: `ఫోన్ సెట్టింగ్‌లు`,
    },

    quickDialListItem: {
      empty: {
        parkingSpots: `ఇక్కడ పార్కింగ్ స్థలాలను చూపించడానికి, మీ వెబ్ ఫోన్ సెట్టింగ్‌లను సర్దుబాటు చేయండి`,
        lineExtensions: `వారి లభ్యతను ఇక్కడ చూడటానికి ఏదైనా లైన్ ఎక్స్‌టెన్షన్‌ను జోడించండి`,
        speedDial: `మీరు తరచుగా కాల్ చేసే నంబర్‌లను స్పీడ్ డయల్‌తో నిల్వ చేయండి`,
        recentlyDialedPrimary: `ఇటీవల డయల్ చేసిన నంబర్‌లు లేవు`,
        recentlyDialedSecondary: `మీరు కాల్స్ చేసిన తర్వాత మీ ఇటీవల డయల్ చేసిన నంబర్‌లు ఇక్కడ కనిపిస్తాయి.`,
      },
      button: {
        webPhoneSettings: `వెబ్ ఫోన్ సెట్టింగ్‌లు`,
        configurePresence: `ఉనికిని కాన్ఫిగర్ చేయండి`,
        configureSpeedDial: `స్పీడ్ డయల్‌ను కాన్ఫిగర్ చేయండి`,
      },
      parkingLot: {
        title: `పార్కింగ్ లాట్`,
        subtitle: `పార్కింగ్ లాట్`,
      },
      tooltip: {
        pickUpCall: `కాల్ తీయండి`,
        startCall: `కాల్ ప్రారంభించండి`,
        parkCall: `కాల్ పార్క్ చేయండి`,
        newCall: `కొత్త కాల్ ప్రారంభించండి`,
        transferCall: `కాల్ బదిలీ చేయండి`,
      },
    },

    callContactButton: {
      startCall: `కాల్ ప్రారంభించండి`,
      startCallAriaLabel: `కాల్ ప్రారంభించండి: {{name}}, {{number}}`,
      startCallNumberAriaLabel: `కాల్ ప్రారంభించండి: {{number}}`,
      callNumber: `{{number}}కి కాల్ చేయండి`,
      callNumberWithLabel: `{{number}}కి కాల్ చేయండి - {{label}}`,
      otherNumbersAriaLabel: `{{name}} యొక్క ఇతర నంబర్లు`,
    },

    phoneNumberInput: {
      placeholder: `నంబర్‌ను నమోదు చేయండి`,
      clearButton: `క్లియర్ చేయండి`,
      inputLabel: `కాల్ చేయాల్సిన ఫోన్ నంబర్`,
    },

    phoneNumberMultiDropdown: {
      allNumbers: `అన్ని నంబర్‌లు`,
    },

    phoneSearchInput: {
      placeholder: `పేరు లేదా నంబర్‌ను నమోదు చేయండి`,
      clearButton: `క్లియర్ చేయండి`,
      inputLabel: `పేరు లేదా నంబర్ ద్వారా వెతకండి`,
    },

    contactCardsList: {
      emptySearchText: `శోధన ప్రారంభించడానికి పైన పేరు లేదా నంబర్‌ను నమోదు చేయండి`,
    },

    outOfCallView: {
      tabButtonDialpad: `డయల్‌ప్యాడ్`,
      tabButtonSearch: `శోధించు`,
    },

    contactCardList: {
      searchResults: `శోధన ఫలితాలు`,
      noMatchingContacts: `మేము దీనికి సరిపోలే ఏ కాంటాక్ట్‌లను కనుగొనలేదు `,
    },

    callButton: {
      startCall: `కాల్ ప్రారంభించండి`,
      endCall: `కాల్ ముగించండి`,
      disabled: `నిలిపివేయబడింది`,
      unknown: `తెలియదు`,
    },

    callControlButton: {
      endCall: `కాల్ ముగించండి`,
      splitConference: `కాన్ఫరెన్స్‌ను విభజించండి`,
      mergeCalls: `కాల్స్‌ను విలీనం చేయండి`,
      newCall: `కొత్త కాల్`,
      transfer: `బదిలీ చేయండి`,
      park: `పార్క్ చేయండి`,
      mute: `మ్యూట్ చేయండి`,
      keypad: `కీప్యాడ్`,
      hold: `హోల్డ్ చేయండి`,
      audioSettings: `ఆడియో సెట్టింగ్‌లు`,
    },

    onboardingView: {
      welcomeText: `ఏదైనా బ్రౌజర్ నుండి కాల్స్ చేయండి`,
      bodyText: `కాల్స్ చేయండి మరియు స్వీకరించండి, సులభంగా బదిలీ చేయండి లేదా పార్క్ చేయండి, బహుళ కాల్స్‌ను నిర్వహించండి, ఇష్టమైనవి మరియు స్పీడ్ డయల్స్ జోడించండి. మీ కమ్యూనికేషన్, మీ మార్గం, ఎక్కడి నుండైనా.`,
      buttonLabel: `ఫోన్‌ను యాక్టివేట్ చేయండి`,
      confirmModal: {
        title: `లైన్ ఎక్స్‌టెన్షన్‌లు అందుబాటులో లేవు`,
        message1: `ఈ ఫోన్ సిస్టమ్ {{pbxName}}లో మీకు ఏ లైన్ ఎక్స్‌టెన్షన్‌లు కేటాయించబడలేదు.`,
        message2: `ఫోన్ ఫీచర్‌ను ఉపయోగించడానికి, దయచేసి లైన్ ఎక్స్‌టెన్షన్‌ను కేటాయించడానికి మీ సిస్టమ్ అడ్మినిస్ట్రేటర్‌ను సంప్రదించండి.`,
        confirmText: `కొట్టివేయండి`,
      },
    },

    numberComparisonDashboard: {
      invalidDateRange: `చెల్లని తేదీ పరిధి`,
      dateRangeTooLarge: `తేదీ పరిధి చాలా పెద్దది. దయచేసి 365 రోజులు లేదా అంతకంటే తక్కువ పరిధిని ఎంచుకోండి.`,
      dateRangeAdjustPrompt: `దయచేసి మీ తేదీ పరిధిని సర్దుబాటు చేసి మళ్లీ ప్రయత్నించండి.`,
      chartTitle: `సంఖ్య వారీగా కాల్ వాల్యూమ్`,
      showingCount: `{{total}}లో {{displayed}} చూపుతోంది`,
      counters: {
        totalCalls: {
          title: `మొత్తం ఇన్‌బౌండ్ కాల్స్`,
          subtitle: `అన్ని నంబర్లలో మొత్తం ఇన్‌బౌండ్ కాల్స్`,
        },
        numberCount: {
          title: `మొత్తం నంబర్లు`,
          subtitle: `ట్రాక్ చేయబడిన మొత్తం ఫోన్ నంబర్లు`,
        },
        averageCalls: {
          title: `నంబర్‌కు సగటు`,
          subtitle: `నంబర్‌కు సగటు ఇన్‌బౌండ్ కాల్స్`,
        },
        topNumber: {
          title: `టాప్ పెర్ఫార్మర్`,
        },
      },
      dashboard: {
        errorText: `నంబర్ డేటాను లోడ్ చేయడంలో లోపం`,
        noDataText: `నంబర్ డేటా అందుబాటులో లేదు`,
      },
      showMore: `మరిన్ని చూపించు ({{remaining}} మిగిలి ఉన్నాయి)`,
      unknown: `తెలియనిది`,
      notAvailable: `అందుబాటులో లేదు`,
    },

    callControl: {
      audioSettings: {
        title: `ఆడియో సెట్టింగ్‌లు`,
        outputSource: `అవుట్‌పుట్ సోర్స్ - స్పీకర్లు`,
        inputSource: `ఇన్‌పుట్ సోర్స్ - మైక్రోఫోన్`,
      },
      parkCall: `కాల్ పార్క్ చేయండి`,
      transferCall: `కాల్ బదిలీ చేయండి`,
    },

    transferTarget: {
      buttonText: `కాల్ బదిలీ చేయండి`,
      buttonAriaLabel: `కాల్ బదిలీ చేయండి: {{name}}, {{number}}`,
    },

    transferHeader: {
      placeholder: `నంబర్‌ను నమోదు చేయండి`,
      ariaLabel: `బదిలీ చేయండి`,
      inputLabel: `బదిలీ చేయాల్సిన నంబర్`,
    },

    parkTarget: {
      buttonText: `కాల్ పార్క్ చేయండి`,
      buttonAriaLabel: `కాల్ పార్క్ చేయండి: {{name}}`,
    },

    controlDrawer: {
      ariaLabel: `డ్రాయర్‌ను మూసివేయండి`,
    },

    dashboardsPage: {
      item: {
        agentStatus: `ఏజెంట్ స్థితి`,
        eventLog: `ఈవెంట్ లాగ్`,
        inboundAnswerRate: `ఇన్‌బౌండ్ సమాధాన రేటు`,
        numberComparison: `సంఖ్య పోల్చిక`,
        extensionComparison: `ఎక్స్‌టెన్షన్ పోల్చిక`,
        queueDashboard: `క్యూ డాష్‌బోర్డ్`,
      },
      group: {
        callCenter: `కాల్ సెంటర్`,
        callDashboards: `కాల్ డాష్‌బోర్డ్‌లు`,
      },
    },

    queueDashboard: {
      emptyState: {
        title: `సమాచారం కనుగొనబడలేదు`,
        description: `సంబంధిత డేటాను వీక్షించడానికి జాబితా నుండి క్యూ‌ను ఎంచుకోండి`,
      },
      filters: {
        title: `క్యూ`,
        subtitle: `మీ టీమ్ కాల్ కార్యకలాపాలు ఎలా పోలుతాయో చూడండి`,
      },
      queueSelector: {
        placeholder: `జాబితా నుండి ఎంచుకోండి`,
        ariaLabel: `కాల్ క్యూ‌ను ఎంచుకోండి`,
      },
      metrics: {
        callersInQueue: `క్యూ‌లో కాలర్‌లు`,
        maxWait: `గరిష్ట వేచి ఉండే సమయం`,
        averageWait: `సగటు వేచి ఉండే సమయం`,
        maxAbandoned: `గరిష్ట విడిచిపెట్టబడింది`,
        averageAbandoned: `సగటు విడిచిపెట్టబడింది`,
        dropRate: `డ్రాప్ రేటు`,
        answerRate: `సమాధాన రేటు`,
        sampleHistory: `నమూనా చరిత్ర`,
        sampleHistoryAriaLabel: `నమూనా చరిత్ర సమయ విండోను ఎంచుకోండి`,
      },
      agentsPanel: {
        title: `ఏజెంట్ క్యూ`,
        activeAgents: `క్రియాశీల ఏజెంట్‌లు`,
        inactiveAgents: `నిష్క్రియ ఏజెంట్‌లు`,
        searchPlaceholder: `పేరు లేదా విస్తరణను నమోదు చేయండి`,
        exportCsv: `CSV ఎగుమతి`,
        exportToast: {
          title: `ఎగుమతి`,
          description: `CSV ఎగుమతి ఫంక్షనాలిటీ త్వరలో వస్తుంది.`,
        },
        loginFailed: {
          title: `లాగిన్ విఫలమైంది`,
          description: `ఏజెంట్‌ను క్యూ‌లోకి లాగిన్ చేయడంలో విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.`,
        },
        logoutFailed: {
          title: `లాగౌట్ విఫలమైంది`,
          description: `ఏజెంట్‌ను క్యూ‌నుండి లాగౌట్ చేయడంలో విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.`,
        },
      },
      callersTable: {
        title: `ఇన్‌బౌండ్ క్యూ`,
        callerNumber: `కాలర్ #`,
        callerName: `కాలర్ పేరు`,
        callTime: `కాల్/వేచి ఉండే సమయం`,
        status: `స్థితి`,
        emptyState: {
          title: `సమాచారం కనుగొనబడలేదు`,
          description: `ప్రస్తుత క్యూ కోసం ప్రస్తుతం ఏ సమాచారం చూపబడుతోంది`,
        },
      },
      activeAgentsTable: {
        callerNumber: `కాలర్ #`,
        agentName: `ఏజెంట్ పేరు`,
        ext: `ఎక్స్టెన్షన్`,
        loggedIn: `లాగిన్ అయ్యింది`,
        talkTime: `మాట్లాడే సమయం`,
        answered: `సమాధానమిచ్చారు`,
        missed: `తప్పిపోయింది`,
        total: `మొత్తం`,
        status: `స్థితి`,
        lastOffered: `చివరి ఆఫర్`,
        action: `చర్య`,
        emptyState: {
          title: `ఏజెంట్‌లు కనుగొనబడలేదు`,
          description: `ప్రస్తుత క్యూ కోసం ప్రస్తుతం ఏ సమాచారం చూపబడుతోంది`,
        },
      },
      inactiveAgentsTable: {
        agent: `ఏజెంట్`,
        ext: `ఎక్స్టెన్షన్`,
        lastLoggedOut: `చివరి లాగౌట్`,
        status: `స్థితి`,
        action: `చర్య`,
        emptyState: {
          title: `ఏజెంట్‌లు కనుగొనబడలేదు`,
          description: `ప్రస్తుత క్యూ కోసం ప్రస్తుతం ఏ సమాచారం చూపబడుతోంది`,
        },
      },
      agentRow: {
        changeStatus: `స్థితిని మార్చండి`,
        offline: `ఆఫ్‌లైన్`,
      },
      settings: {
        alertHoldTime: `హోల్డ్ అలర్ట్ సమయం`,
        alertHoldTimeAriaLabel: `హోల్డ్ అలర్ట్ థ్రెషోల్డ్‌ను ఎంచుకోండి`,
        refreshEvery: `ప్రతి రిఫ్రెష్ చేయండి`,
        refreshAriaLabel: `రిఫ్రెష్ విరామాన్ని ఎంచుకోండి`,
        seconds_one: `{{count}} సెకను`,
        seconds_other: `{{count}} సెకన్లు`,
        minutes_one: `{{count}} నిమిషం`,
        minutes_other: `{{count}} నిమిషాలు`,
        hours_one: `{{count}} గంట`,
        hours_other: `{{count}} గంటలు`,
      },
      errorDisplay: {
        retrying_one: `{{count}} సెకనులో మళ్లీ ప్రయత్నిస్తోంది...`,
        retrying_other: `{{count}} సెకనులో మళ్లీ ప్రయత్నిస్తోంది...`,
        retryNow: `ఇప్పుడే మళ్లీ ప్రయత్నించండి`,
        retryingButton: `మళ్లీ ప్రయత్నిస్తోంది...`,
        persistentMessage: `పునరావృత వైఫల్యాల కారణంగా స్వయంచాలక రిఫ్రెష్ పాజ్ చేయబడింది.`,
      },
      status: {
        ready: `సిద్ధంగా ఉంది`,
        onCall: `కాల్‌లో`,
        ringing: `రింగింగ్`,
        available: `అందుబాటులో ఉంది`,
        break: `విరామం`,
        waiting: `వేచి ఉంది`,
        answered: `సమాధానమిచ్చారు`,
        cancelled: `రద్దు చేయబడింది`,
      },
    },

    inboundAnswerRate: {
      header: `ఇన్‌బౌండ్ ఆన్సర్ రేట్`,
      subtitle: `సమాధానమిచ్చిన ఇన్‌బౌండ్ కాల్స్ శాతాన్ని చూపిస్తుంది`,
      filters: {
        dateRange: `తేదీ పరిధి`,
        number: `నంబర్`,
        maxPhoneNumbers: `(గరిష్టం {{max}})`,
      },
      counters: {
        answerRate: {
          title: `ఆన్సర్ రేట్`,
          subtitle: `సమాధానమిచ్చిన కాల్స్ శాతం`,
        },
        totalCalls: {
          title: `మొత్తం కాల్స్`,
          subtitle: `మొత్తం ఇన్‌బౌండ్ కాల్స్`,
        },
        answered: {
          title: `సమాధానమిచ్చిన కాల్స్`,
          subtitle: `మొత్తం సమాధానమిచ్చిన కాల్స్`,
        },
        missed: {
          title: `తప్పిన కాల్స్`,
          subtitle: `మొత్తం తప్పిన కాల్స్`,
        },
      },
      dashboard: {
        title: `ఆన్సర్ రేట్ గణాంకాలు`,
        errorText: `కాల్ డేటాను లోడ్ చేయడంలో లోపం`,
        noDataText: `కాల్ డేటా అందుబాటులో లేదు`,
        tableViewPlaceholder: `టేబుల్ వ్యూ త్వరలో`,
      },
      metrics: {
        answered: `సమాధానమిచ్చినవి`,
        missed: `తప్పినవి`,
        answerRate: `ఆన్సర్ రేట్`,
      },
      rechartTitle: `{{groupByTitle}}కు కాల్స్`,
      viewToggle: {
        chart: `చార్ట్`,
        table: `టేబుల్`,
      },
      table: {
        columns: {
          number: `నంబర్`,
          answerRate: `ఇన్‌బౌండ్ ఆన్సర్ రేట్`,
          answered: `సమాధానమిచ్చిన కాల్స్`,
          missed: `తప్పిన కాల్స్`,
          total: `మొత్తం కాల్స్`,
        },
        errorLoading: `ఫోన్ నంబర్ గణాంకాలు లోడ్ చేయడంలో లోపం`,
        noData: `ఫోన్ నంబర్ డేటా అందుబాటులో లేదు`,
        unknown: `తెలియనిది`,
      },
      invalidDateRange: `చెల్లని తేదీ పరిధి`,
      dateRangeTooLarge: `తేదీ పరిధి చాలా పెద్దది. దయచేసి 365 రోజులు లేదా అంతకంటే తక్కువ పరిధిని ఎంచుకోండి.`,
      dateRangeAdjustPrompt: `దయచేసి మీ తేదీ పరిధిని సర్దుబాటు చేసి మళ్లీ ప్రయత్నించండి.`,
    },

    voicemailLineChart: {
      rechartTitle: `{{groupByTitle}}కు వాయిస్‌మెయిల్స్`,
    },

    agentStatusFilters: {
      header: `ఏజెంట్ స్థితి`,
      availability: `లభ్యత`,
      status: `స్థితి`,
      items: {
        online: `ఆన్‌లైన్`,
        away: `దూరంగా`,
      },
    },

    agentStatusTable: {
      agent: `ఏజెంట్`,
      extension: `ఎక్స్‌టెన్షన్`,
      currentStatus: `ప్రస్తుత స్థితి`,
      timeInStatus: `స్థితిలో సమయం`,
      startedAt: `ప్రారంభమైనది`,
      actions: `చర్యలు`,
      status: {
        offline: `ఆఫ్‌లైన్`,
        inQueue: `క్యూలో ఉంది`,
      },
    },

    agentStatusActions: {
      tooltip: {
        changeStatus: `స్థితిని మార్చండి`,
      },
    },

    eventLog: {
      title: `ఈవెంట్ లాగ్`,
      filters: {
        allAgents: `అన్ని ఏజెంట్‌లు`,
        searchAgents: `ఏజెంట్‌లను శోధించండి`,
      },
    },

    eventLogTable: {
      when: `ఎప్పుడు`,
      who: `ఎవరు`,
      status: `స్థితి`,
      inQueue: `క్యూలో ఉంది`,
      changedBy: `ద్వారా మార్చబడింది`,
      yes: `అవును`,
      no: `కాదు`,
      system: `సిస్టమ్`,
      unknown: `తెలియదు`,
      failedToLoad: `మరిన్ని ఈవెంట్‌లను లోడ్ చేయడం విఫలమైంది.`,
      retry: `మళ్లీ ప్రయత్నించండి`,
      noRecords: `రికార్డులు కనుగొనబడలేదు.`,
      noRecordsHint: `మరిన్ని చూడటానికి మీ ఫిల్టర్‌లను సర్దుబాటు చేయండి లేదా క్లియర్ చేయండి.`,
    },

    callDetailsOverviewTab: {
      missed: `తప్పినవి`,
      answered: `సమాధానమిచ్చినవి`,
      textButton: `వాయిస్‌మెయిల్ రికార్డ్ చేయబడింది`,
    },

    callDetailData: {
      missed: `తప్పినవి`,
      answered: `సమాధానమిచ్చినవి`,
      inProgress: `ప్రోగ్రెస్‌లో ఉంది`,
      failed: `విఫలమైంది`,
      direction: {
        inbound: `ఇన్‌బౌండ్`,
        outbound: `అవుట్‌బౌండ్`,
        internal: `అంతర్గత`,
      },
    },

    callFilters: {
      buttonTitle: `ఫిల్టర్`,
      sections: {
        direction: `దిశ`,
        outcome: `ఫలితం`,
        sentiment: `భావన`,
        status: `స్థితి`,
        callTrait: `కాల్ లక్షణం`,
        duration: `వ్యవధి`,
        user: `వినియోగదారు`,
        aiAgent: `AI ఏజెంట్`,
      },
      direction: {
        inbound: `ఇన్‌బౌండ్`,
        outbound: `అవుట్‌బౌండ్`,
        internal: `అంతర్గత`,
      },
      outcome: {
        missed: `తప్పినవి`,
        answered: `సమాధానమిచ్చినవి`,
      },
      sentiment: {
        office: `ఆఫీస్`,
        patient: `రోగి`,
        negative: `నెగటివ్`,
        neutral: `న్యూట్రల్`,
        positive: `పాజిటివ్`,
      },
      status: {
        inProgress: `ప్రోగ్రెస్‌లో ఉంది`,
        completed: `పూర్తయింది`,
        failed: `విఫలమైంది`,
        canceled: `రద్దు చేయబడింది`,
        busy: `వ్యాప్తంగా ఉంది`,
      },
      callTrait: {
        voicemailRecorded: `వాయిస్‌మెయిల్ రికార్డ్ చేయబడింది`,
        externallyTransferred: `బాహ్యంగా బదిలీ చేయబడింది`,
      },
      duration: {
        longerThan: `కంటే ఎక్కువ`,
        shorterThan: `కంటే తక్కువ`,
        tenSeconds: `10 సెకన్లు`,
        oneMinute: `1 నిమిషం`,
        fiveMinutes: `5 నిమిషాలు`,
        tenMinutes: `10 నిమిషాలు`,
      },
      user: {
        unknown: `తెలియని వినియోగదారు`,
      },
      aiAgent: {
        unknown: `తెలియని AI ఏజెంట్`,
      },
    },

    rechartsBarChart: {
      tooltip: {
        modalView: `మోడల్ వీక్షణ`,
        answerRate: `సమాధాన రేటు:`,
        total: `మొత్తం:`,
      },
      noChartData: `చార్ట్ డేటా అందుబాటులో లేదు`,
      weekOf: `{{date}} వారం`,
    },

    dateDropdown: {
      today: `ఈరోజు`,
      yesterday: `నిన్న`,
      last7Days: `గత 7 రోజులు`,
      last14Days: `గత 14 రోజులు`,
      last30Days: `గత 30 రోజులు`,
      thisWeek: `ఈ వారం`,
      lastWeek: `గత వారం`,
      thisMonth: `ఈ నెల`,
      lastMonth: `గత నెల`,
      last60Days: `గత 60 రోజులు`,
      last90Days: `గత 90 రోజులు`,
      customRange: `కస్టమ్ పరిధి`,
    },

    dateTimeRange: {
      after: `తర్వాత: {{date}}`,
      before: `ముందు: {{date}}`,
      selectDateRange: `తేదీ పరిధిని ఎంచుకోండి`,
      buttonPlaceholder: `తేదీ పరిధిని ఎంచుకోండి`,
    },

    dateTimeRangeModal: {
      after: `తర్వాత `,
      before: `ముందు `,
      optional: `(ఐచ్ఛికం)`,
      selectDateRange: `తేదీ పరిధిని ఎంచుకోండి`,
      buttonPlaceholder: `తేదీ పరిధిని ఎంచుకోండి`,
      clearButton: `క్లియర్ చేయండి`,
      setDateRangeButton: `తేదీ పరిధిని సెట్ చేయండి`,
      monthLabel: `{{label}} నెల`,
      dayLabel: `{{label}} రోజు`,
      yearLabel: `{{label}} సంవత్సరం`,
      hourLabel: `{{label}} గంట`,
      minuteLabel: `{{label}} నిమిషం`,
      meridiemLabel: `{{label}} పూర్వాహ్నం/అపరాహ్నం`,
    },

    queueControlButton: {
      inQueue: `క్యూలో ఉంది`,
      outOfQueue: `క్యూలో నుండి`,
      doNotDisturb: `ద్వారా నుండి`,
      online: `ఆన్‌లైన్`,
      offline: `ఆఫ్‌లైన్`,
      joinQueue: `క్యూలో చేరండి`,
      leaveQueue: `క్యూలో నుండి`,
      goOffline: `ఆఫ్‌లైన్`,
    },

    queueStatusMenu: {
      online: `ఆన్‌లైన్`,
      away: `దూరంగా`,
      goOffline: `ఆఫ్‌లైన్`,
      joinQueue: `క్యూలో చేరండి`,
    },

    changelogModal: {
      whatsNewLabel: `కొత్తది ఏమిటి`,
      noResults: `మార్పుల లాగ్ అందుబాటులో లేదు`,
      doneButton: `పూర్తయింది`,
      loadingData: `మార్పుల లాగ్ను లోడ్ చేస్తోంది...`,
      latest: `(Latest)`,
      releasedLabel: `విడుదల చేయబడింది`,
    },

    queueToasts: {
      loggedInToQueue: `క్యూలో లాగిన్ అయ్యారు`,
      loggedOutOfQueue: `క్యూ నుండి లాగ్అవుట్ అయ్యారు`,
      agentStatusUpdated: `ఏజెంట్ స్థితి అప్‌డేట్ అయింది`,
      unableToUpdateStatus: `స్థితిని అప్‌డేట్ చేయడం సాధ్యం కాలేదు`,
      queueUpdateErrorMessage: `దయచేసి ఈ యూజర్/ఎక్స్‌టెన్షన్ అడ్మిన్ పోర్టల్‌లో కాల్ క్యూకు జోడించబడిందో లేదో నిర్ధారించుకోండి లేదా సపోర్ట్‌ను సంప్రదించండి.`,
      genericUpdateErrorMessage: `స్థితిని అప్‌డేట్ చేయడంలో సమస్య ఏర్పడింది. దయచేసి మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌ను సంప్రదించండి.`,
      ok: `సరే`,
    },

    regionSelector: {
      settingsTitle: `మ్యాంగో డేటా రీజియన్`,
      settingsDescription: `ఇది మ్యాంగో ఎకోసిస్టమ్‌లో మీ డేటా ఎక్కడ ఉంచబడుతుందో సూచిస్తుంది.`,
      selectRegion: `ప్రాంతాన్ని ఎంచుకోండి`,
      regionInfoTooltip: `మ్యాంగో డేటా రీజియన్‌ను సూచిస్తుంది, మీ స్థానాన్ని కాదు.`,
      regions: {
        unitedStates: `యునైటెడ్ స్టేట్స్`,
        unitedKingdom: `యునైటెడ్ కింగ్‌డమ్`,
      },
    },

    announcementBanner: {
      infoLabel: `సమాచార ప్రకటన: {{title}}`,
      warningLabel: `హెచ్చరిక ప్రకటన: {{title}}`,
      criticalLabel: `క్లిష్టమైన ప్రకటన: {{title}}`,
      dismiss: `ప్రకటనను తీసివేయండి`,
      collapse: `ప్రకటనను కుదించండి`,
      expand: `ప్రకటనను విస్తరించండి`,
    },
    bannerPager: {
      carousel: `బ్యానర్‌లు`,
      slide: `{{total}}లో బ్యానర్ {{current}}`,
      position: `{{current}}/{{total}}`,
      previous: `మునుపటి బ్యానర్`,
      next: `తదుపరి బ్యానర్`,
      carouselRole: `కారౌసెల్`,
      slideRole: `స్లయిడ్`,
    },

    appVersionBanner: {
      desktopUpdateAvailable: `{{appName}} యొక్క వెర్షన్ {{version}} అందుబాటులో ఉంది.`,
      webUpdateAvailable: `మ్యాంగో వెబ్ యాప్ యొక్క కొత్త వెర్షన్ అందుబాటులో ఉంది.`,
      restartAndUpdate: `రీస్టార్ట్ మరియు అప్డేట్`,
      updateNow: `ఇప్పుడు అప్డేట్ చేయండి`,
      whatsNew: `కొత్తది ఏమిటి`,
      remindLater: `తర్వాత గుర్తు చేయండి`,
      dismiss: `మూసివేయండి`,
    },

    clockSkewBanner: {
      message: `మీ పరికరపు గడియారం కొన్ని నిమిషాలకు మించి తప్పుగా ఉంది. దీనివల్ల కాల్‌లు, సందేశాలు మరియు ఇతర ఫీచర్‌లు ఊహించని విధంగా పని చేయవచ్చు. దయచేసి మీ సిస్టమ్ సెట్టింగ్‌లలో తేదీ & సమయం స్వయంచాలక సమకాలీకరణను ఆన్ చేయండి.`,
    },

    updateBlockedBanner: {
      message: `యాప్ అప్డేట్ను పూర్తి చేయలేకపోయింది. సాధారణంగా యాంటీవైరస్ లేదా సెక్యూరిటీ సాఫ్ట్‌వేర్ అప్డేట్ను నిరోధించడం వల్ల ఇది జరుగుతుంది. యాప్ అప్డేట్ అవ్వడానికి అనుమతించమని మీ IT ని అడగండి, లేదా తాజా వెర్షన్ను డౌన్‌లోడ్ చేయండి.`,
      downloadLatest: `తాజా వెర్షన్ను డౌన్‌లోడ్ చేయండి`,
    },

    updatePermissionBanner: {
      message: `యాప్ ఇన్‌స్టాల్ చేసిన విధానం కారణంగా ఈ కంప్యూటర్‌లో అప్డేట్‌లను ఇన్‌స్టాల్ చేయలేకపోతోంది. మా సహాయ కథనాన్ని అనుసరించండి, లేదా దాన్ని మీ IT బృందంతో పంచుకోండి.`,
      howToFix: `ఎలా పరిష్కరించాలి`,
      updateAnyway: `అయినా అప్‌డేట్ చేయండి`,
    },

    updateCheck: {
      checkForUpdates: `అప్డేట్లను తనిఖీ చేయండి`,
      restartAndUpdate: `పునఃప్రారంభించి అప్డేట్ చేయండి`,
      checking: `అప్డేట్లను తనిఖీ చేస్తోంది...`,
      upToDate: `అప్లికేషన్ తాజాగా ఉంది`,
      checkFailed: `అప్డేట్ తనిఖీ విఫలమైంది`,
      versionAvailable: `వెర్షన్ {{version}} అందుబాటులో ఉంది`,
      downloading: `డౌన్లోడ్ చేస్తోంది... {{percent}}%`,
      downloaded: `వెర్షన్ {{version}} డౌన్లోడ్ అయింది`,
      errorOccurred: `అప్డేట్ తనిఖీ చేయడంలో లోపం సంభవించింది।`,
    },
    updateRequirement: {
      recommendedMessage: `{{appName}} యొక్క కొత్త వెర్షన్ అందుబాటులో ఉంది. తాజా పరిష్కారాలను పొందడానికి అప్‌డేట్ చేయండి.`,
      recommendedMessageWithDate: `ఉపయోగించడం కొనసాగించడానికి {{date}} లోపు {{appName}}ని అప్‌డేట్ చేయండి.`,
      requiredDuringCall: `{{appName}} యొక్క ఈ వెర్షన్‌కు ఇకపై మద్దతు లేదు. మీ కాల్ ముగిసిన తర్వాత, కొనసాగించడానికి మీరు అప్‌డేట్ చేయాలి.`,
      update: `అప్‌డేట్ చేయండి`,
      later: `తర్వాత`,
      downloading: `డౌన్‌లోడ్ అవుతోంది {{percent}}%`,
      restartToUpdate: `అప్‌డేట్ చేయడానికి పునఃప్రారంభించండి`,
      downloadInstaller: `ఇన్‌స్టాలర్‌ను డౌన్‌లోడ్ చేయండి`,
      requiredTitle: `అప్‌డేట్ అవసరం`,
      requiredMessage: `{{appName}} యొక్క ఈ వెర్షన్ ({{currentVersion}})కు ఇకపై మద్దతు లేదు. యాప్‌ను ఉపయోగించడం కొనసాగించడానికి అప్‌డేట్ చేయండి.`,
      callsNotice: `మీరు అప్‌డేట్ చేసే వరకు, ఈ యాప్ కాల్‌లను స్వీకరించదు. కాల్‌లు మీ ఇతర పరికరాలు, రింగ్ గ్రూప్‌లు లేదా వాయిస్‌మెయిల్‌కు వెళ్తాయి.`,
      preparing: `అప్‌డేట్ సిద్ధమవుతోంది...`,
      downloadingProgress: `అప్‌డేట్ డౌన్‌లోడ్ అవుతోంది: {{percent}}%`,
      progressLabel: `అప్‌డేట్ డౌన్‌లోడ్ పురోగతి`,
      manualInstallMessage: `యాప్ అప్‌డేట్‌ను స్వయంచాలకంగా ఇన్‌స్టాల్ చేయలేదు. తాజా వెర్షన్‌ను డౌన్‌లోడ్ చేసి ఇన్‌స్టాల్ చేయండి.`,
      useWebApp: `వెబ్ యాప్‌ను ఉపయోగించండి`,
      contactSupport: `సపోర్ట్‌ను సంప్రదించండి`,
      alertTitle: `{{appName}}ని అప్‌డేట్ చేయాలి`,
      alertBody: `మీరు అప్‌డేట్ చేసే వరకు కాల్‌లు ఇతర పరికరాలకు లేదా వాయిస్‌మెయిల్‌కు వెళ్తాయి.`,
      copyDownloadLink: `డౌన్‌లోడ్ లింక్‌ను కాపీ చేయండి`,
      linkCopied: `లింక్ కాపీ చేయబడింది`,
    },

    callDetails: {
      title: `కాల్ వివరాలు`,
      callTimeline: `కాల్ టైమ్‌లైన్`,
      callFlow: `కాల్ ఫ్లో`,
      started: `ప్రారంభమైంది`,
      ended: `ముగిసింది`,
      answerTime: `సమాధానం సమయం`,
      callDuration: `కాల్ వ్యవధి`,
      callOn: `కాల్ తేదీ`,
      statisticsNotAvailable: `గణాంకాలు అందుబాటులో లేవు`,
      transcriptNotAvailable: `ట్రాన్స్‌క్రిప్ట్ అందుబాటులో లేదు`,
      noRecordingAvailable: `రికార్డింగ్ అందుబాటులో లేదు`,
      callSummary: `కాల్ సారాంశం`,
      callStatistics: `కాల్ గణాంకాలు`,
      header: {
        copyLinkToCall: `కాల్ లింక్‌ను కాపీ చేయండి`,
        copyLinkToCallAtTimestamp: `టైమ్‌స్టాంప్ వద్ద కాల్ లింక్‌ను కాపీ చేయండి`,
        downloadAudio: `ఆడియోను డౌన్‌లోడ్ చేయండి`,
        closePanel: `ప్యానెల్‌ను మూసివేయండి`,
        expand: `విస్తరించండి`,
        moreActions: `మరిన్ని చర్యలు`,
      },
      sections: {
        sentimentByQuarter: {
          title: `క్వార్టర్ వారీగా సెంటిమెంట్`,
          tooltip: `ఇది రోగి మరియు కార్యాలయ సెంటిమెంట్‌ను చూపిస్తుంది, సంభాషణ యొక్క భావోద్వేగ స్వరాన్ని ప్రతిబింబిస్తుంది. ప్రతి క్వార్టర్ సానుకూల (ఆకుపచ్చ), తటస్థ (బూడిద) లేదా ప్రతికూల (ఎరుపు) గా వర్గీకరించబడింది.`,
          agentOverall: `ఎజెంట్: {{score}} మొత్తం`,
          customerOverall: `కస్టమర్: {{score}} మొత్తం`,
          patient: `రోగి`,
          office: `కార్యాలయం`,
        },
        officeTalkTime: {
          title: `కార్యాలయ మాట్లాడే సమయం`,
          tooltip: `ఈ పై చార్ట్ కాల్ సమయంలో కార్యాలయం మాట్లాడటం వర్సెస్ వినడంపై గడిపిన సమయం యొక్క విశ్లేషణను చూపిస్తుంది. ఆదర్శంగా, ఎజెంట్‌లు మాట్లాడటం కంటే ఎక్కువ సమయం వినడంపై గడపాలి, ప్రభావవంతమైన కస్టమర్ ఇంటరాక్షన్ కోసం 50-60% మాట్లాడటం మరియు 40-50% వినడం విభజనను లక్ష్యంగా పెట్టుకోవాలి.`,
          talking: `మాట్లాడటం`,
          listening: `వినడం`,
        },
        officeTalkSpeed: {
          title: `కార్యాలయ మాట్లాడే వేగం`,
          tooltip: `ఇది నిమిషానికి పదాల (wpm)లో కార్యాలయం యొక్క మొత్తం మాట్లాడే వేగాన్ని చూపిస్తుంది. సాధారణ పరిధి 120-150 wpm, ఇది స్పష్టమైనది మరియు అర్థం చేసుకోవడం సులభం. 100 wpm కంటే తక్కువ వేగాలు చాలా నెమ్మదిగా అనిపించవచ్చు, అయితే 160 wpm కంటే ఎక్కువ వేగాలు రోగులకు అనుసరించడం కష్టంగా ఉండవచ్చు.`,
          wordsPerMinute: `నిమిషానికి పదాలు`,
        },
        interruptions: {
          title: `అంతరాయాలు`,
          tooltip: `ఇది రోగి మరియు కార్యాలయం ఒకరినొకరు ఎన్నిసార్లు అంతరాయం కలిగించారో చూపిస్తుంది. సంభాషణ ఎంత సజావుగా సాగిందో అంచనా వేయడానికి ఇది ఉపయోగపడుతుంది.`,
          total: `మొత్తం`,
          patient: `రోగి`,
          office: `కార్యాలయం`,
        },
        holdAndPauseTime: {
          title: `హోల్డ్ సమయం & పాజ్‌లు`,
          tooltip: `ఇది కాలర్ హోల్డ్‌లో లేదా నిశ్శబ్దంలో ఎంత సమయం గడిపాడో మరియు మొత్తం కాల్‌లో శాతాన్ని చూపిస్తుంది. సాధారణం కంటే ఎక్కువ ఎదురుచూపు సమయాలు ఎరుపు రంగులో హైలైట్ చేయబడతాయి.`,
          percentageOfCall: `కాల్‌లో {{percentage}}%`,
        },
      },
      toast: {
        linkCopied: `లింక్ క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది`,
        linkCopyFailed: `క్లిప్‌బోర్డ్‌కు లింక్ కాపీ చేయడం విఫలమైంది.`,
        voicemailTranscriptCopied: `వాయిస్‌మెయిల్ ట్రాన్స్‌క్రిప్ట్ క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది.`,
        voicemailTranscriptCopyFailed: `వాయిస్‌మెయిల్ ట్రాన్స్‌క్రిప్ట్‌ను కాపీ చేయడం సాధ్యం కాలేదు.`,
        noVoicemailTranscript: `కాపీ చేయడానికి వాయిస్‌మెయిల్ ట్రాన్స్‌క్రిప్ట్ లేదు.`,
        voicemailTranscriptCopyError: `వాయిస్‌మెయిల్ ట్రాన్స్‌క్రిప్ట్‌ను కాపీ చేయడం సాధ్యం కాలేదు. దయచేసి మళ్ళీ ప్రయత్నించండి.`,
        summaryCopied: `సారాంశం క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది.`,
        summaryCopyFailed: `సారాంశాన్ని కాపీ చేయడం సాధ్యం కాలేదు. దయచేసి మళ్ళీ ప్రయత్నించండి.`,
        noSummary: `కాపీ చేయడానికి సారాంశం లేదు.`,
        feedbackThanks: `మీ అభిప్రాయానికి ధన్యవాదాలు!`,
        feedbackThumbsUpFailed: `థంబ్స్ అప్ చర్య నివేదించడం విఫలమైంది.`,
        feedbackThumbsDownFailed: `థంబ్స్ డౌన్ చర్య నివేదించడం విఫలమైంది.`,
      },
      voicemail: {
        title: `వాయిస్‌మెయిల్`,
        loading: `వాయిస్‌మెయిల్ ట్రాన్స్‌క్రిప్ట్ లోడ్ అవుతోంది...`,
        accessDenied: `ఈ వాయిస్‌మెయిల్ మీకు ప్రాప్యత లేని ఇన్‌బాక్స్‌లో ఉంచబడింది. మీ సిస్టమ్ అడ్మినిస్ట్రేటర్‌ను సంప్రదించండి.`,
        deleted: `వాయిస్‌మెయిల్ తొలగించబడింది.`,
        notAvailable: `వాయిస్‌మెయిల్ అందుబాటులో లేదు.`,
        transcriptionNotAvailable: `వాయిస్‌మెయిల్ ట్రాన్స్‌క్రిప్షన్ అందుబాటులో లేదు.`,
      },
      summary: {
        title: `సారాంశం`,
        processing: `కాల్ ట్రాన్స్‌క్రిప్షన్ ప్రాసెసింగ్ అవుతోంది...`,
        notFound: `సారాంశం కనుగొనబడలేదు`,
        notAvailable: `ట్రాన్స్‌క్రిప్ట్ సారాంశం అందుబాటులో లేదు.`,
      },
      margoSummary: {
        title: `మార్గో సారాంశం`,
        copy: `మార్గో సారాంశాన్ని కాపీ చేయండి`,
        copied: `మార్గో సారాంశం కాపీ చేయబడింది`,
        copySuccess: `మార్గో సారాంశం క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది.`,
        copyFailure: `మార్గో సారాంశాన్ని కాపీ చేయడం సాధ్యం కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.`,
      },
      tabs: {
        overview: `అవలోకనం`,
        transcripts: `ట్రాన్స్‌క్రిప్ట్‌లు`,
        stats: `గణాంకాలు`,
      },
      sentiment: {
        title: `సెంటిమెంట్`,
        patient: `రోగి`,
        office: `కార్యాలయం`,
        positive: `పాజిటివ్`,
        negative: `నెగటివ్`,
        neutral: `న్యూట్రల్`,
      },
      tooltip: {
        copyToClipboard: `క్లిప్‌బోర్డ్‌కు కాపీ చేయండి`,
        goToVoicemail: `వాయిస్‌మెయిల్‌కు వెళ్ళండి`,
        accurate: `ఖచ్చితమైనది`,
        inaccurate: `ఖచ్చితమైనది కాదు`,
        copyLinkToSearch: `శోధనకు లింక్ కాపీ చేయండి`,
        fullscreen: `పూర్తి స్క్రీన్`,
      },
    },

    calls: {
      searchLabel: `కాల్‌లను వెతకండి`,
      export: {
        button: `CSV ఎగుమతి`,
        starting: `ప్రారంభమవుతోంది...`,
        preparing: `ఎగుమతి సిద్ధం చేస్తోంది...`,
        processing: `ఎగుమతి చేస్తోంది...`,
        completed: `ఎగుమతి చేయబడింది`,
        success: `CSV డౌన్‌లోడ్ ప్రారంభమైంది`,
        successTruncated: `ఎగుమతి పూర్తయింది (ఫలితాలు 10 లక్షల అడ్డు వరుసలకు పరిమితం)`,
        error: `ఎగుమతి విఫలమైంది`,
        errorTooMany: `చాలా ఎగుమతులు నడుస్తున్నాయి. దయచేసి వేచి ఉండి మళ్ళీ ప్రయత్నించండి.`,
        errorInvalid: `చెల్లని ఎగుమతి పారామీటర్లు.`,
        errorNotFound: `ఎగుమతి జాబ్ కనుగొనబడలేదు. సర్వర్ రీస్టార్ట్ అయి ఉండవచ్చు. దయచేసి మళ్ళీ ప్రయత్నించండి.`,
        errorGeneric: `ఎగుమతిని ప్రారంభించడం విఫలమైంది.`,
        errorStatusCheck: `ఎగుమతి స్థితిని తనిఖీ చేయడం విఫలమైంది.`,
        toastProcessingTitle: `ఎగుమతి ప్రగతిలో ఉంది`,
        toastProcessingDescription: `మీ CSV సిద్ధం చేయబడుతోంది. డౌన్‌లోడ్ స్వయంచాలకంగా ప్రారంభమవుతుంది.`,
        unsupportedFiltersHeader: `CSV ఎగుమతి ఈ ఫిల్టర్‌లకు మద్దతు ఇవ్వదు:`,
        filterSearch: `శోధన`,
      },
      transcriptCell: {
        noTranscriptAvailable: `No transcript available.`,
        inProgress: `Transcript is currently being generated, please check back later.`,
        audioTooLong: `Transcript unavailable: the call audio was too long.`,
        viewTranscript: `ట్రాన్‌స్క్రిప్ట్ చూడండి`,
        noTranscript: `ట్రాన్‌స్క్రిప్ట్ ఏదీ అందుబాటులో లేదు`,
        transcriptInProgress: `ట్రాన్‌స్క్రిప్ట్ రూపొందించబడుతోంది`,
        transcriptUnavailable: `ట్రాన్‌స్క్రిప్ట్ అందుబాటులో లేదు`,
        openVoicemail: `వాయిస్‌మెయిల్ తెరవండి`,
      },
      detail: {
        notFound: `Oops this record has either been deleted or does not exist. If you need help, please contact support.`,
        unknownNumber: `Unknown Number`,
        unknownSource: `Unknown`,
      },
    },

    missedCalls: {
      emptyState: `తప్పిన కాల్స్ లేవు`,
      emptyStateSubtitle: `అన్ని కాల్స్ లకు సమాధానం ఇవ్వబడింది`,
      description: `తప్పిన కాల్స్ లను ట్రాక్ చేయండి మరియు నిర్వహించండి`,
      instructions: `నిర్దిష్ట తప్పిన కాల్స్ లను కనుగొనడానికి ఫిల్టర్ లు మరియు తేదీ పరిధులను ఉపయోగించండి`,
      errorLoadingMissedCalls: `తప్పిన కాల్స్ లోడ్ చేయడంలో లోపం`,
      pleaseTryAgainLater: `దయచేసి తర్వాత మళ్ళీ ప్రయత్నించండి`,
      countLabel: `{{count}} తప్పిన కాల్స్`,
      refresh: `రిఫ్రెష్ చేయండి`,
      followUpStatus: {
        open: `తెరవండి`,
        returnedCallBack: `తిరిగి వచ్చింది - కాల్ బ్యాక్`,
        returnedSMS: `తిరిగి వచ్చింది - SMS`,
        returnedVoicemail: `తిరిగి వచ్చింది - వాయిస్‌మెయిల్`,
        returnedEmail: `తిరిగి వచ్చింది - ఇమెయిల్`,
        returnedNoAnswer: `తిరిగి వచ్చింది - సమాధానం లేదు`,
        noFollowUpRequired: `ఫాలో అప్ అవసరం లేదు`,
        assignUserFirst: `మొదట వినియోగదారుని కేటాయించండి`,
      },
      filters: {
        sections: {
          type: `Type`,
          status: `Status`,
          user: `User`,
          phoneNumber: `Phone number`,
        },
        type: {
          voicemail: `Voicemail`,
          abandoned: `Abandoned`,
        },
        userFallback: `User {{id}}`,
      },
      assignedUser: {
        loading: `Loading...`,
        loadingShort: `Loading`,
        unassigned: `Unassigned`,
        userFallback: `User {{id}}`,
      },
      type: {
        voicemailAlt: `Voicemail`,
        abandonedAlt: `Abandoned`,
        abandonedTitle: `Abandoned`,
        abandonedDescription: `The call was not answered, and the customer did not leave a voicemail`,
      },
    },

    callsList: {
      noCallsFound: `కాల్స్ కనుగొనబడలేదు`,
      tryDifferentFilters: `వేరే ఫిల్టర్లను ప్రయత్నించండి`,
    },

    callsTable: {
      label: `కాల్స్`,
      openCallDetails: `కాల్ వివరాలను చూడండి, {{time}} {{date}}`,
      columns: {
        dateTime: `తేదీ & సమయం`,
        outcome: `ఫలితం`,
        to: `కు`,
        from: `నుండి`,
        toFrom: `కు/నుండి`,
        duration: `వ్యవధి`,
        transcript: `ట్రాన్స్‌క్రిప్ట్`,
      },
    },

    missedCallsTable: {
      columns: {
        dateTime: `తేదీ & సమయం`,
        from: `నుండి`,
        to: `కు`,
        type: `రకం`,
        followUpTime: `ఫాలో అప్ సమయం`,
        followUpStatus: `ఫాలో అప్ స్థితి`,
        assignedTo: `కేటాయించబడింది`,
        action: `చర్య`,
      },
    },

    contactInfoCard: {
      callTarget: {
        from: `నుండి`,
        to: `కు`,
      },
      tooltip: {
        call: `కాల్`,
        message: `సందేశం`,
        sendFax: `ఫ్యాక్స్ పంపండి`,
        blockNumber: `నంబర్‌ను నిరోధించు`,
        unblockNumber: `నంబర్‌ను అన్‌బ్లాక్ చేయి`,
      },
    },

    contactCell: {
      menu: {
        callNumber: `నంబర్‌కు కాల్ చేయి`,
        copyNumber: `నంబర్‌ను కాపీ చేయి`,
        messageNumber: `నంబర్‌కు సందేశం`,
        sendFax: `ఫ్యాక్స్ పంపండి`,
        blockNumber: `నంబర్‌ను నిరోధించు`,
        unblockNumber: `నంబర్‌ను అన్‌బ్లాక్ చేయి`,
        moreOptions: `మరిన్ని ఎంపికలు`,
        moreOptionsFor: `{{name}} కోసం మరిన్ని ఎంపికలు, {{time}} {{date}}`,
      },
    },

    reportingFilters: {
      dateRange: `తేదీ పరిధి`,
      number: `నంబర్`,
      maxPhoneNumbers: `(గరిష్టం {{max}})`,
    },

    numberComparisonFilters: {
      numberComparison: `సంఖ్య పోల్చిక`,
      subtitle: `ఫోన్ నంబర్‌లలో ఇన్‌బౌండ్ కాల్ వాల్యూమ్‌ను పోల్చండి`,
      dateRange: `తేదీ పరిధి`,
      number: `నంబర్`,
      maxPhoneNumbers: `(గరిష్టం {{max}})`,
    },

    numberComparisonTable: {
      columns: {
        name: `ఫోన్ నంబర్ పేరు`,
        number: `ఫోన్ నంబర్`,
        inboundCalls: `ఇన్‌బౌండ్ కాల్స్`,
        avgDuration: `సగటు వ్యవధి`,
      },
    },

    numberComparisonChart: {
      inboundCalls: `ఇన్‌బౌండ్ కాల్స్`,
      avgDuration: `సగటు వ్యవధి`,
    },

    extensionComparison: {
      retired: `రిటైర్డ్`,
    },

    extensionComparisonDashboard: {
      invalidDateRange: `చెల్లని తేదీ పరిధి`,
      dateRangeTooLarge: `తేదీ పరిధి చాలా పెద్దది. దయచేసి 365 రోజులు లేదా అంతకంటే తక్కువ పరిధిని ఎంచుకోండి.`,
      dateRangeAdjustPrompt: `దయచేసి మీ తేదీ పరిధిని సర్దుబాటు చేసి మళ్లీ ప్రయత్నించండి.`,
      chartTitle: `ఎక్స్‌టెన్షన్ వారీగా కాల్ వాల్యూమ్`,
      showingCount: `{{total}}లో {{displayed}} చూపుతోంది`,
      notAvailable: `అందుబాటులో లేదు`,
      counters: {
        totalCalls: {
          title: `మొత్తం కాల్స్`,
          subtitle: `అన్ని ఎక్స్‌టెన్షన్లలో మొత్తం కాల్స్`,
        },
        averageCalls: {
          title: `ఎక్స్‌టెన్షన్‌కు సగటు`,
          subtitle: `ఎక్స్‌టెన్షన్‌కు సగటు కాల్స్`,
        },
        averageMinutes: {
          title: `ఎక్స్‌టెన్షన్‌కు సగటు నిమిషాలు`,
          subtitle: `ఎక్స్‌టెన్షన్‌కు సగటు నిమిషాలు`,
        },
        topExtension: {
          title: `టాప్ పెర్ఫార్మర్`,
        },
      },
      dashboard: {
        errorText: `ఎక్స్‌టెన్షన్ డేటాను లోడ్ చేయడంలో లోపం`,
        noDataText: `ఎక్స్‌టెన్షన్ డేటా అందుబాటులో లేదు`,
      },
    },

    extensionComparisonFilters: {
      title: `ఎక్స్‌టెన్షన్ పోలిక`,
      subtitle: `ఎక్స్‌టెన్షన్లలో కాల్ వాల్యూమ్ పోల్చండి`,
      directionLabel: `దిశ`,
      extensionsLabel: `ఎక్స్‌టెన్షన్లు`,
      direction: {
        all: `ఇన్‌బౌండ్ & అవుట్‌బౌండ్`,
        inbound: `ఇన్‌బౌండ్`,
        outbound: `అవుట్‌బౌండ్`,
      },
    },

    extensionComparisonChart: {
      extensionLabel: `ఎక్స్‌టెన్షన్ {{ext}}`,
      totalCalls: `మొత్తం కాల్స్`,
      totalMinutes: `మొత్తం నిమిషాలు`,
      avgDuration: `సగటు వ్యవధి`,
      showMore: `మరిన్ని చూపించు ({{remaining}} మిగిలి ఉన్నాయి)`,
      totalCallsTitle: `మొత్తం కాల్స్`,
      totalMinutesTitle: `మొత్తం నిమిషాలు`,
    },

    extensionComparisonTable: {
      columns: {
        extension: `ఎక్స్‌టెన్షన్`,
        calls: `కాల్స్`,
        percentCalls: `% మొత్తం`,
        minutes: `నిమిషాలు`,
        percentMinutes: `% మొత్తం`,
      },
    },

    extensionMultiDropdown: {
      allExtensions: `అన్ని ఎక్స్‌టెన్షన్లు`,
    },

    extensionPills: {
      extensionsSelected: `{{count}} ఎక్స్‌టెన్షన్లు ఎంచుకోబడ్డాయి`,
    },

    dashboards: {
      noDataAvailable: `డేటా అందుబాటులో లేదు`,
      gettingPbx: `PBX పొందుతోంది...`,
      noStatisticsAvailable: `గణాంకాలు అందుబాటులో లేవు`,
      noGridData: `గ్రిడ్ డేటా లేదు`,
      errorLoadingStatistics: `గణాంకాలు లోడ్ చేయడంలో లోపం`,
      errorLoadingCallData: `కాల్ డేటా లోడ్ చేయడంలో లోపం`,
      noCallDataAvailable: `కాల్ డేటా అందుబాటులో లేదు`,
      errorLoadingVoicemailData: `వాయిస్‌మెయిల్ డేటా లోడ్ చేయడంలో లోపం`,
      noVoicemailDataAvailable: `వాయిస్‌మెయిల్ డేటా అందుబాటులో లేదు`,
      csvExport: {
        buttonLabel: `CSV ఎగుమతి`,
        exported: `ఎగుమతి చేయబడింది`,
        success: `CSV ఎగుమతి చేయబడింది`,
        failed: `CSV ఎగుమతి విఫలమైంది`,
        headers: {
          inboundAnswerRate: {
            startDateTime: `ప్రారంభ తేదీ/సమయం`,
            endDateTime: `ముగింపు తేదీ/సమయం`,
            answeredCalls: `సమాధానమిచ్చిన కాల్స్`,
            missedCalls: `తప్పిన కాల్స్`,
            totalCalls: `మొత్తం కాల్స్`,
            answerRatePercent: `సమాధాన రేటు %`,
          },
          numberComparison: {
            phoneNumber: `ఫోన్ నంబర్`,
            displayNumber: `ప్రదర్శన నంబర్`,
            name: `పేరు`,
            inboundCalls: `ఇన్‌బౌండ్ కాల్స్`,
            totalDurationSeconds: `మొత్తం వ్యవధి (సెకన్లు)`,
            averageDurationSeconds: `సగటు వ్యవధి (సెకన్లు)`,
          },
          extensionComparison: {
            extension: `ఎక్స్‌టెన్షన్`,
            totalCalls: `మొత్తం కాల్స్`,
            totalMinutes: `మొత్తం నిమిషాలు`,
            totalDurationSeconds: `మొత్తం వ్యవధి (సెకన్లు)`,
            averageDurationSeconds: `సగటు వ్యవధి (సెకన్లు)`,
          },
        },
      },
      unknown: `తెలియనిది`,
      notAvailable: `అందుబాటులో లేదు`,
    },

    aria: {
      backspace: `బ్యాక్‌స్పేస్`,
      toggleColorMode: `కలర్ మోడ్ మార్చండి`,
    },

    callAnalytics: {
      empty: {
        noTranscriptRecord: `Uh oh - there doesn't seem to be a transcript record for this call.`,
        noCallSelected: `No Call Selected`,
      },
      stats: {
        agentTalkTime: `Agent Talk Time`,
        talking: `Talking: {{duration}} ({{percent}}%)`,
        listening: `Listening: {{duration}} ({{percent}}%)`,
        agentTalkSpeed: `Agent Talk Speed`,
        wordsPerMinute: `{{count}} Words Per Minute (averaged)`,
        holdTimeAndPauses: `Hold Time and Pauses`,
        holdPercentOfCall: `{{duration}} ({{percent}}% of call)`,
        interruptionsTotal: `Interruptions: {{count}} total`,
        interruptionsAgent: `Agent: {{count}} ({{percent}}%)`,
        interruptionsCustomer: `Customer: {{count}} ({{percent}}%)`,
      },
      transcript: {
        office: `Office`,
        patient: `Patient`,
        silence: `Silence {{duration}}`,
      },
    },

    filterModal: {
      header: `ఫిల్టర్‌లు`,
      apply: `ఫిల్టర్‌లను వర్తింపజేయండి`,
      clear: `క్లియర్ చేయండి`,
      clearSection: `{{title}} క్లియర్ చేయండి`,
      buttonTitle: `ఫిల్టర్‌లు`,
      tooltipOneApplied: `{{title}} ({{count}} ఫిల్టర్ వర్తింపజేయబడింది)`,
      tooltipManyApplied: `{{title}} ({{count}} ఫిల్టర్‌లు వర్తింపజేయబడ్డాయి)`,
    },

    previewModal: {
      rotate: `Rotate`,
      imagePreview: `చిత్రం ప్రివ్యూ`,
    },

    pdfViewer: {
      loadError: `Unable to load this file`,
    },

    mangoPlusAds: {
      stayRelevant: `Stay relevant`,
      inTodaysWorld: `in today's world`,
      bodyHeading: `Who doesn't like texting?`,
      paragraph1: `In today's world, people love texting over phone calls. Choose to text your customers-save time and energy!`,
      paragraph2: `Texting is just one of the many Mango Plus perks. Talk to our Sales Team about a month trial before you buy.`,
      learnMore: `Learn More`,
    },

    outboundPhoneSearch: {
      placeholder: `Select Number`,
    },

    faxFilters: {
      directionTooltip: `Direction Filter`,
      allFaxes: `All Faxes`,
    },

    messagingThread: {
      dropFileToSend: `Drop file to send`,
    },

    resetPassword: {
      togglePasswordVisibility: `Toggle password visibility`,
    },

    resourceErrorBoundary: {
      defaultMessage: `An unexpected error occurred.`,
      notFoundFallback: `Oops this record has either been deleted or does not exist. If you need help, please contact support.`,
      takeMeBack: `Take me back`,
    },

    moveFaxModal: {
      toast: {
        errorMoving: `An error occurred while moving the fax.`,
        notMarkedUnread: `Fax was not marked as unread.`,
        moveFailed: `Failed to move the fax to the selected virtual fax.`,
        errorTitle: `Error Moving Fax`,
      },
      noAccessWarning: `If you don't have access to the selected Virtual Fax you won't be able to view this fax once it's been moved.`,
    },

    filePrinter: {
      printFailed: `Failed to print file.`,
    },

    router: {
      loadingContent: `Loading content...`,
    },

    resourceFailedToLoad: {
      permission: `You don't have permission to access this voicemail box`,
      deleted: `Voicemail deleted`,
      unavailable: `Voicemail unavailable`,
      contactAdmin: `To get access, contact your system administrator`,
    },

    tagInput: {
      commaSeparated: `Multiple values must be comma separated`,
      removeTag: `{{value}}ని తీసివేయండి`,
      valueNotAdded: `ఈ విలువను జోడించడం సాధ్యం కాలేదు`,
      valuesNotAdded: `ఈ విలువలను జోడించడం సాధ్యం కాలేదు`,
      invalidValue: `ఈ విలువ చెల్లుబాటు అయ్యే {{valueType}} కాదు`,
      invalidValues: `ఈ విలువలు చెల్లుబాటు అయ్యే {{valueType}} కావు`,
      limitReached: `గరిష్ఠంగా {{maxTags}} చేరుకున్నారు. మరొకటి జోడించడానికి ఒకదాన్ని తీసివేయండి.`,
      errorAndLimit: `{{error}}. {{limit}}`,
    },

    unsavedChangesDialog: {
      title: `Unsaved changes`,
      body: `You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost.`,
      stay: `Stay on page`,
      discard: `Discard changes`,
    },

    blockedNumber: {
      blockNumbers: `Block Numbers`,
    },

    notificationsBanner: {
      grantedPrefix: `Fantastic, notification preferences can be adjusted in`,
      settings: `settings`,
      prompt: `Mango works best with notifications to keep you up to date.`,
      enable: `Enable Notifications!`,
    },

    switchboardEdit: {
      invalidDialPlan: `Invalid extension dial plan`,
      invalidPbxId: `Invalid PBX ID`,
      loading: `Loading switchboard...`,
    },

    webPhoneExtras: {
      activeCall: `Active Call`,
      failedSearch: `Failed Search`,
      otherLabel: `other`,
      awayWithLabel: `Away - {{label}}`,
    },

    callDetailsExtras: {
      callInProgress: `Call in progress`,
      mayTakeMinutes: `This may take several minutes`,
    },

    contactCombinedCell: {
      fromPrefix: `F:`,
      toPrefix: `T:`,
    },

    messaging:
      messagingTeIn as unknown as (typeof en)['translation']['messaging'],
    phoneNumbers:
      phoneNumbersTeIn as unknown as (typeof en)['translation']['phoneNumbers'],
    pbxLocations:
      pbxLocationsTeIn as unknown as (typeof en)['translation']['pbxLocations'],
    musicOnHold:
      musicOnHoldTeIn as unknown as (typeof en)['translation']['musicOnHold'],
    hotels: hotelsTeIn as unknown as (typeof en)['translation']['hotels'],
    soundClips:
      soundClipsTeIn as unknown as (typeof en)['translation']['soundClips'],
    ...systemSettingsTeIn,
    pbxSettings:
      pbxSettingsTeIn as unknown as (typeof en)['translation']['pbxSettings'],
    devices: devicesTeIn as unknown as (typeof en)['translation']['devices'],
    extensions:
      extensionsTeIn as unknown as (typeof en)['translation']['extensions'],
    userGroups:
      userGroupsTeIn as unknown as (typeof en)['translation']['userGroups'],
    webhooks: webhooksTeIn as unknown as (typeof en)['translation']['webhooks'],
  },
  support_phone_label: `మద్దతు హాట్‌లైన్: {{phoneNumber, phone}}`,
  user_profile_phone: `మీ రిజిస్టర్డ్ ఫోన్ నంబర్: {{userPhone, phone}}`,
} satisfies typeof en
